//Do not edit this file
/*! For license information please see globo_swatch.js.LICENSE.txt */ ! function(t) {
    var e = {};

    function n(r) {
        if (e[r]) return e[r].exports;
        var o = e[r] = {
            i: r,
            l: !1,
            exports: {}
        };
        return t[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports
    }
    n.m = t, n.c = e, n.d = function(t, e, r) {
        n.o(t, e) || Object.defineProperty(t, e, {
            enumerable: !0,
            get: r
        })
    }, n.r = function(t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(t, "__esModule", {
            value: !0
        })
    }, n.t = function(t, e) {
        if (1 & e && (t = n(t)), 8 & e) return t;
        if (4 & e && "object" == typeof t && t && t.__esModule) return t;
        var r = Object.create(null);
        if (n.r(r), Object.defineProperty(r, "default", {
                enumerable: !0,
                value: t
            }), 2 & e && "string" != typeof t)
            for (var o in t) n.d(r, o, function(e) {
                return t[e]
            }.bind(null, o));
        return r
    }, n.n = function(t) {
        var e = t && t.__esModule ? function() {
            return t.default
        } : function() {
            return t
        };
        return n.d(e, "a", e), e
    }, n.o = function(t, e) {
        return Object.prototype.hasOwnProperty.call(t, e)
    }, n.p = "/", n(n.s = 167)
}({
    1: function(t, e, n) {
        var r, o, i;
        o = "undefined" != typeof window ? window : this, i = function(n, o) {
            var i = [],
                a = n.document,
                s = i.slice,
                u = i.concat,
                l = i.push,
                c = i.indexOf,
                d = {},
                p = d.toString,
                _ = d.hasOwnProperty,
                f = {},
                h = function(t, e) {
                    return new h.fn.init(t, e)
                },
                g = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
                m = /^-ms-/,
                y = /-([\da-z])/gi,
                E = function(t, e) {
                    return e.toUpperCase()
                };

            function v(t) {
                var e = !!t && "length" in t && t.length,
                    n = h.type(t);
                return "function" !== n && !h.isWindow(t) && ("array" === n || 0 === e || "number" == typeof e && e > 0 && e - 1 in t)
            }
            h.fn = h.prototype = {
                jquery: "2.2.4",
                constructor: h,
                selector: "",
                length: 0,
                toArray: function() {
                    return s.call(this)
                },
                get: function(t) {
                    return null != t ? t < 0 ? this[t + this.length] : this[t] : s.call(this)
                },
                pushStack: function(t) {
                    var e = h.merge(this.constructor(), t);
                    return e.prevObject = this, e.context = this.context, e
                },
                each: function(t) {
                    return h.each(this, t)
                },
                map: function(t) {
                    return this.pushStack(h.map(this, (function(e, n) {
                        return t.call(e, n, e)
                    })))
                },
                slice: function() {
                    return this.pushStack(s.apply(this, arguments))
                },
                first: function() {
                    return this.eq(0)
                },
                last: function() {
                    return this.eq(-1)
                },
                eq: function(t) {
                    var e = this.length,
                        n = +t + (t < 0 ? e : 0);
                    return this.pushStack(n >= 0 && n < e ? [this[n]] : [])
                },
                end: function() {
                    return this.prevObject || this.constructor()
                },
                push: l,
                sort: i.sort,
                splice: i.splice
            }, h.extend = h.fn.extend = function() {
                var t, e, n, r, o, i, a = arguments[0] || {},
                    s = 1,
                    u = arguments.length,
                    l = !1;
                for ("boolean" == typeof a && (l = a, a = arguments[s] || {}, s++), "object" == typeof a || h.isFunction(a) || (a = {}), s === u && (a = this, s--); s < u; s++)
                    if (null != (t = arguments[s]))
                        for (e in t) n = a[e], a !== (r = t[e]) && (l && r && (h.isPlainObject(r) || (o = h.isArray(r))) ? (o ? (o = !1, i = n && h.isArray(n) ? n : []) : i = n && h.isPlainObject(n) ? n : {}, a[e] = h.extend(l, i, r)) : void 0 !== r && (a[e] = r));
                return a
            }, h.extend({
                expando: "jQuery" + ("2.2.4" + Math.random()).replace(/\D/g, ""),
                isReady: !0,
                error: function(t) {
                    throw new Error(t)
                },
                noop: function() {},
                isFunction: function(t) {
                    return "function" === h.type(t)
                },
                isArray: Array.isArray,
                isWindow: function(t) {
                    return null != t && t === t.window
                },
                isNumeric: function(t) {
                    var e = t && t.toString();
                    return !h.isArray(t) && e - parseFloat(e) + 1 >= 0
                },
                isPlainObject: function(t) {
                    var e;
                    if ("object" !== h.type(t) || t.nodeType || h.isWindow(t)) return !1;
                    if (t.constructor && !_.call(t, "constructor") && !_.call(t.constructor.prototype || {}, "isPrototypeOf")) return !1;
                    for (e in t);
                    return void 0 === e || _.call(t, e)
                },
                isEmptyObject: function(t) {
                    var e;
                    for (e in t) return !1;
                    return !0
                },
                type: function(t) {
                    return null == t ? t + "" : "object" == typeof t || "function" == typeof t ? d[p.call(t)] || "object" : typeof t
                },
                globalEval: function(t) {
                    var e, n = eval;
                    (t = h.trim(t)) && (1 === t.indexOf("use strict") ? ((e = a.createElement("script")).text = t, a.head.appendChild(e).parentNode.removeChild(e)) : n(t))
                },
                camelCase: function(t) {
                    return t.replace(m, "ms-").replace(y, E)
                },
                nodeName: function(t, e) {
                    return t.nodeName && t.nodeName.toLowerCase() === e.toLowerCase()
                },
                each: function(t, e) {
                    var n, r = 0;
                    if (v(t))
                        for (n = t.length; r < n && !1 !== e.call(t[r], r, t[r]); r++);
                    else
                        for (r in t)
                            if (!1 === e.call(t[r], r, t[r])) break;
                    return t
                },
                trim: function(t) {
                    return null == t ? "" : (t + "").replace(g, "")
                },
                makeArray: function(t, e) {
                    var n = e || [];
                    return null != t && (v(Object(t)) ? h.merge(n, "string" == typeof t ? [t] : t) : l.call(n, t)), n
                },
                inArray: function(t, e, n) {
                    return null == e ? -1 : c.call(e, t, n)
                },
                merge: function(t, e) {
                    for (var n = +e.length, r = 0, o = t.length; r < n; r++) t[o++] = e[r];
                    return t.length = o, t
                },
                grep: function(t, e, n) {
                    for (var r = [], o = 0, i = t.length, a = !n; o < i; o++) !e(t[o], o) !== a && r.push(t[o]);
                    return r
                },
                map: function(t, e, n) {
                    var r, o, i = 0,
                        a = [];
                    if (v(t))
                        for (r = t.length; i < r; i++) null != (o = e(t[i], i, n)) && a.push(o);
                    else
                        for (i in t) null != (o = e(t[i], i, n)) && a.push(o);
                    return u.apply([], a)
                },
                guid: 1,
                proxy: function(t, e) {
                    var n, r, o;
                    if ("string" == typeof e && (n = t[e], e = t, t = n), h.isFunction(t)) return r = s.call(arguments, 2), (o = function() {
                        return t.apply(e || this, r.concat(s.call(arguments)))
                    }).guid = t.guid = t.guid || h.guid++, o
                },
                now: Date.now,
                support: f
            }), "function" == typeof Symbol && (h.fn[Symbol.iterator] = i[Symbol.iterator]), h.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), (function(t, e) {
                d["[object " + e + "]"] = e.toLowerCase()
            }));
            var b = function(t) {
                var e, n, r, o, i, a, s, u, l, c, d, p, _, f, h, g, m, y, E, v = "sizzle" + 1 * new Date,
                    b = t.document,
                    O = 0,
                    D = 0,
                    P = ot(),
                    M = ot(),
                    T = ot(),
                    w = function(t, e) {
                        return t === e && (d = !0), 0
                    },
                    C = {}.hasOwnProperty,
                    x = [],
                    A = x.pop,
                    q = x.push,
                    j = x.push,
                    L = x.slice,
                    R = function(t, e) {
                        for (var n = 0, r = t.length; n < r; n++)
                            if (t[n] === e) return n;
                        return -1
                    },
                    I = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
                    B = "[\\x20\\t\\r\\n\\f]",
                    W = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
                    k = "\\[" + B + "*(" + W + ")(?:" + B + "*([*^$|!~]?=)" + B + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + W + "))|)" + B + "*\\]",
                    U = ":(" + W + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + k + ")*)|.*)\\)|)",
                    S = new RegExp(B + "+", "g"),
                    K = new RegExp("^" + B + "+|((?:^|[^\\\\])(?:\\\\.)*)" + B + "+$", "g"),
                    N = new RegExp("^" + B + "*," + B + "*"),
                    F = new RegExp("^" + B + "*([>+~]|" + B + ")" + B + "*"),
                    H = new RegExp("=" + B + "*([^\\]'\"]*?)" + B + "*\\]", "g"),
                    $ = new RegExp(U),
                    V = new RegExp("^" + W + "$"),
                    z = {
                        ID: new RegExp("^#(" + W + ")"),
                        CLASS: new RegExp("^\\.(" + W + ")"),
                        TAG: new RegExp("^(" + W + "|[*])"),
                        ATTR: new RegExp("^" + k),
                        PSEUDO: new RegExp("^" + U),
                        CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + B + "*(even|odd|(([+-]|)(\\d*)n|)" + B + "*(?:([+-]|)" + B + "*(\\d+)|))" + B + "*\\)|)", "i"),
                        bool: new RegExp("^(?:" + I + ")$", "i"),
                        needsContext: new RegExp("^" + B + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + B + "*((?:-\\d)?\\d*)" + B + "*\\)|)(?=[^-]|$)", "i")
                    },
                    G = /^(?:input|select|textarea|button)$/i,
                    Q = /^h\d$/i,
                    X = /^[^{]+\{\s*\[native \w/,
                    Y = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
                    J = /[+~]/,
                    Z = /'|\\/g,
                    tt = new RegExp("\\\\([\\da-f]{1,6}" + B + "?|(" + B + ")|.)", "ig"),
                    et = function(t, e, n) {
                        var r = "0x" + e - 65536;
                        return r != r || n ? e : r < 0 ? String.fromCharCode(r + 65536) : String.fromCharCode(r >> 10 | 55296, 1023 & r | 56320)
                    },
                    nt = function() {
                        p()
                    };
                try {
                    j.apply(x = L.call(b.childNodes), b.childNodes), x[b.childNodes.length].nodeType
                } catch (t) {
                    j = {
                        apply: x.length ? function(t, e) {
                            q.apply(t, L.call(e))
                        } : function(t, e) {
                            for (var n = t.length, r = 0; t[n++] = e[r++];);
                            t.length = n - 1
                        }
                    }
                }

                function rt(t, e, r, o) {
                    var i, s, l, c, d, f, m, y, O = e && e.ownerDocument,
                        D = e ? e.nodeType : 9;
                    if (r = r || [], "string" != typeof t || !t || 1 !== D && 9 !== D && 11 !== D) return r;
                    if (!o && ((e ? e.ownerDocument || e : b) !== _ && p(e), e = e || _, h)) {
                        if (11 !== D && (f = Y.exec(t)))
                            if (i = f[1]) {
                                if (9 === D) {
                                    if (!(l = e.getElementById(i))) return r;
                                    if (l.id === i) return r.push(l), r
                                } else if (O && (l = O.getElementById(i)) && E(e, l) && l.id === i) return r.push(l), r
                            } else {
                                if (f[2]) return j.apply(r, e.getElementsByTagName(t)), r;
                                if ((i = f[3]) && n.getElementsByClassName && e.getElementsByClassName) return j.apply(r, e.getElementsByClassName(i)), r
                            } if (n.qsa && !T[t + " "] && (!g || !g.test(t))) {
                            if (1 !== D) O = e, y = t;
                            else if ("object" !== e.nodeName.toLowerCase()) {
                                for ((c = e.getAttribute("id")) ? c = c.replace(Z, "\\$&") : e.setAttribute("id", c = v), s = (m = a(t)).length, d = V.test(c) ? "#" + c : "[id='" + c + "']"; s--;) m[s] = d + " " + ft(m[s]);
                                y = m.join(","), O = J.test(t) && pt(e.parentNode) || e
                            }
                            if (y) try {
                                return j.apply(r, O.querySelectorAll(y)), r
                            } catch (t) {} finally {
                                c === v && e.removeAttribute("id")
                            }
                        }
                    }
                    return u(t.replace(K, "$1"), e, r, o)
                }

                function ot() {
                    var t = [];
                    return function e(n, o) {
                        return t.push(n + " ") > r.cacheLength && delete e[t.shift()], e[n + " "] = o
                    }
                }

                function it(t) {
                    return t[v] = !0, t
                }

                function at(t) {
                    var e = _.createElement("div");
                    try {
                        return !!t(e)
                    } catch (t) {
                        return !1
                    } finally {
                        e.parentNode && e.parentNode.removeChild(e), e = null
                    }
                }

                function st(t, e) {
                    for (var n = t.split("|"), o = n.length; o--;) r.attrHandle[n[o]] = e
                }

                function ut(t, e) {
                    var n = e && t,
                        r = n && 1 === t.nodeType && 1 === e.nodeType && (~e.sourceIndex || 1 << 31) - (~t.sourceIndex || 1 << 31);
                    if (r) return r;
                    if (n)
                        for (; n = n.nextSibling;)
                            if (n === e) return -1;
                    return t ? 1 : -1
                }

                function lt(t) {
                    return function(e) {
                        return "input" === e.nodeName.toLowerCase() && e.type === t
                    }
                }

                function ct(t) {
                    return function(e) {
                        var n = e.nodeName.toLowerCase();
                        return ("input" === n || "button" === n) && e.type === t
                    }
                }

                function dt(t) {
                    return it((function(e) {
                        return e = +e, it((function(n, r) {
                            for (var o, i = t([], n.length, e), a = i.length; a--;) n[o = i[a]] && (n[o] = !(r[o] = n[o]))
                        }))
                    }))
                }

                function pt(t) {
                    return t && void 0 !== t.getElementsByTagName && t
                }
                for (e in n = rt.support = {}, i = rt.isXML = function(t) {
                        var e = t && (t.ownerDocument || t).documentElement;
                        return !!e && "HTML" !== e.nodeName
                    }, p = rt.setDocument = function(t) {
                        var e, o, a = t ? t.ownerDocument || t : b;
                        return a !== _ && 9 === a.nodeType && a.documentElement ? (f = (_ = a).documentElement, h = !i(_), (o = _.defaultView) && o.top !== o && (o.addEventListener ? o.addEventListener("unload", nt, !1) : o.attachEvent && o.attachEvent("onunload", nt)), n.attributes = at((function(t) {
                            return t.className = "i", !t.getAttribute("className")
                        })), n.getElementsByTagName = at((function(t) {
                            return t.appendChild(_.createComment("")), !t.getElementsByTagName("*").length
                        })), n.getElementsByClassName = X.test(_.getElementsByClassName), n.getById = at((function(t) {
                            return f.appendChild(t).id = v, !_.getElementsByName || !_.getElementsByName(v).length
                        })), n.getById ? (r.find.ID = function(t, e) {
                            if (void 0 !== e.getElementById && h) {
                                var n = e.getElementById(t);
                                return n ? [n] : []
                            }
                        }, r.filter.ID = function(t) {
                            var e = t.replace(tt, et);
                            return function(t) {
                                return t.getAttribute("id") === e
                            }
                        }) : (delete r.find.ID, r.filter.ID = function(t) {
                            var e = t.replace(tt, et);
                            return function(t) {
                                var n = void 0 !== t.getAttributeNode && t.getAttributeNode("id");
                                return n && n.value === e
                            }
                        }), r.find.TAG = n.getElementsByTagName ? function(t, e) {
                            return void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t) : n.qsa ? e.querySelectorAll(t) : void 0
                        } : function(t, e) {
                            var n, r = [],
                                o = 0,
                                i = e.getElementsByTagName(t);
                            if ("*" === t) {
                                for (; n = i[o++];) 1 === n.nodeType && r.push(n);
                                return r
                            }
                            return i
                        }, r.find.CLASS = n.getElementsByClassName && function(t, e) {
                            if (void 0 !== e.getElementsByClassName && h) return e.getElementsByClassName(t)
                        }, m = [], g = [], (n.qsa = X.test(_.querySelectorAll)) && (at((function(t) {
                            f.appendChild(t).innerHTML = "<a id='" + v + "'></a><select id='" + v + "-\r\\' msallowcapture=''><option selected=''></option></select>", t.querySelectorAll("[msallowcapture^='']").length && g.push("[*^$]=" + B + "*(?:''|\"\")"), t.querySelectorAll("[selected]").length || g.push("\\[" + B + "*(?:value|" + I + ")"), t.querySelectorAll("[id~=" + v + "-]").length || g.push("~="), t.querySelectorAll(":checked").length || g.push(":checked"), t.querySelectorAll("a#" + v + "+*").length || g.push(".#.+[+~]")
                        })), at((function(t) {
                            var e = _.createElement("input");
                            e.setAttribute("type", "hidden"), t.appendChild(e).setAttribute("name", "D"), t.querySelectorAll("[name=d]").length && g.push("name" + B + "*[*^$|!~]?="), t.querySelectorAll(":enabled").length || g.push(":enabled", ":disabled"), t.querySelectorAll("*,:x"), g.push(",.*:")
                        }))), (n.matchesSelector = X.test(y = f.matches || f.webkitMatchesSelector || f.mozMatchesSelector || f.oMatchesSelector || f.msMatchesSelector)) && at((function(t) {
                            n.disconnectedMatch = y.call(t, "div"), y.call(t, "[s!='']:x"), m.push("!=", U)
                        })), g = g.length && new RegExp(g.join("|")), m = m.length && new RegExp(m.join("|")), e = X.test(f.compareDocumentPosition), E = e || X.test(f.contains) ? function(t, e) {
                            var n = 9 === t.nodeType ? t.documentElement : t,
                                r = e && e.parentNode;
                            return t === r || !(!r || 1 !== r.nodeType || !(n.contains ? n.contains(r) : t.compareDocumentPosition && 16 & t.compareDocumentPosition(r)))
                        } : function(t, e) {
                            if (e)
                                for (; e = e.parentNode;)
                                    if (e === t) return !0;
                            return !1
                        }, w = e ? function(t, e) {
                            if (t === e) return d = !0, 0;
                            var r = !t.compareDocumentPosition - !e.compareDocumentPosition;
                            return r || (1 & (r = (t.ownerDocument || t) === (e.ownerDocument || e) ? t.compareDocumentPosition(e) : 1) || !n.sortDetached && e.compareDocumentPosition(t) === r ? t === _ || t.ownerDocument === b && E(b, t) ? -1 : e === _ || e.ownerDocument === b && E(b, e) ? 1 : c ? R(c, t) - R(c, e) : 0 : 4 & r ? -1 : 1)
                        } : function(t, e) {
                            if (t === e) return d = !0, 0;
                            var n, r = 0,
                                o = t.parentNode,
                                i = e.parentNode,
                                a = [t],
                                s = [e];
                            if (!o || !i) return t === _ ? -1 : e === _ ? 1 : o ? -1 : i ? 1 : c ? R(c, t) - R(c, e) : 0;
                            if (o === i) return ut(t, e);
                            for (n = t; n = n.parentNode;) a.unshift(n);
                            for (n = e; n = n.parentNode;) s.unshift(n);
                            for (; a[r] === s[r];) r++;
                            return r ? ut(a[r], s[r]) : a[r] === b ? -1 : s[r] === b ? 1 : 0
                        }, _) : _
                    }, rt.matches = function(t, e) {
                        return rt(t, null, null, e)
                    }, rt.matchesSelector = function(t, e) {
                        if ((t.ownerDocument || t) !== _ && p(t), e = e.replace(H, "='$1']"), n.matchesSelector && h && !T[e + " "] && (!m || !m.test(e)) && (!g || !g.test(e))) try {
                            var r = y.call(t, e);
                            if (r || n.disconnectedMatch || t.document && 11 !== t.document.nodeType) return r
                        } catch (t) {}
                        return rt(e, _, null, [t]).length > 0
                    }, rt.contains = function(t, e) {
                        return (t.ownerDocument || t) !== _ && p(t), E(t, e)
                    }, rt.attr = function(t, e) {
                        (t.ownerDocument || t) !== _ && p(t);
                        var o = r.attrHandle[e.toLowerCase()],
                            i = o && C.call(r.attrHandle, e.toLowerCase()) ? o(t, e, !h) : void 0;
                        return void 0 !== i ? i : n.attributes || !h ? t.getAttribute(e) : (i = t.getAttributeNode(e)) && i.specified ? i.value : null
                    }, rt.error = function(t) {
                        throw new Error("Syntax error, unrecognized expression: " + t)
                    }, rt.uniqueSort = function(t) {
                        var e, r = [],
                            o = 0,
                            i = 0;
                        if (d = !n.detectDuplicates, c = !n.sortStable && t.slice(0), t.sort(w), d) {
                            for (; e = t[i++];) e === t[i] && (o = r.push(i));
                            for (; o--;) t.splice(r[o], 1)
                        }
                        return c = null, t
                    }, o = rt.getText = function(t) {
                        var e, n = "",
                            r = 0,
                            i = t.nodeType;
                        if (i) {
                            if (1 === i || 9 === i || 11 === i) {
                                if ("string" == typeof t.textContent) return t.textContent;
                                for (t = t.firstChild; t; t = t.nextSibling) n += o(t)
                            } else if (3 === i || 4 === i) return t.nodeValue
                        } else
                            for (; e = t[r++];) n += o(e);
                        return n
                    }, (r = rt.selectors = {
                        cacheLength: 50,
                        createPseudo: it,
                        match: z,
                        attrHandle: {},
                        find: {},
                        relative: {
                            ">": {
                                dir: "parentNode",
                                first: !0
                            },
                            " ": {
                                dir: "parentNode"
                            },
                            "+": {
                                dir: "previousSibling",
                                first: !0
                            },
                            "~": {
                                dir: "previousSibling"
                            }
                        },
                        preFilter: {
                            ATTR: function(t) {
                                return t[1] = t[1].replace(tt, et), t[3] = (t[3] || t[4] || t[5] || "").replace(tt, et), "~=" === t[2] && (t[3] = " " + t[3] + " "), t.slice(0, 4)
                            },
                            CHILD: function(t) {
                                return t[1] = t[1].toLowerCase(), "nth" === t[1].slice(0, 3) ? (t[3] || rt.error(t[0]), t[4] = +(t[4] ? t[5] + (t[6] || 1) : 2 * ("even" === t[3] || "odd" === t[3])), t[5] = +(t[7] + t[8] || "odd" === t[3])) : t[3] && rt.error(t[0]), t
                            },
                            PSEUDO: function(t) {
                                var e, n = !t[6] && t[2];
                                return z.CHILD.test(t[0]) ? null : (t[3] ? t[2] = t[4] || t[5] || "" : n && $.test(n) && (e = a(n, !0)) && (e = n.indexOf(")", n.length - e) - n.length) && (t[0] = t[0].slice(0, e), t[2] = n.slice(0, e)), t.slice(0, 3))
                            }
                        },
                        filter: {
                            TAG: function(t) {
                                var e = t.replace(tt, et).toLowerCase();
                                return "*" === t ? function() {
                                    return !0
                                } : function(t) {
                                    return t.nodeName && t.nodeName.toLowerCase() === e
                                }
                            },
                            CLASS: function(t) {
                                var e = P[t + " "];
                                return e || (e = new RegExp("(^|" + B + ")" + t + "(" + B + "|$)")) && P(t, (function(t) {
                                    return e.test("string" == typeof t.className && t.className || void 0 !== t.getAttribute && t.getAttribute("class") || "")
                                }))
                            },
                            ATTR: function(t, e, n) {
                                return function(r) {
                                    var o = rt.attr(r, t);
                                    return null == o ? "!=" === e : !e || (o += "", "=" === e ? o === n : "!=" === e ? o !== n : "^=" === e ? n && 0 === o.indexOf(n) : "*=" === e ? n && o.indexOf(n) > -1 : "$=" === e ? n && o.slice(-n.length) === n : "~=" === e ? (" " + o.replace(S, " ") + " ").indexOf(n) > -1 : "|=" === e && (o === n || o.slice(0, n.length + 1) === n + "-"))
                                }
                            },
                            CHILD: function(t, e, n, r, o) {
                                var i = "nth" !== t.slice(0, 3),
                                    a = "last" !== t.slice(-4),
                                    s = "of-type" === e;
                                return 1 === r && 0 === o ? function(t) {
                                    return !!t.parentNode
                                } : function(e, n, u) {
                                    var l, c, d, p, _, f, h = i !== a ? "nextSibling" : "previousSibling",
                                        g = e.parentNode,
                                        m = s && e.nodeName.toLowerCase(),
                                        y = !u && !s,
                                        E = !1;
                                    if (g) {
                                        if (i) {
                                            for (; h;) {
                                                for (p = e; p = p[h];)
                                                    if (s ? p.nodeName.toLowerCase() === m : 1 === p.nodeType) return !1;
                                                f = h = "only" === t && !f && "nextSibling"
                                            }
                                            return !0
                                        }
                                        if (f = [a ? g.firstChild : g.lastChild], a && y) {
                                            for (E = (_ = (l = (c = (d = (p = g)[v] || (p[v] = {}))[p.uniqueID] || (d[p.uniqueID] = {}))[t] || [])[0] === O && l[1]) && l[2], p = _ && g.childNodes[_]; p = ++_ && p && p[h] || (E = _ = 0) || f.pop();)
                                                if (1 === p.nodeType && ++E && p === e) {
                                                    c[t] = [O, _, E];
                                                    break
                                                }
                                        } else if (y && (E = _ = (l = (c = (d = (p = e)[v] || (p[v] = {}))[p.uniqueID] || (d[p.uniqueID] = {}))[t] || [])[0] === O && l[1]), !1 === E)
                                            for (;
                                                (p = ++_ && p && p[h] || (E = _ = 0) || f.pop()) && ((s ? p.nodeName.toLowerCase() !== m : 1 !== p.nodeType) || !++E || (y && ((c = (d = p[v] || (p[v] = {}))[p.uniqueID] || (d[p.uniqueID] = {}))[t] = [O, E]), p !== e)););
                                        return (E -= o) === r || E % r == 0 && E / r >= 0
                                    }
                                }
                            },
                            PSEUDO: function(t, e) {
                                var n, o = r.pseudos[t] || r.setFilters[t.toLowerCase()] || rt.error("unsupported pseudo: " + t);
                                return o[v] ? o(e) : o.length > 1 ? (n = [t, t, "", e], r.setFilters.hasOwnProperty(t.toLowerCase()) ? it((function(t, n) {
                                    for (var r, i = o(t, e), a = i.length; a--;) t[r = R(t, i[a])] = !(n[r] = i[a])
                                })) : function(t) {
                                    return o(t, 0, n)
                                }) : o
                            }
                        },
                        pseudos: {
                            not: it((function(t) {
                                var e = [],
                                    n = [],
                                    r = s(t.replace(K, "$1"));
                                return r[v] ? it((function(t, e, n, o) {
                                    for (var i, a = r(t, null, o, []), s = t.length; s--;)(i = a[s]) && (t[s] = !(e[s] = i))
                                })) : function(t, o, i) {
                                    return e[0] = t, r(e, null, i, n), e[0] = null, !n.pop()
                                }
                            })),
                            has: it((function(t) {
                                return function(e) {
                                    return rt(t, e).length > 0
                                }
                            })),
                            contains: it((function(t) {
                                return t = t.replace(tt, et),
                                    function(e) {
                                        return (e.textContent || e.innerText || o(e)).indexOf(t) > -1
                                    }
                            })),
                            lang: it((function(t) {
                                return V.test(t || "") || rt.error("unsupported lang: " + t), t = t.replace(tt, et).toLowerCase(),
                                    function(e) {
                                        var n;
                                        do {
                                            if (n = h ? e.lang : e.getAttribute("xml:lang") || e.getAttribute("lang")) return (n = n.toLowerCase()) === t || 0 === n.indexOf(t + "-")
                                        } while ((e = e.parentNode) && 1 === e.nodeType);
                                        return !1
                                    }
                            })),
                            target: function(e) {
                                var n = t.location && t.location.hash;
                                return n && n.slice(1) === e.id
                            },
                            root: function(t) {
                                return t === f
                            },
                            focus: function(t) {
                                return t === _.activeElement && (!_.hasFocus || _.hasFocus()) && !!(t.type || t.href || ~t.tabIndex)
                            },
                            enabled: function(t) {
                                return !1 === t.disabled
                            },
                            disabled: function(t) {
                                return !0 === t.disabled
                            },
                            checked: function(t) {
                                var e = t.nodeName.toLowerCase();
                                return "input" === e && !!t.checked || "option" === e && !!t.selected
                            },
                            selected: function(t) {
                                return t.parentNode && t.parentNode.selectedIndex, !0 === t.selected
                            },
                            empty: function(t) {
                                for (t = t.firstChild; t; t = t.nextSibling)
                                    if (t.nodeType < 6) return !1;
                                return !0
                            },
                            parent: function(t) {
                                return !r.pseudos.empty(t)
                            },
                            header: function(t) {
                                return Q.test(t.nodeName)
                            },
                            input: function(t) {
                                return G.test(t.nodeName)
                            },
                            button: function(t) {
                                var e = t.nodeName.toLowerCase();
                                return "input" === e && "button" === t.type || "button" === e
                            },
                            text: function(t) {
                                var e;
                                return "input" === t.nodeName.toLowerCase() && "text" === t.type && (null == (e = t.getAttribute("type")) || "text" === e.toLowerCase())
                            },
                            first: dt((function() {
                                return [0]
                            })),
                            last: dt((function(t, e) {
                                return [e - 1]
                            })),
                            eq: dt((function(t, e, n) {
                                return [n < 0 ? n + e : n]
                            })),
                            even: dt((function(t, e) {
                                for (var n = 0; n < e; n += 2) t.push(n);
                                return t
                            })),
                            odd: dt((function(t, e) {
                                for (var n = 1; n < e; n += 2) t.push(n);
                                return t
                            })),
                            lt: dt((function(t, e, n) {
                                for (var r = n < 0 ? n + e : n; --r >= 0;) t.push(r);
                                return t
                            })),
                            gt: dt((function(t, e, n) {
                                for (var r = n < 0 ? n + e : n; ++r < e;) t.push(r);
                                return t
                            }))
                        }
                    }).pseudos.nth = r.pseudos.eq, {
                        radio: !0,
                        checkbox: !0,
                        file: !0,
                        password: !0,
                        image: !0
                    }) r.pseudos[e] = lt(e);
                for (e in {
                        submit: !0,
                        reset: !0
                    }) r.pseudos[e] = ct(e);

                function _t() {}

                function ft(t) {
                    for (var e = 0, n = t.length, r = ""; e < n; e++) r += t[e].value;
                    return r
                }

                function ht(t, e, n) {
                    var r = e.dir,
                        o = n && "parentNode" === r,
                        i = D++;
                    return e.first ? function(e, n, i) {
                        for (; e = e[r];)
                            if (1 === e.nodeType || o) return t(e, n, i)
                    } : function(e, n, a) {
                        var s, u, l, c = [O, i];
                        if (a) {
                            for (; e = e[r];)
                                if ((1 === e.nodeType || o) && t(e, n, a)) return !0
                        } else
                            for (; e = e[r];)
                                if (1 === e.nodeType || o) {
                                    if ((s = (u = (l = e[v] || (e[v] = {}))[e.uniqueID] || (l[e.uniqueID] = {}))[r]) && s[0] === O && s[1] === i) return c[2] = s[2];
                                    if (u[r] = c, c[2] = t(e, n, a)) return !0
                                }
                    }
                }

                function gt(t) {
                    return t.length > 1 ? function(e, n, r) {
                        for (var o = t.length; o--;)
                            if (!t[o](e, n, r)) return !1;
                        return !0
                    } : t[0]
                }

                function mt(t, e, n, r, o) {
                    for (var i, a = [], s = 0, u = t.length, l = null != e; s < u; s++)(i = t[s]) && (n && !n(i, r, o) || (a.push(i), l && e.push(s)));
                    return a
                }

                function yt(t, e, n, r, o, i) {
                    return r && !r[v] && (r = yt(r)), o && !o[v] && (o = yt(o, i)), it((function(i, a, s, u) {
                        var l, c, d, p = [],
                            _ = [],
                            f = a.length,
                            h = i || function(t, e, n) {
                                for (var r = 0, o = e.length; r < o; r++) rt(t, e[r], n);
                                return n
                            }(e || "*", s.nodeType ? [s] : s, []),
                            g = !t || !i && e ? h : mt(h, p, t, s, u),
                            m = n ? o || (i ? t : f || r) ? [] : a : g;
                        if (n && n(g, m, s, u), r)
                            for (l = mt(m, _), r(l, [], s, u), c = l.length; c--;)(d = l[c]) && (m[_[c]] = !(g[_[c]] = d));
                        if (i) {
                            if (o || t) {
                                if (o) {
                                    for (l = [], c = m.length; c--;)(d = m[c]) && l.push(g[c] = d);
                                    o(null, m = [], l, u)
                                }
                                for (c = m.length; c--;)(d = m[c]) && (l = o ? R(i, d) : p[c]) > -1 && (i[l] = !(a[l] = d))
                            }
                        } else m = mt(m === a ? m.splice(f, m.length) : m), o ? o(null, a, m, u) : j.apply(a, m)
                    }))
                }

                function Et(t) {
                    for (var e, n, o, i = t.length, a = r.relative[t[0].type], s = a || r.relative[" "], u = a ? 1 : 0, c = ht((function(t) {
                            return t === e
                        }), s, !0), d = ht((function(t) {
                            return R(e, t) > -1
                        }), s, !0), p = [function(t, n, r) {
                            var o = !a && (r || n !== l) || ((e = n).nodeType ? c(t, n, r) : d(t, n, r));
                            return e = null, o
                        }]; u < i; u++)
                        if (n = r.relative[t[u].type]) p = [ht(gt(p), n)];
                        else {
                            if ((n = r.filter[t[u].type].apply(null, t[u].matches))[v]) {
                                for (o = ++u; o < i && !r.relative[t[o].type]; o++);
                                return yt(u > 1 && gt(p), u > 1 && ft(t.slice(0, u - 1).concat({
                                    value: " " === t[u - 2].type ? "*" : ""
                                })).replace(K, "$1"), n, u < o && Et(t.slice(u, o)), o < i && Et(t = t.slice(o)), o < i && ft(t))
                            }
                            p.push(n)
                        } return gt(p)
                }
                return _t.prototype = r.filters = r.pseudos, r.setFilters = new _t, a = rt.tokenize = function(t, e) {
                    var n, o, i, a, s, u, l, c = M[t + " "];
                    if (c) return e ? 0 : c.slice(0);
                    for (s = t, u = [], l = r.preFilter; s;) {
                        for (a in n && !(o = N.exec(s)) || (o && (s = s.slice(o[0].length) || s), u.push(i = [])), n = !1, (o = F.exec(s)) && (n = o.shift(), i.push({
                                value: n,
                                type: o[0].replace(K, " ")
                            }), s = s.slice(n.length)), r.filter) !(o = z[a].exec(s)) || l[a] && !(o = l[a](o)) || (n = o.shift(), i.push({
                            value: n,
                            type: a,
                            matches: o
                        }), s = s.slice(n.length));
                        if (!n) break
                    }
                    return e ? s.length : s ? rt.error(t) : M(t, u).slice(0)
                }, s = rt.compile = function(t, e) {
                    var n, o = [],
                        i = [],
                        s = T[t + " "];
                    if (!s) {
                        for (e || (e = a(t)), n = e.length; n--;)(s = Et(e[n]))[v] ? o.push(s) : i.push(s);
                        (s = T(t, function(t, e) {
                            var n = e.length > 0,
                                o = t.length > 0,
                                i = function(i, a, s, u, c) {
                                    var d, f, g, m = 0,
                                        y = "0",
                                        E = i && [],
                                        v = [],
                                        b = l,
                                        D = i || o && r.find.TAG("*", c),
                                        P = O += null == b ? 1 : Math.random() || .1,
                                        M = D.length;
                                    for (c && (l = a === _ || a || c); y !== M && null != (d = D[y]); y++) {
                                        if (o && d) {
                                            for (f = 0, a || d.ownerDocument === _ || (p(d), s = !h); g = t[f++];)
                                                if (g(d, a || _, s)) {
                                                    u.push(d);
                                                    break
                                                } c && (O = P)
                                        }
                                        n && ((d = !g && d) && m--, i && E.push(d))
                                    }
                                    if (m += y, n && y !== m) {
                                        for (f = 0; g = e[f++];) g(E, v, a, s);
                                        if (i) {
                                            if (m > 0)
                                                for (; y--;) E[y] || v[y] || (v[y] = A.call(u));
                                            v = mt(v)
                                        }
                                        j.apply(u, v), c && !i && v.length > 0 && m + e.length > 1 && rt.uniqueSort(u)
                                    }
                                    return c && (O = P, l = b), E
                                };
                            return n ? it(i) : i
                        }(i, o))).selector = t
                    }
                    return s
                }, u = rt.select = function(t, e, o, i) {
                    var u, l, c, d, p, _ = "function" == typeof t && t,
                        f = !i && a(t = _.selector || t);
                    if (o = o || [], 1 === f.length) {
                        if ((l = f[0] = f[0].slice(0)).length > 2 && "ID" === (c = l[0]).type && n.getById && 9 === e.nodeType && h && r.relative[l[1].type]) {
                            if (!(e = (r.find.ID(c.matches[0].replace(tt, et), e) || [])[0])) return o;
                            _ && (e = e.parentNode), t = t.slice(l.shift().value.length)
                        }
                        for (u = z.needsContext.test(t) ? 0 : l.length; u-- && (c = l[u], !r.relative[d = c.type]);)
                            if ((p = r.find[d]) && (i = p(c.matches[0].replace(tt, et), J.test(l[0].type) && pt(e.parentNode) || e))) {
                                if (l.splice(u, 1), !(t = i.length && ft(l))) return j.apply(o, i), o;
                                break
                            }
                    }
                    return (_ || s(t, f))(i, e, !h, o, !e || J.test(t) && pt(e.parentNode) || e), o
                }, n.sortStable = v.split("").sort(w).join("") === v, n.detectDuplicates = !!d, p(), n.sortDetached = at((function(t) {
                    return 1 & t.compareDocumentPosition(_.createElement("div"))
                })), at((function(t) {
                    return t.innerHTML = "<a href='#'></a>", "#" === t.firstChild.getAttribute("href")
                })) || st("type|href|height|width", (function(t, e, n) {
                    if (!n) return t.getAttribute(e, "type" === e.toLowerCase() ? 1 : 2)
                })), n.attributes && at((function(t) {
                    return t.innerHTML = "<input/>", t.firstChild.setAttribute("value", ""), "" === t.firstChild.getAttribute("value")
                })) || st("value", (function(t, e, n) {
                    if (!n && "input" === t.nodeName.toLowerCase()) return t.defaultValue
                })), at((function(t) {
                    return null == t.getAttribute("disabled")
                })) || st(I, (function(t, e, n) {
                    var r;
                    if (!n) return !0 === t[e] ? e.toLowerCase() : (r = t.getAttributeNode(e)) && r.specified ? r.value : null
                })), rt
            }(n);
            h.find = b, h.expr = b.selectors, h.expr[":"] = h.expr.pseudos, h.uniqueSort = h.unique = b.uniqueSort, h.text = b.getText, h.isXMLDoc = b.isXML, h.contains = b.contains;
            var O = function(t, e, n) {
                    for (var r = [], o = void 0 !== n;
                        (t = t[e]) && 9 !== t.nodeType;)
                        if (1 === t.nodeType) {
                            if (o && h(t).is(n)) break;
                            r.push(t)
                        } return r
                },
                D = function(t, e) {
                    for (var n = []; t; t = t.nextSibling) 1 === t.nodeType && t !== e && n.push(t);
                    return n
                },
                P = h.expr.match.needsContext,
                M = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/,
                T = /^.[^:#\[\.,]*$/;

            function w(t, e, n) {
                if (h.isFunction(e)) return h.grep(t, (function(t, r) {
                    return !!e.call(t, r, t) !== n
                }));
                if (e.nodeType) return h.grep(t, (function(t) {
                    return t === e !== n
                }));
                if ("string" == typeof e) {
                    if (T.test(e)) return h.filter(e, t, n);
                    e = h.filter(e, t)
                }
                return h.grep(t, (function(t) {
                    return c.call(e, t) > -1 !== n
                }))
            }
            h.filter = function(t, e, n) {
                var r = e[0];
                return n && (t = ":not(" + t + ")"), 1 === e.length && 1 === r.nodeType ? h.find.matchesSelector(r, t) ? [r] : [] : h.find.matches(t, h.grep(e, (function(t) {
                    return 1 === t.nodeType
                })))
            }, h.fn.extend({
                find: function(t) {
                    var e, n = this.length,
                        r = [],
                        o = this;
                    if ("string" != typeof t) return this.pushStack(h(t).filter((function() {
                        for (e = 0; e < n; e++)
                            if (h.contains(o[e], this)) return !0
                    })));
                    for (e = 0; e < n; e++) h.find(t, o[e], r);
                    return (r = this.pushStack(n > 1 ? h.unique(r) : r)).selector = this.selector ? this.selector + " " + t : t, r
                },
                filter: function(t) {
                    return this.pushStack(w(this, t || [], !1))
                },
                not: function(t) {
                    return this.pushStack(w(this, t || [], !0))
                },
                is: function(t) {
                    return !!w(this, "string" == typeof t && P.test(t) ? h(t) : t || [], !1).length
                }
            });
            var C, x = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/;
            (h.fn.init = function(t, e, n) {
                var r, o;
                if (!t) return this;
                if (n = n || C, "string" == typeof t) {
                    if (!(r = "<" === t[0] && ">" === t[t.length - 1] && t.length >= 3 ? [null, t, null] : x.exec(t)) || !r[1] && e) return !e || e.jquery ? (e || n).find(t) : this.constructor(e).find(t);
                    if (r[1]) {
                        if (e = e instanceof h ? e[0] : e, h.merge(this, h.parseHTML(r[1], e && e.nodeType ? e.ownerDocument || e : a, !0)), M.test(r[1]) && h.isPlainObject(e))
                            for (r in e) h.isFunction(this[r]) ? this[r](e[r]) : this.attr(r, e[r]);
                        return this
                    }
                    return (o = a.getElementById(r[2])) && o.parentNode && (this.length = 1, this[0] = o), this.context = a, this.selector = t, this
                }
                return t.nodeType ? (this.context = this[0] = t, this.length = 1, this) : h.isFunction(t) ? void 0 !== n.ready ? n.ready(t) : t(h) : (void 0 !== t.selector && (this.selector = t.selector, this.context = t.context), h.makeArray(t, this))
            }).prototype = h.fn, C = h(a);
            var A = /^(?:parents|prev(?:Until|All))/,
                q = {
                    children: !0,
                    contents: !0,
                    next: !0,
                    prev: !0
                };

            function j(t, e) {
                for (;
                    (t = t[e]) && 1 !== t.nodeType;);
                return t
            }
            h.fn.extend({
                has: function(t) {
                    var e = h(t, this),
                        n = e.length;
                    return this.filter((function() {
                        for (var t = 0; t < n; t++)
                            if (h.contains(this, e[t])) return !0
                    }))
                },
                closest: function(t, e) {
                    for (var n, r = 0, o = this.length, i = [], a = P.test(t) || "string" != typeof t ? h(t, e || this.context) : 0; r < o; r++)
                        for (n = this[r]; n && n !== e; n = n.parentNode)
                            if (n.nodeType < 11 && (a ? a.index(n) > -1 : 1 === n.nodeType && h.find.matchesSelector(n, t))) {
                                i.push(n);
                                break
                            } return this.pushStack(i.length > 1 ? h.uniqueSort(i) : i)
                },
                index: function(t) {
                    return t ? "string" == typeof t ? c.call(h(t), this[0]) : c.call(this, t.jquery ? t[0] : t) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
                },
                add: function(t, e) {
                    return this.pushStack(h.uniqueSort(h.merge(this.get(), h(t, e))))
                },
                addBack: function(t) {
                    return this.add(null == t ? this.prevObject : this.prevObject.filter(t))
                }
            }), h.each({
                parent: function(t) {
                    var e = t.parentNode;
                    return e && 11 !== e.nodeType ? e : null
                },
                parents: function(t) {
                    return O(t, "parentNode")
                },
                parentsUntil: function(t, e, n) {
                    return O(t, "parentNode", n)
                },
                next: function(t) {
                    return j(t, "nextSibling")
                },
                prev: function(t) {
                    return j(t, "previousSibling")
                },
                nextAll: function(t) {
                    return O(t, "nextSibling")
                },
                prevAll: function(t) {
                    return O(t, "previousSibling")
                },
                nextUntil: function(t, e, n) {
                    return O(t, "nextSibling", n)
                },
                prevUntil: function(t, e, n) {
                    return O(t, "previousSibling", n)
                },
                siblings: function(t) {
                    return D((t.parentNode || {}).firstChild, t)
                },
                children: function(t) {
                    return D(t.firstChild)
                },
                contents: function(t) {
                    return t.contentDocument || h.merge([], t.childNodes)
                }
            }, (function(t, e) {
                h.fn[t] = function(n, r) {
                    var o = h.map(this, e, n);
                    return "Until" !== t.slice(-5) && (r = n), r && "string" == typeof r && (o = h.filter(r, o)), this.length > 1 && (q[t] || h.uniqueSort(o), A.test(t) && o.reverse()), this.pushStack(o)
                }
            }));
            var L, R = /\S+/g;

            function I() {
                a.removeEventListener("DOMContentLoaded", I), n.removeEventListener("load", I), h.ready()
            }
            h.Callbacks = function(t) {
                t = "string" == typeof t ? function(t) {
                    var e = {};
                    return h.each(t.match(R) || [], (function(t, n) {
                        e[n] = !0
                    })), e
                }(t) : h.extend({}, t);
                var e, n, r, o, i = [],
                    a = [],
                    s = -1,
                    u = function() {
                        for (o = t.once, r = e = !0; a.length; s = -1)
                            for (n = a.shift(); ++s < i.length;) !1 === i[s].apply(n[0], n[1]) && t.stopOnFalse && (s = i.length, n = !1);
                        t.memory || (n = !1), e = !1, o && (i = n ? [] : "")
                    },
                    l = {
                        add: function() {
                            return i && (n && !e && (s = i.length - 1, a.push(n)), function e(n) {
                                h.each(n, (function(n, r) {
                                    h.isFunction(r) ? t.unique && l.has(r) || i.push(r) : r && r.length && "string" !== h.type(r) && e(r)
                                }))
                            }(arguments), n && !e && u()), this
                        },
                        remove: function() {
                            return h.each(arguments, (function(t, e) {
                                for (var n;
                                    (n = h.inArray(e, i, n)) > -1;) i.splice(n, 1), n <= s && s--
                            })), this
                        },
                        has: function(t) {
                            return t ? h.inArray(t, i) > -1 : i.length > 0
                        },
                        empty: function() {
                            return i && (i = []), this
                        },
                        disable: function() {
                            return o = a = [], i = n = "", this
                        },
                        disabled: function() {
                            return !i
                        },
                        lock: function() {
                            return o = a = [], n || (i = n = ""), this
                        },
                        locked: function() {
                            return !!o
                        },
                        fireWith: function(t, n) {
                            return o || (n = [t, (n = n || []).slice ? n.slice() : n], a.push(n), e || u()), this
                        },
                        fire: function() {
                            return l.fireWith(this, arguments), this
                        },
                        fired: function() {
                            return !!r
                        }
                    };
                return l
            }, h.extend({
                Deferred: function(t) {
                    var e = [
                            ["resolve", "done", h.Callbacks("once memory"), "resolved"],
                            ["reject", "fail", h.Callbacks("once memory"), "rejected"],
                            ["notify", "progress", h.Callbacks("memory")]
                        ],
                        n = "pending",
                        r = {
                            state: function() {
                                return n
                            },
                            always: function() {
                                return o.done(arguments).fail(arguments), this
                            },
                            then: function() {
                                var t = arguments;
                                return h.Deferred((function(n) {
                                    h.each(e, (function(e, i) {
                                        var a = h.isFunction(t[e]) && t[e];
                                        o[i[1]]((function() {
                                            var t = a && a.apply(this, arguments);
                                            t && h.isFunction(t.promise) ? t.promise().progress(n.notify).done(n.resolve).fail(n.reject) : n[i[0] + "With"](this === r ? n.promise() : this, a ? [t] : arguments)
                                        }))
                                    })), t = null
                                })).promise()
                            },
                            promise: function(t) {
                                return null != t ? h.extend(t, r) : r
                            }
                        },
                        o = {};
                    return r.pipe = r.then, h.each(e, (function(t, i) {
                        var a = i[2],
                            s = i[3];
                        r[i[1]] = a.add, s && a.add((function() {
                            n = s
                        }), e[1 ^ t][2].disable, e[2][2].lock), o[i[0]] = function() {
                            return o[i[0] + "With"](this === o ? r : this, arguments), this
                        }, o[i[0] + "With"] = a.fireWith
                    })), r.promise(o), t && t.call(o, o), o
                },
                when: function(t) {
                    var e, n, r, o = 0,
                        i = s.call(arguments),
                        a = i.length,
                        u = 1 !== a || t && h.isFunction(t.promise) ? a : 0,
                        l = 1 === u ? t : h.Deferred(),
                        c = function(t, n, r) {
                            return function(o) {
                                n[t] = this, r[t] = arguments.length > 1 ? s.call(arguments) : o, r === e ? l.notifyWith(n, r) : --u || l.resolveWith(n, r)
                            }
                        };
                    if (a > 1)
                        for (e = new Array(a), n = new Array(a), r = new Array(a); o < a; o++) i[o] && h.isFunction(i[o].promise) ? i[o].promise().progress(c(o, n, e)).done(c(o, r, i)).fail(l.reject) : --u;
                    return u || l.resolveWith(r, i), l.promise()
                }
            }), h.fn.ready = function(t) {
                return h.ready.promise().done(t), this
            }, h.extend({
                isReady: !1,
                readyWait: 1,
                holdReady: function(t) {
                    t ? h.readyWait++ : h.ready(!0)
                },
                ready: function(t) {
                    (!0 === t ? --h.readyWait : h.isReady) || (h.isReady = !0, !0 !== t && --h.readyWait > 0 || (L.resolveWith(a, [h]), h.fn.triggerHandler && (h(a).triggerHandler("ready"), h(a).off("ready"))))
                }
            }), h.ready.promise = function(t) {
                return L || (L = h.Deferred(), "complete" === a.readyState || "loading" !== a.readyState && !a.documentElement.doScroll ? n.setTimeout(h.ready) : (a.addEventListener("DOMContentLoaded", I), n.addEventListener("load", I))), L.promise(t)
            }, h.ready.promise();
            var B = function(t, e, n, r, o, i, a) {
                    var s = 0,
                        u = t.length,
                        l = null == n;
                    if ("object" === h.type(n))
                        for (s in o = !0, n) B(t, e, s, n[s], !0, i, a);
                    else if (void 0 !== r && (o = !0, h.isFunction(r) || (a = !0), l && (a ? (e.call(t, r), e = null) : (l = e, e = function(t, e, n) {
                            return l.call(h(t), n)
                        })), e))
                        for (; s < u; s++) e(t[s], n, a ? r : r.call(t[s], s, e(t[s], n)));
                    return o ? t : l ? e.call(t) : u ? e(t[0], n) : i
                },
                W = function(t) {
                    return 1 === t.nodeType || 9 === t.nodeType || !+t.nodeType
                };

            function k() {
                this.expando = h.expando + k.uid++
            }
            k.uid = 1, k.prototype = {
                register: function(t, e) {
                    var n = e || {};
                    return t.nodeType ? t[this.expando] = n : Object.defineProperty(t, this.expando, {
                        value: n,
                        writable: !0,
                        configurable: !0
                    }), t[this.expando]
                },
                cache: function(t) {
                    if (!W(t)) return {};
                    var e = t[this.expando];
                    return e || (e = {}, W(t) && (t.nodeType ? t[this.expando] = e : Object.defineProperty(t, this.expando, {
                        value: e,
                        configurable: !0
                    }))), e
                },
                set: function(t, e, n) {
                    var r, o = this.cache(t);
                    if ("string" == typeof e) o[e] = n;
                    else
                        for (r in e) o[r] = e[r];
                    return o
                },
                get: function(t, e) {
                    return void 0 === e ? this.cache(t) : t[this.expando] && t[this.expando][e]
                },
                access: function(t, e, n) {
                    var r;
                    return void 0 === e || e && "string" == typeof e && void 0 === n ? void 0 !== (r = this.get(t, e)) ? r : this.get(t, h.camelCase(e)) : (this.set(t, e, n), void 0 !== n ? n : e)
                },
                remove: function(t, e) {
                    var n, r, o, i = t[this.expando];
                    if (void 0 !== i) {
                        if (void 0 === e) this.register(t);
                        else {
                            h.isArray(e) ? r = e.concat(e.map(h.camelCase)) : (o = h.camelCase(e), r = e in i ? [e, o] : (r = o) in i ? [r] : r.match(R) || []), n = r.length;
                            for (; n--;) delete i[r[n]]
                        }(void 0 === e || h.isEmptyObject(i)) && (t.nodeType ? t[this.expando] = void 0 : delete t[this.expando])
                    }
                },
                hasData: function(t) {
                    var e = t[this.expando];
                    return void 0 !== e && !h.isEmptyObject(e)
                }
            };
            var U = new k,
                S = new k,
                K = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
                N = /[A-Z]/g;

            function F(t, e, n) {
                var r;
                if (void 0 === n && 1 === t.nodeType)
                    if (r = "data-" + e.replace(N, "-$&").toLowerCase(), "string" == typeof(n = t.getAttribute(r))) {
                        try {
                            n = "true" === n || "false" !== n && ("null" === n ? null : +n + "" === n ? +n : K.test(n) ? h.parseJSON(n) : n)
                        } catch (t) {}
                        S.set(t, e, n)
                    } else n = void 0;
                return n
            }
            h.extend({
                hasData: function(t) {
                    return S.hasData(t) || U.hasData(t)
                },
                data: function(t, e, n) {
                    return S.access(t, e, n)
                },
                removeData: function(t, e) {
                    S.remove(t, e)
                },
                _data: function(t, e, n) {
                    return U.access(t, e, n)
                },
                _removeData: function(t, e) {
                    U.remove(t, e)
                }
            }), h.fn.extend({
                data: function(t, e) {
                    var n, r, o, i = this[0],
                        a = i && i.attributes;
                    if (void 0 === t) {
                        if (this.length && (o = S.get(i), 1 === i.nodeType && !U.get(i, "hasDataAttrs"))) {
                            for (n = a.length; n--;) a[n] && 0 === (r = a[n].name).indexOf("data-") && (r = h.camelCase(r.slice(5)), F(i, r, o[r]));
                            U.set(i, "hasDataAttrs", !0)
                        }
                        return o
                    }
                    return "object" == typeof t ? this.each((function() {
                        S.set(this, t)
                    })) : B(this, (function(e) {
                        var n, r;
                        if (i && void 0 === e) return void 0 !== (n = S.get(i, t) || S.get(i, t.replace(N, "-$&").toLowerCase())) ? n : (r = h.camelCase(t), void 0 !== (n = S.get(i, r)) || void 0 !== (n = F(i, r, void 0)) ? n : void 0);
                        r = h.camelCase(t), this.each((function() {
                            var n = S.get(this, r);
                            S.set(this, r, e), t.indexOf("-") > -1 && void 0 !== n && S.set(this, t, e)
                        }))
                    }), null, e, arguments.length > 1, null, !0)
                },
                removeData: function(t) {
                    return this.each((function() {
                        S.remove(this, t)
                    }))
                }
            }), h.extend({
                queue: function(t, e, n) {
                    var r;
                    if (t) return e = (e || "fx") + "queue", r = U.get(t, e), n && (!r || h.isArray(n) ? r = U.access(t, e, h.makeArray(n)) : r.push(n)), r || []
                },
                dequeue: function(t, e) {
                    e = e || "fx";
                    var n = h.queue(t, e),
                        r = n.length,
                        o = n.shift(),
                        i = h._queueHooks(t, e);
                    "inprogress" === o && (o = n.shift(), r--), o && ("fx" === e && n.unshift("inprogress"), delete i.stop, o.call(t, (function() {
                        h.dequeue(t, e)
                    }), i)), !r && i && i.empty.fire()
                },
                _queueHooks: function(t, e) {
                    var n = e + "queueHooks";
                    return U.get(t, n) || U.access(t, n, {
                        empty: h.Callbacks("once memory").add((function() {
                            U.remove(t, [e + "queue", n])
                        }))
                    })
                }
            }), h.fn.extend({
                queue: function(t, e) {
                    var n = 2;
                    return "string" != typeof t && (e = t, t = "fx", n--), arguments.length < n ? h.queue(this[0], t) : void 0 === e ? this : this.each((function() {
                        var n = h.queue(this, t, e);
                        h._queueHooks(this, t), "fx" === t && "inprogress" !== n[0] && h.dequeue(this, t)
                    }))
                },
                dequeue: function(t) {
                    return this.each((function() {
                        h.dequeue(this, t)
                    }))
                },
                clearQueue: function(t) {
                    return this.queue(t || "fx", [])
                },
                promise: function(t, e) {
                    var n, r = 1,
                        o = h.Deferred(),
                        i = this,
                        a = this.length,
                        s = function() {
                            --r || o.resolveWith(i, [i])
                        };
                    for ("string" != typeof t && (e = t, t = void 0), t = t || "fx"; a--;)(n = U.get(i[a], t + "queueHooks")) && n.empty && (r++, n.empty.add(s));
                    return s(), o.promise(e)
                }
            });
            var H = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
                $ = new RegExp("^(?:([+-])=|)(" + H + ")([a-z%]*)$", "i"),
                V = ["Top", "Right", "Bottom", "Left"],
                z = function(t, e) {
                    return t = e || t, "none" === h.css(t, "display") || !h.contains(t.ownerDocument, t)
                };

            function G(t, e, n, r) {
                var o, i = 1,
                    a = 20,
                    s = r ? function() {
                        return r.cur()
                    } : function() {
                        return h.css(t, e, "")
                    },
                    u = s(),
                    l = n && n[3] || (h.cssNumber[e] ? "" : "px"),
                    c = (h.cssNumber[e] || "px" !== l && +u) && $.exec(h.css(t, e));
                if (c && c[3] !== l) {
                    l = l || c[3], n = n || [], c = +u || 1;
                    do {
                        c /= i = i || ".5", h.style(t, e, c + l)
                    } while (i !== (i = s() / u) && 1 !== i && --a)
                }
                return n && (c = +c || +u || 0, o = n[1] ? c + (n[1] + 1) * n[2] : +n[2], r && (r.unit = l, r.start = c, r.end = o)), o
            }
            var Q = /^(?:checkbox|radio)$/i,
                X = /<([\w:-]+)/,
                Y = /^$|\/(?:java|ecma)script/i,
                J = {
                    option: [1, "<select multiple='multiple'>", "</select>"],
                    thead: [1, "<table>", "</table>"],
                    col: [2, "<table><colgroup>", "</colgroup></table>"],
                    tr: [2, "<table><tbody>", "</tbody></table>"],
                    td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
                    _default: [0, "", ""]
                };

            function Z(t, e) {
                var n = void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e || "*") : void 0 !== t.querySelectorAll ? t.querySelectorAll(e || "*") : [];
                return void 0 === e || e && h.nodeName(t, e) ? h.merge([t], n) : n
            }

            function tt(t, e) {
                for (var n = 0, r = t.length; n < r; n++) U.set(t[n], "globalEval", !e || U.get(e[n], "globalEval"))
            }
            J.optgroup = J.option, J.tbody = J.tfoot = J.colgroup = J.caption = J.thead, J.th = J.td;
            var et, nt, rt = /<|&#?\w+;/;

            function ot(t, e, n, r, o) {
                for (var i, a, s, u, l, c, d = e.createDocumentFragment(), p = [], _ = 0, f = t.length; _ < f; _++)
                    if ((i = t[_]) || 0 === i)
                        if ("object" === h.type(i)) h.merge(p, i.nodeType ? [i] : i);
                        else if (rt.test(i)) {
                    for (a = a || d.appendChild(e.createElement("div")), s = (X.exec(i) || ["", ""])[1].toLowerCase(), u = J[s] || J._default, a.innerHTML = u[1] + h.htmlPrefilter(i) + u[2], c = u[0]; c--;) a = a.lastChild;
                    h.merge(p, a.childNodes), (a = d.firstChild).textContent = ""
                } else p.push(e.createTextNode(i));
                for (d.textContent = "", _ = 0; i = p[_++];)
                    if (r && h.inArray(i, r) > -1) o && o.push(i);
                    else if (l = h.contains(i.ownerDocument, i), a = Z(d.appendChild(i), "script"), l && tt(a), n)
                    for (c = 0; i = a[c++];) Y.test(i.type || "") && n.push(i);
                return d
            }
            et = a.createDocumentFragment().appendChild(a.createElement("div")), (nt = a.createElement("input")).setAttribute("type", "radio"), nt.setAttribute("checked", "checked"), nt.setAttribute("name", "t"), et.appendChild(nt), f.checkClone = et.cloneNode(!0).cloneNode(!0).lastChild.checked, et.innerHTML = "<textarea>x</textarea>", f.noCloneChecked = !!et.cloneNode(!0).lastChild.defaultValue;
            var it = /^key/,
                at = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
                st = /^([^.]*)(?:\.(.+)|)/;

            function ut() {
                return !0
            }

            function lt() {
                return !1
            }

            function ct() {
                try {
                    return a.activeElement
                } catch (t) {}
            }

            function dt(t, e, n, r, o, i) {
                var a, s;
                if ("object" == typeof e) {
                    for (s in "string" != typeof n && (r = r || n, n = void 0), e) dt(t, s, n, r, e[s], i);
                    return t
                }
                if (null == r && null == o ? (o = n, r = n = void 0) : null == o && ("string" == typeof n ? (o = r, r = void 0) : (o = r, r = n, n = void 0)), !1 === o) o = lt;
                else if (!o) return t;
                return 1 === i && (a = o, (o = function(t) {
                    return h().off(t), a.apply(this, arguments)
                }).guid = a.guid || (a.guid = h.guid++)), t.each((function() {
                    h.event.add(this, e, o, r, n)
                }))
            }
            h.event = {
                global: {},
                add: function(t, e, n, r, o) {
                    var i, a, s, u, l, c, d, p, _, f, g, m = U.get(t);
                    if (m)
                        for (n.handler && (n = (i = n).handler, o = i.selector), n.guid || (n.guid = h.guid++), (u = m.events) || (u = m.events = {}), (a = m.handle) || (a = m.handle = function(e) {
                                return void 0 !== h && h.event.triggered !== e.type ? h.event.dispatch.apply(t, arguments) : void 0
                            }), l = (e = (e || "").match(R) || [""]).length; l--;) _ = g = (s = st.exec(e[l]) || [])[1], f = (s[2] || "").split(".").sort(), _ && (d = h.event.special[_] || {}, _ = (o ? d.delegateType : d.bindType) || _, d = h.event.special[_] || {}, c = h.extend({
                            type: _,
                            origType: g,
                            data: r,
                            handler: n,
                            guid: n.guid,
                            selector: o,
                            needsContext: o && h.expr.match.needsContext.test(o),
                            namespace: f.join(".")
                        }, i), (p = u[_]) || ((p = u[_] = []).delegateCount = 0, d.setup && !1 !== d.setup.call(t, r, f, a) || t.addEventListener && t.addEventListener(_, a)), d.add && (d.add.call(t, c), c.handler.guid || (c.handler.guid = n.guid)), o ? p.splice(p.delegateCount++, 0, c) : p.push(c), h.event.global[_] = !0)
                },
                remove: function(t, e, n, r, o) {
                    var i, a, s, u, l, c, d, p, _, f, g, m = U.hasData(t) && U.get(t);
                    if (m && (u = m.events)) {
                        for (l = (e = (e || "").match(R) || [""]).length; l--;)
                            if (_ = g = (s = st.exec(e[l]) || [])[1], f = (s[2] || "").split(".").sort(), _) {
                                for (d = h.event.special[_] || {}, p = u[_ = (r ? d.delegateType : d.bindType) || _] || [], s = s[2] && new RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)"), a = i = p.length; i--;) c = p[i], !o && g !== c.origType || n && n.guid !== c.guid || s && !s.test(c.namespace) || r && r !== c.selector && ("**" !== r || !c.selector) || (p.splice(i, 1), c.selector && p.delegateCount--, d.remove && d.remove.call(t, c));
                                a && !p.length && (d.teardown && !1 !== d.teardown.call(t, f, m.handle) || h.removeEvent(t, _, m.handle), delete u[_])
                            } else
                                for (_ in u) h.event.remove(t, _ + e[l], n, r, !0);
                        h.isEmptyObject(u) && U.remove(t, "handle events")
                    }
                },
                dispatch: function(t) {
                    t = h.event.fix(t);
                    var e, n, r, o, i, a = [],
                        u = s.call(arguments),
                        l = (U.get(this, "events") || {})[t.type] || [],
                        c = h.event.special[t.type] || {};
                    if (u[0] = t, t.delegateTarget = this, !c.preDispatch || !1 !== c.preDispatch.call(this, t)) {
                        for (a = h.event.handlers.call(this, t, l), e = 0;
                            (o = a[e++]) && !t.isPropagationStopped();)
                            for (t.currentTarget = o.elem, n = 0;
                                (i = o.handlers[n++]) && !t.isImmediatePropagationStopped();) t.rnamespace && !t.rnamespace.test(i.namespace) || (t.handleObj = i, t.data = i.data, void 0 !== (r = ((h.event.special[i.origType] || {}).handle || i.handler).apply(o.elem, u)) && !1 === (t.result = r) && (t.preventDefault(), t.stopPropagation()));
                        return c.postDispatch && c.postDispatch.call(this, t), t.result
                    }
                },
                handlers: function(t, e) {
                    var n, r, o, i, a = [],
                        s = e.delegateCount,
                        u = t.target;
                    if (s && u.nodeType && ("click" !== t.type || isNaN(t.button) || t.button < 1))
                        for (; u !== this; u = u.parentNode || this)
                            if (1 === u.nodeType && (!0 !== u.disabled || "click" !== t.type)) {
                                for (r = [], n = 0; n < s; n++) void 0 === r[o = (i = e[n]).selector + " "] && (r[o] = i.needsContext ? h(o, this).index(u) > -1 : h.find(o, this, null, [u]).length), r[o] && r.push(i);
                                r.length && a.push({
                                    elem: u,
                                    handlers: r
                                })
                            } return s < e.length && a.push({
                        elem: this,
                        handlers: e.slice(s)
                    }), a
                },
                props: "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
                fixHooks: {},
                keyHooks: {
                    props: "char charCode key keyCode".split(" "),
                    filter: function(t, e) {
                        return null == t.which && (t.which = null != e.charCode ? e.charCode : e.keyCode), t
                    }
                },
                mouseHooks: {
                    props: "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
                    filter: function(t, e) {
                        var n, r, o, i = e.button;
                        return null == t.pageX && null != e.clientX && (r = (n = t.target.ownerDocument || a).documentElement, o = n.body, t.pageX = e.clientX + (r && r.scrollLeft || o && o.scrollLeft || 0) - (r && r.clientLeft || o && o.clientLeft || 0), t.pageY = e.clientY + (r && r.scrollTop || o && o.scrollTop || 0) - (r && r.clientTop || o && o.clientTop || 0)), t.which || void 0 === i || (t.which = 1 & i ? 1 : 2 & i ? 3 : 4 & i ? 2 : 0), t
                    }
                },
                fix: function(t) {
                    if (t[h.expando]) return t;
                    var e, n, r, o = t.type,
                        i = t,
                        s = this.fixHooks[o];
                    for (s || (this.fixHooks[o] = s = at.test(o) ? this.mouseHooks : it.test(o) ? this.keyHooks : {}), r = s.props ? this.props.concat(s.props) : this.props, t = new h.Event(i), e = r.length; e--;) t[n = r[e]] = i[n];
                    return t.target || (t.target = a), 3 === t.target.nodeType && (t.target = t.target.parentNode), s.filter ? s.filter(t, i) : t
                },
                special: {
                    load: {
                        noBubble: !0
                    },
                    focus: {
                        trigger: function() {
                            if (this !== ct() && this.focus) return this.focus(), !1
                        },
                        delegateType: "focusin"
                    },
                    blur: {
                        trigger: function() {
                            if (this === ct() && this.blur) return this.blur(), !1
                        },
                        delegateType: "focusout"
                    },
                    click: {
                        trigger: function() {
                            if ("checkbox" === this.type && this.click && h.nodeName(this, "input")) return this.click(), !1
                        },
                        _default: function(t) {
                            return h.nodeName(t.target, "a")
                        }
                    },
                    beforeunload: {
                        postDispatch: function(t) {
                            void 0 !== t.result && t.originalEvent && (t.originalEvent.returnValue = t.result)
                        }
                    }
                }
            }, h.removeEvent = function(t, e, n) {
                t.removeEventListener && t.removeEventListener(e, n)
            }, h.Event = function(t, e) {
                if (!(this instanceof h.Event)) return new h.Event(t, e);
                t && t.type ? (this.originalEvent = t, this.type = t.type, this.isDefaultPrevented = t.defaultPrevented || void 0 === t.defaultPrevented && !1 === t.returnValue ? ut : lt) : this.type = t, e && h.extend(this, e), this.timeStamp = t && t.timeStamp || h.now(), this[h.expando] = !0
            }, h.Event.prototype = {
                constructor: h.Event,
                isDefaultPrevented: lt,
                isPropagationStopped: lt,
                isImmediatePropagationStopped: lt,
                isSimulated: !1,
                preventDefault: function() {
                    var t = this.originalEvent;
                    this.isDefaultPrevented = ut, t && !this.isSimulated && t.preventDefault()
                },
                stopPropagation: function() {
                    var t = this.originalEvent;
                    this.isPropagationStopped = ut, t && !this.isSimulated && t.stopPropagation()
                },
                stopImmediatePropagation: function() {
                    var t = this.originalEvent;
                    this.isImmediatePropagationStopped = ut, t && !this.isSimulated && t.stopImmediatePropagation(), this.stopPropagation()
                }
            }, h.each({
                mouseenter: "mouseover",
                mouseleave: "mouseout",
                pointerenter: "pointerover",
                pointerleave: "pointerout"
            }, (function(t, e) {
                h.event.special[t] = {
                    delegateType: e,
                    bindType: e,
                    handle: function(t) {
                        var n, r = this,
                            o = t.relatedTarget,
                            i = t.handleObj;
                        return o && (o === r || h.contains(r, o)) || (t.type = i.origType, n = i.handler.apply(this, arguments), t.type = e), n
                    }
                }
            })), h.fn.extend({
                on: function(t, e, n, r) {
                    return dt(this, t, e, n, r)
                },
                one: function(t, e, n, r) {
                    return dt(this, t, e, n, r, 1)
                },
                off: function(t, e, n) {
                    var r, o;
                    if (t && t.preventDefault && t.handleObj) return r = t.handleObj, h(t.delegateTarget).off(r.namespace ? r.origType + "." + r.namespace : r.origType, r.selector, r.handler), this;
                    if ("object" == typeof t) {
                        for (o in t) this.off(o, e, t[o]);
                        return this
                    }
                    return !1 !== e && "function" != typeof e || (n = e, e = void 0), !1 === n && (n = lt), this.each((function() {
                        h.event.remove(this, t, n, e)
                    }))
                }
            });
            var pt = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
                _t = /<script|<style|<link/i,
                ft = /checked\s*(?:[^=]|=\s*.checked.)/i,
                ht = /^true\/(.*)/,
                gt = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

            function mt(t, e) {
                return h.nodeName(t, "table") && h.nodeName(11 !== e.nodeType ? e : e.firstChild, "tr") ? t.getElementsByTagName("tbody")[0] || t.appendChild(t.ownerDocument.createElement("tbody")) : t
            }

            function yt(t) {
                return t.type = (null !== t.getAttribute("type")) + "/" + t.type, t
            }

            function Et(t) {
                var e = ht.exec(t.type);
                return e ? t.type = e[1] : t.removeAttribute("type"), t
            }

            function vt(t, e) {
                var n, r, o, i, a, s, u, l;
                if (1 === e.nodeType) {
                    if (U.hasData(t) && (i = U.access(t), a = U.set(e, i), l = i.events))
                        for (o in delete a.handle, a.events = {}, l)
                            for (n = 0, r = l[o].length; n < r; n++) h.event.add(e, o, l[o][n]);
                    S.hasData(t) && (s = S.access(t), u = h.extend({}, s), S.set(e, u))
                }
            }

            function bt(t, e, n, r) {
                e = u.apply([], e);
                var o, i, a, s, l, c, d = 0,
                    p = t.length,
                    _ = p - 1,
                    g = e[0],
                    m = h.isFunction(g);
                if (m || p > 1 && "string" == typeof g && !f.checkClone && ft.test(g)) return t.each((function(o) {
                    var i = t.eq(o);
                    m && (e[0] = g.call(this, o, i.html())), bt(i, e, n, r)
                }));
                if (p && (i = (o = ot(e, t[0].ownerDocument, !1, t, r)).firstChild, 1 === o.childNodes.length && (o = i), i || r)) {
                    for (s = (a = h.map(Z(o, "script"), yt)).length; d < p; d++) l = o, d !== _ && (l = h.clone(l, !0, !0), s && h.merge(a, Z(l, "script"))), n.call(t[d], l, d);
                    if (s)
                        for (c = a[a.length - 1].ownerDocument, h.map(a, Et), d = 0; d < s; d++) l = a[d], Y.test(l.type || "") && !U.access(l, "globalEval") && h.contains(c, l) && (l.src ? h._evalUrl && h._evalUrl(l.src) : h.globalEval(l.textContent.replace(gt, "")))
                }
                return t
            }

            function Ot(t, e, n) {
                for (var r, o = e ? h.filter(e, t) : t, i = 0; null != (r = o[i]); i++) n || 1 !== r.nodeType || h.cleanData(Z(r)), r.parentNode && (n && h.contains(r.ownerDocument, r) && tt(Z(r, "script")), r.parentNode.removeChild(r));
                return t
            }
            h.extend({
                htmlPrefilter: function(t) {
                    return t.replace(pt, "<$1></$2>")
                },
                clone: function(t, e, n) {
                    var r, o, i, a, s, u, l, c = t.cloneNode(!0),
                        d = h.contains(t.ownerDocument, t);
                    if (!(f.noCloneChecked || 1 !== t.nodeType && 11 !== t.nodeType || h.isXMLDoc(t)))
                        for (a = Z(c), r = 0, o = (i = Z(t)).length; r < o; r++) s = i[r], u = a[r], l = void 0, "input" === (l = u.nodeName.toLowerCase()) && Q.test(s.type) ? u.checked = s.checked : "input" !== l && "textarea" !== l || (u.defaultValue = s.defaultValue);
                    if (e)
                        if (n)
                            for (i = i || Z(t), a = a || Z(c), r = 0, o = i.length; r < o; r++) vt(i[r], a[r]);
                        else vt(t, c);
                    return (a = Z(c, "script")).length > 0 && tt(a, !d && Z(t, "script")), c
                },
                cleanData: function(t) {
                    for (var e, n, r, o = h.event.special, i = 0; void 0 !== (n = t[i]); i++)
                        if (W(n)) {
                            if (e = n[U.expando]) {
                                if (e.events)
                                    for (r in e.events) o[r] ? h.event.remove(n, r) : h.removeEvent(n, r, e.handle);
                                n[U.expando] = void 0
                            }
                            n[S.expando] && (n[S.expando] = void 0)
                        }
                }
            }), h.fn.extend({
                domManip: bt,
                detach: function(t) {
                    return Ot(this, t, !0)
                },
                remove: function(t) {
                    return Ot(this, t)
                },
                text: function(t) {
                    return B(this, (function(t) {
                        return void 0 === t ? h.text(this) : this.empty().each((function() {
                            1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = t)
                        }))
                    }), null, t, arguments.length)
                },
                append: function() {
                    return bt(this, arguments, (function(t) {
                        1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || mt(this, t).appendChild(t)
                    }))
                },
                prepend: function() {
                    return bt(this, arguments, (function(t) {
                        if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                            var e = mt(this, t);
                            e.insertBefore(t, e.firstChild)
                        }
                    }))
                },
                before: function() {
                    return bt(this, arguments, (function(t) {
                        this.parentNode && this.parentNode.insertBefore(t, this)
                    }))
                },
                after: function() {
                    return bt(this, arguments, (function(t) {
                        this.parentNode && this.parentNode.insertBefore(t, this.nextSibling)
                    }))
                },
                empty: function() {
                    for (var t, e = 0; null != (t = this[e]); e++) 1 === t.nodeType && (h.cleanData(Z(t, !1)), t.textContent = "");
                    return this
                },
                clone: function(t, e) {
                    return t = null != t && t, e = null == e ? t : e, this.map((function() {
                        return h.clone(this, t, e)
                    }))
                },
                html: function(t) {
                    return B(this, (function(t) {
                        var e = this[0] || {},
                            n = 0,
                            r = this.length;
                        if (void 0 === t && 1 === e.nodeType) return e.innerHTML;
                        if ("string" == typeof t && !_t.test(t) && !J[(X.exec(t) || ["", ""])[1].toLowerCase()]) {
                            t = h.htmlPrefilter(t);
                            try {
                                for (; n < r; n++) 1 === (e = this[n] || {}).nodeType && (h.cleanData(Z(e, !1)), e.innerHTML = t);
                                e = 0
                            } catch (t) {}
                        }
                        e && this.empty().append(t)
                    }), null, t, arguments.length)
                },
                replaceWith: function() {
                    var t = [];
                    return bt(this, arguments, (function(e) {
                        var n = this.parentNode;
                        h.inArray(this, t) < 0 && (h.cleanData(Z(this)), n && n.replaceChild(e, this))
                    }), t)
                }
            }), h.each({
                appendTo: "append",
                prependTo: "prepend",
                insertBefore: "before",
                insertAfter: "after",
                replaceAll: "replaceWith"
            }, (function(t, e) {
                h.fn[t] = function(t) {
                    for (var n, r = [], o = h(t), i = o.length - 1, a = 0; a <= i; a++) n = a === i ? this : this.clone(!0), h(o[a])[e](n), l.apply(r, n.get());
                    return this.pushStack(r)
                }
            }));
            var Dt, Pt = {
                HTML: "block",
                BODY: "block"
            };

            function Mt(t, e) {
                var n = h(e.createElement(t)).appendTo(e.body),
                    r = h.css(n[0], "display");
                return n.detach(), r
            }

            function Tt(t) {
                var e = a,
                    n = Pt[t];
                return n || ("none" !== (n = Mt(t, e)) && n || ((e = (Dt = (Dt || h("<iframe frameborder='0' width='0' height='0'/>")).appendTo(e.documentElement))[0].contentDocument).write(), e.close(), n = Mt(t, e), Dt.detach()), Pt[t] = n), n
            }
            var wt = /^margin/,
                Ct = new RegExp("^(" + H + ")(?!px)[a-z%]+$", "i"),
                xt = function(t) {
                    var e = t.ownerDocument.defaultView;
                    return e && e.opener || (e = n), e.getComputedStyle(t)
                },
                At = function(t, e, n, r) {
                    var o, i, a = {};
                    for (i in e) a[i] = t.style[i], t.style[i] = e[i];
                    for (i in o = n.apply(t, r || []), e) t.style[i] = a[i];
                    return o
                },
                qt = a.documentElement;

            function jt(t, e, n) {
                var r, o, i, a, s = t.style;
                return "" !== (a = (n = n || xt(t)) ? n.getPropertyValue(e) || n[e] : void 0) && void 0 !== a || h.contains(t.ownerDocument, t) || (a = h.style(t, e)), n && !f.pixelMarginRight() && Ct.test(a) && wt.test(e) && (r = s.width, o = s.minWidth, i = s.maxWidth, s.minWidth = s.maxWidth = s.width = a, a = n.width, s.width = r, s.minWidth = o, s.maxWidth = i), void 0 !== a ? a + "" : a
            }

            function Lt(t, e) {
                return {
                    get: function() {
                        if (!t()) return (this.get = e).apply(this, arguments);
                        delete this.get
                    }
                }
            }! function() {
                var t, e, r, o, i = a.createElement("div"),
                    s = a.createElement("div");

                function u() {
                    s.style.cssText = "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%", s.innerHTML = "", qt.appendChild(i);
                    var a = n.getComputedStyle(s);
                    t = "1%" !== a.top, o = "2px" === a.marginLeft, e = "4px" === a.width, s.style.marginRight = "50%", r = "4px" === a.marginRight, qt.removeChild(i)
                }
                s.style && (s.style.backgroundClip = "content-box", s.cloneNode(!0).style.backgroundClip = "", f.clearCloneStyle = "content-box" === s.style.backgroundClip, i.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute", i.appendChild(s), h.extend(f, {
                    pixelPosition: function() {
                        return u(), t
                    },
                    boxSizingReliable: function() {
                        return null == e && u(), e
                    },
                    pixelMarginRight: function() {
                        return null == e && u(), r
                    },
                    reliableMarginLeft: function() {
                        return null == e && u(), o
                    },
                    reliableMarginRight: function() {
                        var t, e = s.appendChild(a.createElement("div"));
                        return e.style.cssText = s.style.cssText = "-webkit-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0", e.style.marginRight = e.style.width = "0", s.style.width = "1px", qt.appendChild(i), t = !parseFloat(n.getComputedStyle(e).marginRight), qt.removeChild(i), s.removeChild(e), t
                    }
                }))
            }();
            var Rt = /^(none|table(?!-c[ea]).+)/,
                It = {
                    position: "absolute",
                    visibility: "hidden",
                    display: "block"
                },
                Bt = {
                    letterSpacing: "0",
                    fontWeight: "400"
                },
                Wt = ["Webkit", "O", "Moz", "ms"],
                kt = a.createElement("div").style;

            function Ut(t) {
                if (t in kt) return t;
                for (var e = t[0].toUpperCase() + t.slice(1), n = Wt.length; n--;)
                    if ((t = Wt[n] + e) in kt) return t
            }

            function St(t, e, n) {
                var r = $.exec(e);
                return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || "px") : e
            }

            function Kt(t, e, n, r, o) {
                for (var i = n === (r ? "border" : "content") ? 4 : "width" === e ? 1 : 0, a = 0; i < 4; i += 2) "margin" === n && (a += h.css(t, n + V[i], !0, o)), r ? ("content" === n && (a -= h.css(t, "padding" + V[i], !0, o)), "margin" !== n && (a -= h.css(t, "border" + V[i] + "Width", !0, o))) : (a += h.css(t, "padding" + V[i], !0, o), "padding" !== n && (a += h.css(t, "border" + V[i] + "Width", !0, o)));
                return a
            }

            function Nt(t, e, n) {
                var r = !0,
                    o = "width" === e ? t.offsetWidth : t.offsetHeight,
                    i = xt(t),
                    a = "border-box" === h.css(t, "boxSizing", !1, i);
                if (o <= 0 || null == o) {
                    if (((o = jt(t, e, i)) < 0 || null == o) && (o = t.style[e]), Ct.test(o)) return o;
                    r = a && (f.boxSizingReliable() || o === t.style[e]), o = parseFloat(o) || 0
                }
                return o + Kt(t, e, n || (a ? "border" : "content"), r, i) + "px"
            }

            function Ft(t, e) {
                for (var n, r, o, i = [], a = 0, s = t.length; a < s; a++)(r = t[a]).style && (i[a] = U.get(r, "olddisplay"), n = r.style.display, e ? (i[a] || "none" !== n || (r.style.display = ""), "" === r.style.display && z(r) && (i[a] = U.access(r, "olddisplay", Tt(r.nodeName)))) : (o = z(r), "none" === n && o || U.set(r, "olddisplay", o ? n : h.css(r, "display"))));
                for (a = 0; a < s; a++)(r = t[a]).style && (e && "none" !== r.style.display && "" !== r.style.display || (r.style.display = e ? i[a] || "" : "none"));
                return t
            }

            function Ht(t, e, n, r, o) {
                return new Ht.prototype.init(t, e, n, r, o)
            }
            h.extend({
                cssHooks: {
                    opacity: {
                        get: function(t, e) {
                            if (e) {
                                var n = jt(t, "opacity");
                                return "" === n ? "1" : n
                            }
                        }
                    }
                },
                cssNumber: {
                    animationIterationCount: !0,
                    columnCount: !0,
                    fillOpacity: !0,
                    flexGrow: !0,
                    flexShrink: !0,
                    fontWeight: !0,
                    lineHeight: !0,
                    opacity: !0,
                    order: !0,
                    orphans: !0,
                    widows: !0,
                    zIndex: !0,
                    zoom: !0
                },
                cssProps: {
                    float: "cssFloat"
                },
                style: function(t, e, n, r) {
                    if (t && 3 !== t.nodeType && 8 !== t.nodeType && t.style) {
                        var o, i, a, s = h.camelCase(e),
                            u = t.style;
                        if (e = h.cssProps[s] || (h.cssProps[s] = Ut(s) || s), a = h.cssHooks[e] || h.cssHooks[s], void 0 === n) return a && "get" in a && void 0 !== (o = a.get(t, !1, r)) ? o : u[e];
                        "string" == (i = typeof n) && (o = $.exec(n)) && o[1] && (n = G(t, e, o), i = "number"), null != n && n == n && ("number" === i && (n += o && o[3] || (h.cssNumber[s] ? "" : "px")), f.clearCloneStyle || "" !== n || 0 !== e.indexOf("background") || (u[e] = "inherit"), a && "set" in a && void 0 === (n = a.set(t, n, r)) || (u[e] = n))
                    }
                },
                css: function(t, e, n, r) {
                    var o, i, a, s = h.camelCase(e);
                    return e = h.cssProps[s] || (h.cssProps[s] = Ut(s) || s), (a = h.cssHooks[e] || h.cssHooks[s]) && "get" in a && (o = a.get(t, !0, n)), void 0 === o && (o = jt(t, e, r)), "normal" === o && e in Bt && (o = Bt[e]), "" === n || n ? (i = parseFloat(o), !0 === n || isFinite(i) ? i || 0 : o) : o
                }
            }), h.each(["height", "width"], (function(t, e) {
                h.cssHooks[e] = {
                    get: function(t, n, r) {
                        if (n) return Rt.test(h.css(t, "display")) && 0 === t.offsetWidth ? At(t, It, (function() {
                            return Nt(t, e, r)
                        })) : Nt(t, e, r)
                    },
                    set: function(t, n, r) {
                        var o, i = r && xt(t),
                            a = r && Kt(t, e, r, "border-box" === h.css(t, "boxSizing", !1, i), i);
                        return a && (o = $.exec(n)) && "px" !== (o[3] || "px") && (t.style[e] = n, n = h.css(t, e)), St(0, n, a)
                    }
                }
            })), h.cssHooks.marginLeft = Lt(f.reliableMarginLeft, (function(t, e) {
                if (e) return (parseFloat(jt(t, "marginLeft")) || t.getBoundingClientRect().left - At(t, {
                    marginLeft: 0
                }, (function() {
                    return t.getBoundingClientRect().left
                }))) + "px"
            })), h.cssHooks.marginRight = Lt(f.reliableMarginRight, (function(t, e) {
                if (e) return At(t, {
                    display: "inline-block"
                }, jt, [t, "marginRight"])
            })), h.each({
                margin: "",
                padding: "",
                border: "Width"
            }, (function(t, e) {
                h.cssHooks[t + e] = {
                    expand: function(n) {
                        for (var r = 0, o = {}, i = "string" == typeof n ? n.split(" ") : [n]; r < 4; r++) o[t + V[r] + e] = i[r] || i[r - 2] || i[0];
                        return o
                    }
                }, wt.test(t) || (h.cssHooks[t + e].set = St)
            })), h.fn.extend({
                css: function(t, e) {
                    return B(this, (function(t, e, n) {
                        var r, o, i = {},
                            a = 0;
                        if (h.isArray(e)) {
                            for (r = xt(t), o = e.length; a < o; a++) i[e[a]] = h.css(t, e[a], !1, r);
                            return i
                        }
                        return void 0 !== n ? h.style(t, e, n) : h.css(t, e)
                    }), t, e, arguments.length > 1)
                },
                show: function() {
                    return Ft(this, !0)
                },
                hide: function() {
                    return Ft(this)
                },
                toggle: function(t) {
                    return "boolean" == typeof t ? t ? this.show() : this.hide() : this.each((function() {
                        z(this) ? h(this).show() : h(this).hide()
                    }))
                }
            }), h.Tween = Ht, Ht.prototype = {
                constructor: Ht,
                init: function(t, e, n, r, o, i) {
                    this.elem = t, this.prop = n, this.easing = o || h.easing._default, this.options = e, this.start = this.now = this.cur(), this.end = r, this.unit = i || (h.cssNumber[n] ? "" : "px")
                },
                cur: function() {
                    var t = Ht.propHooks[this.prop];
                    return t && t.get ? t.get(this) : Ht.propHooks._default.get(this)
                },
                run: function(t) {
                    var e, n = Ht.propHooks[this.prop];
                    return this.options.duration ? this.pos = e = h.easing[this.easing](t, this.options.duration * t, 0, 1, this.options.duration) : this.pos = e = t, this.now = (this.end - this.start) * e + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), n && n.set ? n.set(this) : Ht.propHooks._default.set(this), this
                }
            }, Ht.prototype.init.prototype = Ht.prototype, Ht.propHooks = {
                _default: {
                    get: function(t) {
                        var e;
                        return 1 !== t.elem.nodeType || null != t.elem[t.prop] && null == t.elem.style[t.prop] ? t.elem[t.prop] : (e = h.css(t.elem, t.prop, "")) && "auto" !== e ? e : 0
                    },
                    set: function(t) {
                        h.fx.step[t.prop] ? h.fx.step[t.prop](t) : 1 !== t.elem.nodeType || null == t.elem.style[h.cssProps[t.prop]] && !h.cssHooks[t.prop] ? t.elem[t.prop] = t.now : h.style(t.elem, t.prop, t.now + t.unit)
                    }
                }
            }, Ht.propHooks.scrollTop = Ht.propHooks.scrollLeft = {
                set: function(t) {
                    t.elem.nodeType && t.elem.parentNode && (t.elem[t.prop] = t.now)
                }
            }, h.easing = {
                linear: function(t) {
                    return t
                },
                swing: function(t) {
                    return .5 - Math.cos(t * Math.PI) / 2
                },
                _default: "swing"
            }, h.fx = Ht.prototype.init, h.fx.step = {};
            var $t, Vt, zt = /^(?:toggle|show|hide)$/,
                Gt = /queueHooks$/;

            function Qt() {
                return n.setTimeout((function() {
                    $t = void 0
                })), $t = h.now()
            }

            function Xt(t, e) {
                var n, r = 0,
                    o = {
                        height: t
                    };
                for (e = e ? 1 : 0; r < 4; r += 2 - e) o["margin" + (n = V[r])] = o["padding" + n] = t;
                return e && (o.opacity = o.width = t), o
            }

            function Yt(t, e, n) {
                for (var r, o = (Jt.tweeners[e] || []).concat(Jt.tweeners["*"]), i = 0, a = o.length; i < a; i++)
                    if (r = o[i].call(n, e, t)) return r
            }

            function Jt(t, e, n) {
                var r, o, i = 0,
                    a = Jt.prefilters.length,
                    s = h.Deferred().always((function() {
                        delete u.elem
                    })),
                    u = function() {
                        if (o) return !1;
                        for (var e = $t || Qt(), n = Math.max(0, l.startTime + l.duration - e), r = 1 - (n / l.duration || 0), i = 0, a = l.tweens.length; i < a; i++) l.tweens[i].run(r);
                        return s.notifyWith(t, [l, r, n]), r < 1 && a ? n : (s.resolveWith(t, [l]), !1)
                    },
                    l = s.promise({
                        elem: t,
                        props: h.extend({}, e),
                        opts: h.extend(!0, {
                            specialEasing: {},
                            easing: h.easing._default
                        }, n),
                        originalProperties: e,
                        originalOptions: n,
                        startTime: $t || Qt(),
                        duration: n.duration,
                        tweens: [],
                        createTween: function(e, n) {
                            var r = h.Tween(t, l.opts, e, n, l.opts.specialEasing[e] || l.opts.easing);
                            return l.tweens.push(r), r
                        },
                        stop: function(e) {
                            var n = 0,
                                r = e ? l.tweens.length : 0;
                            if (o) return this;
                            for (o = !0; n < r; n++) l.tweens[n].run(1);
                            return e ? (s.notifyWith(t, [l, 1, 0]), s.resolveWith(t, [l, e])) : s.rejectWith(t, [l, e]), this
                        }
                    }),
                    c = l.props;
                for (function(t, e) {
                        var n, r, o, i, a;
                        for (n in t)
                            if (o = e[r = h.camelCase(n)], i = t[n], h.isArray(i) && (o = i[1], i = t[n] = i[0]), n !== r && (t[r] = i, delete t[n]), (a = h.cssHooks[r]) && "expand" in a)
                                for (n in i = a.expand(i), delete t[r], i) n in t || (t[n] = i[n], e[n] = o);
                            else e[r] = o
                    }(c, l.opts.specialEasing); i < a; i++)
                    if (r = Jt.prefilters[i].call(l, t, c, l.opts)) return h.isFunction(r.stop) && (h._queueHooks(l.elem, l.opts.queue).stop = h.proxy(r.stop, r)), r;
                return h.map(c, Yt, l), h.isFunction(l.opts.start) && l.opts.start.call(t, l), h.fx.timer(h.extend(u, {
                    elem: t,
                    anim: l,
                    queue: l.opts.queue
                })), l.progress(l.opts.progress).done(l.opts.done, l.opts.complete).fail(l.opts.fail).always(l.opts.always)
            }
            h.Animation = h.extend(Jt, {
                    tweeners: {
                        "*": [function(t, e) {
                            var n = this.createTween(t, e);
                            return G(n.elem, t, $.exec(e), n), n
                        }]
                    },
                    tweener: function(t, e) {
                        h.isFunction(t) ? (e = t, t = ["*"]) : t = t.match(R);
                        for (var n, r = 0, o = t.length; r < o; r++) n = t[r], Jt.tweeners[n] = Jt.tweeners[n] || [], Jt.tweeners[n].unshift(e)
                    },
                    prefilters: [function(t, e, n) {
                        var r, o, i, a, s, u, l, c = this,
                            d = {},
                            p = t.style,
                            _ = t.nodeType && z(t),
                            f = U.get(t, "fxshow");
                        for (r in n.queue || (null == (s = h._queueHooks(t, "fx")).unqueued && (s.unqueued = 0, u = s.empty.fire, s.empty.fire = function() {
                                s.unqueued || u()
                            }), s.unqueued++, c.always((function() {
                                c.always((function() {
                                    s.unqueued--, h.queue(t, "fx").length || s.empty.fire()
                                }))
                            }))), 1 === t.nodeType && ("height" in e || "width" in e) && (n.overflow = [p.overflow, p.overflowX, p.overflowY], "inline" === ("none" === (l = h.css(t, "display")) ? U.get(t, "olddisplay") || Tt(t.nodeName) : l) && "none" === h.css(t, "float") && (p.display = "inline-block")), n.overflow && (p.overflow = "hidden", c.always((function() {
                                p.overflow = n.overflow[0], p.overflowX = n.overflow[1], p.overflowY = n.overflow[2]
                            }))), e)
                            if (o = e[r], zt.exec(o)) {
                                if (delete e[r], i = i || "toggle" === o, o === (_ ? "hide" : "show")) {
                                    if ("show" !== o || !f || void 0 === f[r]) continue;
                                    _ = !0
                                }
                                d[r] = f && f[r] || h.style(t, r)
                            } else l = void 0;
                        if (h.isEmptyObject(d)) "inline" === ("none" === l ? Tt(t.nodeName) : l) && (p.display = l);
                        else
                            for (r in f ? "hidden" in f && (_ = f.hidden) : f = U.access(t, "fxshow", {}), i && (f.hidden = !_), _ ? h(t).show() : c.done((function() {
                                    h(t).hide()
                                })), c.done((function() {
                                    var e;
                                    for (e in U.remove(t, "fxshow"), d) h.style(t, e, d[e])
                                })), d) a = Yt(_ ? f[r] : 0, r, c), r in f || (f[r] = a.start, _ && (a.end = a.start, a.start = "width" === r || "height" === r ? 1 : 0))
                    }],
                    prefilter: function(t, e) {
                        e ? Jt.prefilters.unshift(t) : Jt.prefilters.push(t)
                    }
                }), h.speed = function(t, e, n) {
                    var r = t && "object" == typeof t ? h.extend({}, t) : {
                        complete: n || !n && e || h.isFunction(t) && t,
                        duration: t,
                        easing: n && e || e && !h.isFunction(e) && e
                    };
                    return r.duration = h.fx.off ? 0 : "number" == typeof r.duration ? r.duration : r.duration in h.fx.speeds ? h.fx.speeds[r.duration] : h.fx.speeds._default, null != r.queue && !0 !== r.queue || (r.queue = "fx"), r.old = r.complete, r.complete = function() {
                        h.isFunction(r.old) && r.old.call(this), r.queue && h.dequeue(this, r.queue)
                    }, r
                }, h.fn.extend({
                    fadeTo: function(t, e, n, r) {
                        return this.filter(z).css("opacity", 0).show().end().animate({
                            opacity: e
                        }, t, n, r)
                    },
                    animate: function(t, e, n, r) {
                        var o = h.isEmptyObject(t),
                            i = h.speed(e, n, r),
                            a = function() {
                                var e = Jt(this, h.extend({}, t), i);
                                (o || U.get(this, "finish")) && e.stop(!0)
                            };
                        return a.finish = a, o || !1 === i.queue ? this.each(a) : this.queue(i.queue, a)
                    },
                    stop: function(t, e, n) {
                        var r = function(t) {
                            var e = t.stop;
                            delete t.stop, e(n)
                        };
                        return "string" != typeof t && (n = e, e = t, t = void 0), e && !1 !== t && this.queue(t || "fx", []), this.each((function() {
                            var e = !0,
                                o = null != t && t + "queueHooks",
                                i = h.timers,
                                a = U.get(this);
                            if (o) a[o] && a[o].stop && r(a[o]);
                            else
                                for (o in a) a[o] && a[o].stop && Gt.test(o) && r(a[o]);
                            for (o = i.length; o--;) i[o].elem !== this || null != t && i[o].queue !== t || (i[o].anim.stop(n), e = !1, i.splice(o, 1));
                            !e && n || h.dequeue(this, t)
                        }))
                    },
                    finish: function(t) {
                        return !1 !== t && (t = t || "fx"), this.each((function() {
                            var e, n = U.get(this),
                                r = n[t + "queue"],
                                o = n[t + "queueHooks"],
                                i = h.timers,
                                a = r ? r.length : 0;
                            for (n.finish = !0, h.queue(this, t, []), o && o.stop && o.stop.call(this, !0), e = i.length; e--;) i[e].elem === this && i[e].queue === t && (i[e].anim.stop(!0), i.splice(e, 1));
                            for (e = 0; e < a; e++) r[e] && r[e].finish && r[e].finish.call(this);
                            delete n.finish
                        }))
                    }
                }), h.each(["toggle", "show", "hide"], (function(t, e) {
                    var n = h.fn[e];
                    h.fn[e] = function(t, r, o) {
                        return null == t || "boolean" == typeof t ? n.apply(this, arguments) : this.animate(Xt(e, !0), t, r, o)
                    }
                })), h.each({
                    slideDown: Xt("show"),
                    slideUp: Xt("hide"),
                    slideToggle: Xt("toggle"),
                    fadeIn: {
                        opacity: "show"
                    },
                    fadeOut: {
                        opacity: "hide"
                    },
                    fadeToggle: {
                        opacity: "toggle"
                    }
                }, (function(t, e) {
                    h.fn[t] = function(t, n, r) {
                        return this.animate(e, t, n, r)
                    }
                })), h.timers = [], h.fx.tick = function() {
                    var t, e = 0,
                        n = h.timers;
                    for ($t = h.now(); e < n.length; e++)(t = n[e])() || n[e] !== t || n.splice(e--, 1);
                    n.length || h.fx.stop(), $t = void 0
                }, h.fx.timer = function(t) {
                    h.timers.push(t), t() ? h.fx.start() : h.timers.pop()
                }, h.fx.interval = 13, h.fx.start = function() {
                    Vt || (Vt = n.setInterval(h.fx.tick, h.fx.interval))
                }, h.fx.stop = function() {
                    n.clearInterval(Vt), Vt = null
                }, h.fx.speeds = {
                    slow: 600,
                    fast: 200,
                    _default: 400
                }, h.fn.delay = function(t, e) {
                    return t = h.fx && h.fx.speeds[t] || t, e = e || "fx", this.queue(e, (function(e, r) {
                        var o = n.setTimeout(e, t);
                        r.stop = function() {
                            n.clearTimeout(o)
                        }
                    }))
                },
                function() {
                    var t = a.createElement("input"),
                        e = a.createElement("select"),
                        n = e.appendChild(a.createElement("option"));
                    t.type = "checkbox", f.checkOn = "" !== t.value, f.optSelected = n.selected, e.disabled = !0, f.optDisabled = !n.disabled, (t = a.createElement("input")).value = "t", t.type = "radio", f.radioValue = "t" === t.value
                }();
            var Zt, te = h.expr.attrHandle;
            h.fn.extend({
                attr: function(t, e) {
                    return B(this, h.attr, t, e, arguments.length > 1)
                },
                removeAttr: function(t) {
                    return this.each((function() {
                        h.removeAttr(this, t)
                    }))
                }
            }), h.extend({
                attr: function(t, e, n) {
                    var r, o, i = t.nodeType;
                    if (3 !== i && 8 !== i && 2 !== i) return void 0 === t.getAttribute ? h.prop(t, e, n) : (1 === i && h.isXMLDoc(t) || (e = e.toLowerCase(), o = h.attrHooks[e] || (h.expr.match.bool.test(e) ? Zt : void 0)), void 0 !== n ? null === n ? void h.removeAttr(t, e) : o && "set" in o && void 0 !== (r = o.set(t, n, e)) ? r : (t.setAttribute(e, n + ""), n) : o && "get" in o && null !== (r = o.get(t, e)) ? r : null == (r = h.find.attr(t, e)) ? void 0 : r)
                },
                attrHooks: {
                    type: {
                        set: function(t, e) {
                            if (!f.radioValue && "radio" === e && h.nodeName(t, "input")) {
                                var n = t.value;
                                return t.setAttribute("type", e), n && (t.value = n), e
                            }
                        }
                    }
                },
                removeAttr: function(t, e) {
                    var n, r, o = 0,
                        i = e && e.match(R);
                    if (i && 1 === t.nodeType)
                        for (; n = i[o++];) r = h.propFix[n] || n, h.expr.match.bool.test(n) && (t[r] = !1), t.removeAttribute(n)
                }
            }), Zt = {
                set: function(t, e, n) {
                    return !1 === e ? h.removeAttr(t, n) : t.setAttribute(n, n), n
                }
            }, h.each(h.expr.match.bool.source.match(/\w+/g), (function(t, e) {
                var n = te[e] || h.find.attr;
                te[e] = function(t, e, r) {
                    var o, i;
                    return r || (i = te[e], te[e] = o, o = null != n(t, e, r) ? e.toLowerCase() : null, te[e] = i), o
                }
            }));
            var ee = /^(?:input|select|textarea|button)$/i,
                ne = /^(?:a|area)$/i;
            h.fn.extend({
                prop: function(t, e) {
                    return B(this, h.prop, t, e, arguments.length > 1)
                },
                removeProp: function(t) {
                    return this.each((function() {
                        delete this[h.propFix[t] || t]
                    }))
                }
            }), h.extend({
                prop: function(t, e, n) {
                    var r, o, i = t.nodeType;
                    if (3 !== i && 8 !== i && 2 !== i) return 1 === i && h.isXMLDoc(t) || (e = h.propFix[e] || e, o = h.propHooks[e]), void 0 !== n ? o && "set" in o && void 0 !== (r = o.set(t, n, e)) ? r : t[e] = n : o && "get" in o && null !== (r = o.get(t, e)) ? r : t[e]
                },
                propHooks: {
                    tabIndex: {
                        get: function(t) {
                            var e = h.find.attr(t, "tabindex");
                            return e ? parseInt(e, 10) : ee.test(t.nodeName) || ne.test(t.nodeName) && t.href ? 0 : -1
                        }
                    }
                },
                propFix: {
                    for: "htmlFor",
                    class: "className"
                }
            }), f.optSelected || (h.propHooks.selected = {
                get: function(t) {
                    var e = t.parentNode;
                    return e && e.parentNode && e.parentNode.selectedIndex, null
                },
                set: function(t) {
                    var e = t.parentNode;
                    e && (e.selectedIndex, e.parentNode && e.parentNode.selectedIndex)
                }
            }), h.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], (function() {
                h.propFix[this.toLowerCase()] = this
            }));
            var re = /[\t\r\n\f]/g;

            function oe(t) {
                return t.getAttribute && t.getAttribute("class") || ""
            }
            h.fn.extend({
                addClass: function(t) {
                    var e, n, r, o, i, a, s, u = 0;
                    if (h.isFunction(t)) return this.each((function(e) {
                        h(this).addClass(t.call(this, e, oe(this)))
                    }));
                    if ("string" == typeof t && t)
                        for (e = t.match(R) || []; n = this[u++];)
                            if (o = oe(n), r = 1 === n.nodeType && (" " + o + " ").replace(re, " ")) {
                                for (a = 0; i = e[a++];) r.indexOf(" " + i + " ") < 0 && (r += i + " ");
                                o !== (s = h.trim(r)) && n.setAttribute("class", s)
                            } return this
                },
                removeClass: function(t) {
                    var e, n, r, o, i, a, s, u = 0;
                    if (h.isFunction(t)) return this.each((function(e) {
                        h(this).removeClass(t.call(this, e, oe(this)))
                    }));
                    if (!arguments.length) return this.attr("class", "");
                    if ("string" == typeof t && t)
                        for (e = t.match(R) || []; n = this[u++];)
                            if (o = oe(n), r = 1 === n.nodeType && (" " + o + " ").replace(re, " ")) {
                                for (a = 0; i = e[a++];)
                                    for (; r.indexOf(" " + i + " ") > -1;) r = r.replace(" " + i + " ", " ");
                                o !== (s = h.trim(r)) && n.setAttribute("class", s)
                            } return this
                },
                toggleClass: function(t, e) {
                    var n = typeof t;
                    return "boolean" == typeof e && "string" === n ? e ? this.addClass(t) : this.removeClass(t) : h.isFunction(t) ? this.each((function(n) {
                        h(this).toggleClass(t.call(this, n, oe(this), e), e)
                    })) : this.each((function() {
                        var e, r, o, i;
                        if ("string" === n)
                            for (r = 0, o = h(this), i = t.match(R) || []; e = i[r++];) o.hasClass(e) ? o.removeClass(e) : o.addClass(e);
                        else void 0 !== t && "boolean" !== n || ((e = oe(this)) && U.set(this, "__className__", e), this.setAttribute && this.setAttribute("class", e || !1 === t ? "" : U.get(this, "__className__") || ""))
                    }))
                },
                hasClass: function(t) {
                    var e, n, r = 0;
                    for (e = " " + t + " "; n = this[r++];)
                        if (1 === n.nodeType && (" " + oe(n) + " ").replace(re, " ").indexOf(e) > -1) return !0;
                    return !1
                }
            });
            var ie = /\r/g,
                ae = /[\x20\t\r\n\f]+/g;
            h.fn.extend({
                val: function(t) {
                    var e, n, r, o = this[0];
                    return arguments.length ? (r = h.isFunction(t), this.each((function(n) {
                        var o;
                        1 === this.nodeType && (null == (o = r ? t.call(this, n, h(this).val()) : t) ? o = "" : "number" == typeof o ? o += "" : h.isArray(o) && (o = h.map(o, (function(t) {
                            return null == t ? "" : t + ""
                        }))), (e = h.valHooks[this.type] || h.valHooks[this.nodeName.toLowerCase()]) && "set" in e && void 0 !== e.set(this, o, "value") || (this.value = o))
                    }))) : o ? (e = h.valHooks[o.type] || h.valHooks[o.nodeName.toLowerCase()]) && "get" in e && void 0 !== (n = e.get(o, "value")) ? n : "string" == typeof(n = o.value) ? n.replace(ie, "") : null == n ? "" : n : void 0
                }
            }), h.extend({
                valHooks: {
                    option: {
                        get: function(t) {
                            var e = h.find.attr(t, "value");
                            return null != e ? e : h.trim(h.text(t)).replace(ae, " ")
                        }
                    },
                    select: {
                        get: function(t) {
                            for (var e, n, r = t.options, o = t.selectedIndex, i = "select-one" === t.type || o < 0, a = i ? null : [], s = i ? o + 1 : r.length, u = o < 0 ? s : i ? o : 0; u < s; u++)
                                if (((n = r[u]).selected || u === o) && (f.optDisabled ? !n.disabled : null === n.getAttribute("disabled")) && (!n.parentNode.disabled || !h.nodeName(n.parentNode, "optgroup"))) {
                                    if (e = h(n).val(), i) return e;
                                    a.push(e)
                                } return a
                        },
                        set: function(t, e) {
                            for (var n, r, o = t.options, i = h.makeArray(e), a = o.length; a--;)((r = o[a]).selected = h.inArray(h.valHooks.option.get(r), i) > -1) && (n = !0);
                            return n || (t.selectedIndex = -1), i
                        }
                    }
                }
            }), h.each(["radio", "checkbox"], (function() {
                h.valHooks[this] = {
                    set: function(t, e) {
                        if (h.isArray(e)) return t.checked = h.inArray(h(t).val(), e) > -1
                    }
                }, f.checkOn || (h.valHooks[this].get = function(t) {
                    return null === t.getAttribute("value") ? "on" : t.value
                })
            }));
            var se = /^(?:focusinfocus|focusoutblur)$/;
            h.extend(h.event, {
                trigger: function(t, e, r, o) {
                    var i, s, u, l, c, d, p, f = [r || a],
                        g = _.call(t, "type") ? t.type : t,
                        m = _.call(t, "namespace") ? t.namespace.split(".") : [];
                    if (s = u = r = r || a, 3 !== r.nodeType && 8 !== r.nodeType && !se.test(g + h.event.triggered) && (g.indexOf(".") > -1 && (m = g.split("."), g = m.shift(), m.sort()), c = g.indexOf(":") < 0 && "on" + g, (t = t[h.expando] ? t : new h.Event(g, "object" == typeof t && t)).isTrigger = o ? 2 : 3, t.namespace = m.join("."), t.rnamespace = t.namespace ? new RegExp("(^|\\.)" + m.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, t.result = void 0, t.target || (t.target = r), e = null == e ? [t] : h.makeArray(e, [t]), p = h.event.special[g] || {}, o || !p.trigger || !1 !== p.trigger.apply(r, e))) {
                        if (!o && !p.noBubble && !h.isWindow(r)) {
                            for (l = p.delegateType || g, se.test(l + g) || (s = s.parentNode); s; s = s.parentNode) f.push(s), u = s;
                            u === (r.ownerDocument || a) && f.push(u.defaultView || u.parentWindow || n)
                        }
                        for (i = 0;
                            (s = f[i++]) && !t.isPropagationStopped();) t.type = i > 1 ? l : p.bindType || g, (d = (U.get(s, "events") || {})[t.type] && U.get(s, "handle")) && d.apply(s, e), (d = c && s[c]) && d.apply && W(s) && (t.result = d.apply(s, e), !1 === t.result && t.preventDefault());
                        return t.type = g, o || t.isDefaultPrevented() || p._default && !1 !== p._default.apply(f.pop(), e) || !W(r) || c && h.isFunction(r[g]) && !h.isWindow(r) && ((u = r[c]) && (r[c] = null), h.event.triggered = g, r[g](), h.event.triggered = void 0, u && (r[c] = u)), t.result
                    }
                },
                simulate: function(t, e, n) {
                    var r = h.extend(new h.Event, n, {
                        type: t,
                        isSimulated: !0
                    });
                    h.event.trigger(r, null, e)
                }
            }), h.fn.extend({
                trigger: function(t, e) {
                    return this.each((function() {
                        h.event.trigger(t, e, this)
                    }))
                },
                triggerHandler: function(t, e) {
                    var n = this[0];
                    if (n) return h.event.trigger(t, e, n, !0)
                }
            }), h.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "), (function(t, e) {
                h.fn[e] = function(t, n) {
                    return arguments.length > 0 ? this.on(e, null, t, n) : this.trigger(e)
                }
            })), h.fn.extend({
                hover: function(t, e) {
                    return this.mouseenter(t).mouseleave(e || t)
                }
            }), f.focusin = "onfocusin" in n, f.focusin || h.each({
                focus: "focusin",
                blur: "focusout"
            }, (function(t, e) {
                var n = function(t) {
                    h.event.simulate(e, t.target, h.event.fix(t))
                };
                h.event.special[e] = {
                    setup: function() {
                        var r = this.ownerDocument || this,
                            o = U.access(r, e);
                        o || r.addEventListener(t, n, !0), U.access(r, e, (o || 0) + 1)
                    },
                    teardown: function() {
                        var r = this.ownerDocument || this,
                            o = U.access(r, e) - 1;
                        o ? U.access(r, e, o) : (r.removeEventListener(t, n, !0), U.remove(r, e))
                    }
                }
            }));
            var ue = n.location,
                le = h.now(),
                ce = /\?/;
            h.parseJSON = function(t) {
                return JSON.parse(t + "")
            }, h.parseXML = function(t) {
                var e;
                if (!t || "string" != typeof t) return null;
                try {
                    e = (new n.DOMParser).parseFromString(t, "text/xml")
                } catch (t) {
                    e = void 0
                }
                return e && !e.getElementsByTagName("parsererror").length || h.error("Invalid XML: " + t), e
            };
            var de = /#.*$/,
                pe = /([?&])_=[^&]*/,
                _e = /^(.*?):[ \t]*([^\r\n]*)$/gm,
                fe = /^(?:GET|HEAD)$/,
                he = /^\/\//,
                ge = {},
                me = {},
                ye = "*/".concat("*"),
                Ee = a.createElement("a");

            function ve(t) {
                return function(e, n) {
                    "string" != typeof e && (n = e, e = "*");
                    var r, o = 0,
                        i = e.toLowerCase().match(R) || [];
                    if (h.isFunction(n))
                        for (; r = i[o++];) "+" === r[0] ? (r = r.slice(1) || "*", (t[r] = t[r] || []).unshift(n)) : (t[r] = t[r] || []).push(n)
                }
            }

            function be(t, e, n, r) {
                var o = {},
                    i = t === me;

                function a(s) {
                    var u;
                    return o[s] = !0, h.each(t[s] || [], (function(t, s) {
                        var l = s(e, n, r);
                        return "string" != typeof l || i || o[l] ? i ? !(u = l) : void 0 : (e.dataTypes.unshift(l), a(l), !1)
                    })), u
                }
                return a(e.dataTypes[0]) || !o["*"] && a("*")
            }

            function Oe(t, e) {
                var n, r, o = h.ajaxSettings.flatOptions || {};
                for (n in e) void 0 !== e[n] && ((o[n] ? t : r || (r = {}))[n] = e[n]);
                return r && h.extend(!0, t, r), t
            }
            Ee.href = ue.href, h.extend({
                active: 0,
                lastModified: {},
                etag: {},
                ajaxSettings: {
                    url: ue.href,
                    type: "GET",
                    isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(ue.protocol),
                    global: !0,
                    processData: !0,
                    async: !0,
                    contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                    accepts: {
                        "*": ye,
                        text: "text/plain",
                        html: "text/html",
                        xml: "application/xml, text/xml",
                        json: "application/json, text/javascript"
                    },
                    contents: {
                        xml: /\bxml\b/,
                        html: /\bhtml/,
                        json: /\bjson\b/
                    },
                    responseFields: {
                        xml: "responseXML",
                        text: "responseText",
                        json: "responseJSON"
                    },
                    converters: {
                        "* text": String,
                        "text html": !0,
                        "text json": h.parseJSON,
                        "text xml": h.parseXML
                    },
                    flatOptions: {
                        url: !0,
                        context: !0
                    }
                },
                ajaxSetup: function(t, e) {
                    return e ? Oe(Oe(t, h.ajaxSettings), e) : Oe(h.ajaxSettings, t)
                },
                ajaxPrefilter: ve(ge),
                ajaxTransport: ve(me),
                ajax: function(t, e) {
                    "object" == typeof t && (e = t, t = void 0), e = e || {};
                    var r, o, i, s, u, l, c, d, p = h.ajaxSetup({}, e),
                        _ = p.context || p,
                        f = p.context && (_.nodeType || _.jquery) ? h(_) : h.event,
                        g = h.Deferred(),
                        m = h.Callbacks("once memory"),
                        y = p.statusCode || {},
                        E = {},
                        v = {},
                        b = 0,
                        O = "canceled",
                        D = {
                            readyState: 0,
                            getResponseHeader: function(t) {
                                var e;
                                if (2 === b) {
                                    if (!s)
                                        for (s = {}; e = _e.exec(i);) s[e[1].toLowerCase()] = e[2];
                                    e = s[t.toLowerCase()]
                                }
                                return null == e ? null : e
                            },
                            getAllResponseHeaders: function() {
                                return 2 === b ? i : null
                            },
                            setRequestHeader: function(t, e) {
                                var n = t.toLowerCase();
                                return b || (t = v[n] = v[n] || t, E[t] = e), this
                            },
                            overrideMimeType: function(t) {
                                return b || (p.mimeType = t), this
                            },
                            statusCode: function(t) {
                                var e;
                                if (t)
                                    if (b < 2)
                                        for (e in t) y[e] = [y[e], t[e]];
                                    else D.always(t[D.status]);
                                return this
                            },
                            abort: function(t) {
                                var e = t || O;
                                return r && r.abort(e), P(0, e), this
                            }
                        };
                    if (g.promise(D).complete = m.add, D.success = D.done, D.error = D.fail, p.url = ((t || p.url || ue.href) + "").replace(de, "").replace(he, ue.protocol + "//"), p.type = e.method || e.type || p.method || p.type, p.dataTypes = h.trim(p.dataType || "*").toLowerCase().match(R) || [""], null == p.crossDomain) {
                        l = a.createElement("a");
                        try {
                            l.href = p.url, l.href = l.href, p.crossDomain = Ee.protocol + "//" + Ee.host != l.protocol + "//" + l.host
                        } catch (t) {
                            p.crossDomain = !0
                        }
                    }
                    if (p.data && p.processData && "string" != typeof p.data && (p.data = h.param(p.data, p.traditional)), be(ge, p, e, D), 2 === b) return D;
                    for (d in (c = h.event && p.global) && 0 == h.active++ && h.event.trigger("ajaxStart"), p.type = p.type.toUpperCase(), p.hasContent = !fe.test(p.type), o = p.url, p.hasContent || (p.data && (o = p.url += (ce.test(o) ? "&" : "?") + p.data, delete p.data), !1 === p.cache && (p.url = pe.test(o) ? o.replace(pe, "$1_=" + le++) : o + (ce.test(o) ? "&" : "?") + "_=" + le++)), p.ifModified && (h.lastModified[o] && D.setRequestHeader("If-Modified-Since", h.lastModified[o]), h.etag[o] && D.setRequestHeader("If-None-Match", h.etag[o])), (p.data && p.hasContent && !1 !== p.contentType || e.contentType) && D.setRequestHeader("Content-Type", p.contentType), D.setRequestHeader("Accept", p.dataTypes[0] && p.accepts[p.dataTypes[0]] ? p.accepts[p.dataTypes[0]] + ("*" !== p.dataTypes[0] ? ", " + ye + "; q=0.01" : "") : p.accepts["*"]), p.headers) D.setRequestHeader(d, p.headers[d]);
                    if (p.beforeSend && (!1 === p.beforeSend.call(_, D, p) || 2 === b)) return D.abort();
                    for (d in O = "abort", {
                            success: 1,
                            error: 1,
                            complete: 1
                        }) D[d](p[d]);
                    if (r = be(me, p, e, D)) {
                        if (D.readyState = 1, c && f.trigger("ajaxSend", [D, p]), 2 === b) return D;
                        p.async && p.timeout > 0 && (u = n.setTimeout((function() {
                            D.abort("timeout")
                        }), p.timeout));
                        try {
                            b = 1, r.send(E, P)
                        } catch (t) {
                            if (!(b < 2)) throw t;
                            P(-1, t)
                        }
                    } else P(-1, "No Transport");

                    function P(t, e, a, s) {
                        var l, d, E, v, O, P = e;
                        2 !== b && (b = 2, u && n.clearTimeout(u), r = void 0, i = s || "", D.readyState = t > 0 ? 4 : 0, l = t >= 200 && t < 300 || 304 === t, a && (v = function(t, e, n) {
                            for (var r, o, i, a, s = t.contents, u = t.dataTypes;
                                "*" === u[0];) u.shift(), void 0 === r && (r = t.mimeType || e.getResponseHeader("Content-Type"));
                            if (r)
                                for (o in s)
                                    if (s[o] && s[o].test(r)) {
                                        u.unshift(o);
                                        break
                                    } if (u[0] in n) i = u[0];
                            else {
                                for (o in n) {
                                    if (!u[0] || t.converters[o + " " + u[0]]) {
                                        i = o;
                                        break
                                    }
                                    a || (a = o)
                                }
                                i = i || a
                            }
                            if (i) return i !== u[0] && u.unshift(i), n[i]
                        }(p, D, a)), v = function(t, e, n, r) {
                            var o, i, a, s, u, l = {},
                                c = t.dataTypes.slice();
                            if (c[1])
                                for (a in t.converters) l[a.toLowerCase()] = t.converters[a];
                            for (i = c.shift(); i;)
                                if (t.responseFields[i] && (n[t.responseFields[i]] = e), !u && r && t.dataFilter && (e = t.dataFilter(e, t.dataType)), u = i, i = c.shift())
                                    if ("*" === i) i = u;
                                    else if ("*" !== u && u !== i) {
                                if (!(a = l[u + " " + i] || l["* " + i]))
                                    for (o in l)
                                        if ((s = o.split(" "))[1] === i && (a = l[u + " " + s[0]] || l["* " + s[0]])) {
                                            !0 === a ? a = l[o] : !0 !== l[o] && (i = s[0], c.unshift(s[1]));
                                            break
                                        } if (!0 !== a)
                                    if (a && t.throws) e = a(e);
                                    else try {
                                        e = a(e)
                                    } catch (t) {
                                        return {
                                            state: "parsererror",
                                            error: a ? t : "No conversion from " + u + " to " + i
                                        }
                                    }
                            }
                            return {
                                state: "success",
                                data: e
                            }
                        }(p, v, D, l), l ? (p.ifModified && ((O = D.getResponseHeader("Last-Modified")) && (h.lastModified[o] = O), (O = D.getResponseHeader("etag")) && (h.etag[o] = O)), 204 === t || "HEAD" === p.type ? P = "nocontent" : 304 === t ? P = "notmodified" : (P = v.state, d = v.data, l = !(E = v.error))) : (E = P, !t && P || (P = "error", t < 0 && (t = 0))), D.status = t, D.statusText = (e || P) + "", l ? g.resolveWith(_, [d, P, D]) : g.rejectWith(_, [D, P, E]), D.statusCode(y), y = void 0, c && f.trigger(l ? "ajaxSuccess" : "ajaxError", [D, p, l ? d : E]), m.fireWith(_, [D, P]), c && (f.trigger("ajaxComplete", [D, p]), --h.active || h.event.trigger("ajaxStop")))
                    }
                    return D
                },
                getJSON: function(t, e, n) {
                    return h.get(t, e, n, "json")
                },
                getScript: function(t, e) {
                    return h.get(t, void 0, e, "script")
                }
            }), h.each(["get", "post"], (function(t, e) {
                h[e] = function(t, n, r, o) {
                    return h.isFunction(n) && (o = o || r, r = n, n = void 0), h.ajax(h.extend({
                        url: t,
                        type: e,
                        dataType: o,
                        data: n,
                        success: r
                    }, h.isPlainObject(t) && t))
                }
            })), h._evalUrl = function(t) {
                return h.ajax({
                    url: t,
                    type: "GET",
                    dataType: "script",
                    async: !1,
                    global: !1,
                    throws: !0
                })
            }, h.fn.extend({
                wrapAll: function(t) {
                    var e;
                    return h.isFunction(t) ? this.each((function(e) {
                        h(this).wrapAll(t.call(this, e))
                    })) : (this[0] && (e = h(t, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && e.insertBefore(this[0]), e.map((function() {
                        for (var t = this; t.firstElementChild;) t = t.firstElementChild;
                        return t
                    })).append(this)), this)
                },
                wrapInner: function(t) {
                    return h.isFunction(t) ? this.each((function(e) {
                        h(this).wrapInner(t.call(this, e))
                    })) : this.each((function() {
                        var e = h(this),
                            n = e.contents();
                        n.length ? n.wrapAll(t) : e.append(t)
                    }))
                },
                wrap: function(t) {
                    var e = h.isFunction(t);
                    return this.each((function(n) {
                        h(this).wrapAll(e ? t.call(this, n) : t)
                    }))
                },
                unwrap: function() {
                    return this.parent().each((function() {
                        h.nodeName(this, "body") || h(this).replaceWith(this.childNodes)
                    })).end()
                }
            }), h.expr.filters.hidden = function(t) {
                return !h.expr.filters.visible(t)
            }, h.expr.filters.visible = function(t) {
                return t.offsetWidth > 0 || t.offsetHeight > 0 || t.getClientRects().length > 0
            };
            var De = /%20/g,
                Pe = /\[\]$/,
                Me = /\r?\n/g,
                Te = /^(?:submit|button|image|reset|file)$/i,
                we = /^(?:input|select|textarea|keygen)/i;

            function Ce(t, e, n, r) {
                var o;
                if (h.isArray(e)) h.each(e, (function(e, o) {
                    n || Pe.test(t) ? r(t, o) : Ce(t + "[" + ("object" == typeof o && null != o ? e : "") + "]", o, n, r)
                }));
                else if (n || "object" !== h.type(e)) r(t, e);
                else
                    for (o in e) Ce(t + "[" + o + "]", e[o], n, r)
            }
            h.param = function(t, e) {
                var n, r = [],
                    o = function(t, e) {
                        e = h.isFunction(e) ? e() : null == e ? "" : e, r[r.length] = encodeURIComponent(t) + "=" + encodeURIComponent(e)
                    };
                if (void 0 === e && (e = h.ajaxSettings && h.ajaxSettings.traditional), h.isArray(t) || t.jquery && !h.isPlainObject(t)) h.each(t, (function() {
                    o(this.name, this.value)
                }));
                else
                    for (n in t) Ce(n, t[n], e, o);
                return r.join("&").replace(De, "+")
            }, h.fn.extend({
                serialize: function() {
                    return h.param(this.serializeArray())
                },
                serializeArray: function() {
                    return this.map((function() {
                        var t = h.prop(this, "elements");
                        return t ? h.makeArray(t) : this
                    })).filter((function() {
                        var t = this.type;
                        return this.name && !h(this).is(":disabled") && we.test(this.nodeName) && !Te.test(t) && (this.checked || !Q.test(t))
                    })).map((function(t, e) {
                        var n = h(this).val();
                        return null == n ? null : h.isArray(n) ? h.map(n, (function(t) {
                            return {
                                name: e.name,
                                value: t.replace(Me, "\r\n")
                            }
                        })) : {
                            name: e.name,
                            value: n.replace(Me, "\r\n")
                        }
                    })).get()
                }
            }), h.ajaxSettings.xhr = function() {
                try {
                    return new n.XMLHttpRequest
                } catch (t) {}
            };
            var xe = {
                    0: 200,
                    1223: 204
                },
                Ae = h.ajaxSettings.xhr();
            f.cors = !!Ae && "withCredentials" in Ae, f.ajax = Ae = !!Ae, h.ajaxTransport((function(t) {
                var e, r;
                if (f.cors || Ae && !t.crossDomain) return {
                    send: function(o, i) {
                        var a, s = t.xhr();
                        if (s.open(t.type, t.url, t.async, t.username, t.password), t.xhrFields)
                            for (a in t.xhrFields) s[a] = t.xhrFields[a];
                        for (a in t.mimeType && s.overrideMimeType && s.overrideMimeType(t.mimeType), t.crossDomain || o["X-Requested-With"] || (o["X-Requested-With"] = "XMLHttpRequest"), o) s.setRequestHeader(a, o[a]);
                        e = function(t) {
                            return function() {
                                e && (e = r = s.onload = s.onerror = s.onabort = s.onreadystatechange = null, "abort" === t ? s.abort() : "error" === t ? "number" != typeof s.status ? i(0, "error") : i(s.status, s.statusText) : i(xe[s.status] || s.status, s.statusText, "text" !== (s.responseType || "text") || "string" != typeof s.responseText ? {
                                    binary: s.response
                                } : {
                                    text: s.responseText
                                }, s.getAllResponseHeaders()))
                            }
                        }, s.onload = e(), r = s.onerror = e("error"), void 0 !== s.onabort ? s.onabort = r : s.onreadystatechange = function() {
                            4 === s.readyState && n.setTimeout((function() {
                                e && r()
                            }))
                        }, e = e("abort");
                        try {
                            s.send(t.hasContent && t.data || null)
                        } catch (t) {
                            if (e) throw t
                        }
                    },
                    abort: function() {
                        e && e()
                    }
                }
            })), h.ajaxSetup({
                accepts: {
                    script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
                },
                contents: {
                    script: /\b(?:java|ecma)script\b/
                },
                converters: {
                    "text script": function(t) {
                        return h.globalEval(t), t
                    }
                }
            }), h.ajaxPrefilter("script", (function(t) {
                void 0 === t.cache && (t.cache = !1), t.crossDomain && (t.type = "GET")
            })), h.ajaxTransport("script", (function(t) {
                var e, n;
                if (t.crossDomain) return {
                    send: function(r, o) {
                        e = h("<script>").prop({
                            charset: t.scriptCharset,
                            src: t.url
                        }).on("load error", n = function(t) {
                            e.remove(), n = null, t && o("error" === t.type ? 404 : 200, t.type)
                        }), a.head.appendChild(e[0])
                    },
                    abort: function() {
                        n && n()
                    }
                }
            }));
            var qe = [],
                je = /(=)\?(?=&|$)|\?\?/;
            h.ajaxSetup({
                jsonp: "callback",
                jsonpCallback: function() {
                    var t = qe.pop() || h.expando + "_" + le++;
                    return this[t] = !0, t
                }
            }), h.ajaxPrefilter("json jsonp", (function(t, e, r) {
                var o, i, a, s = !1 !== t.jsonp && (je.test(t.url) ? "url" : "string" == typeof t.data && 0 === (t.contentType || "").indexOf("application/x-www-form-urlencoded") && je.test(t.data) && "data");
                if (s || "jsonp" === t.dataTypes[0]) return o = t.jsonpCallback = h.isFunction(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback, s ? t[s] = t[s].replace(je, "$1" + o) : !1 !== t.jsonp && (t.url += (ce.test(t.url) ? "&" : "?") + t.jsonp + "=" + o), t.converters["script json"] = function() {
                    return a || h.error(o + " was not called"), a[0]
                }, t.dataTypes[0] = "json", i = n[o], n[o] = function() {
                    a = arguments
                }, r.always((function() {
                    void 0 === i ? h(n).removeProp(o) : n[o] = i, t[o] && (t.jsonpCallback = e.jsonpCallback, qe.push(o)), a && h.isFunction(i) && i(a[0]), a = i = void 0
                })), "script"
            })), h.parseHTML = function(t, e, n) {
                if (!t || "string" != typeof t) return null;
                "boolean" == typeof e && (n = e, e = !1), e = e || a;
                var r = M.exec(t),
                    o = !n && [];
                return r ? [e.createElement(r[1])] : (r = ot([t], e, o), o && o.length && h(o).remove(), h.merge([], r.childNodes))
            };
            var Le = h.fn.load;

            function Re(t) {
                return h.isWindow(t) ? t : 9 === t.nodeType && t.defaultView
            }
            h.fn.load = function(t, e, n) {
                if ("string" != typeof t && Le) return Le.apply(this, arguments);
                var r, o, i, a = this,
                    s = t.indexOf(" ");
                return s > -1 && (r = h.trim(t.slice(s)), t = t.slice(0, s)), h.isFunction(e) ? (n = e, e = void 0) : e && "object" == typeof e && (o = "POST"), a.length > 0 && h.ajax({
                    url: t,
                    type: o || "GET",
                    dataType: "html",
                    data: e
                }).done((function(t) {
                    i = arguments, a.html(r ? h("<div>").append(h.parseHTML(t)).find(r) : t)
                })).always(n && function(t, e) {
                    a.each((function() {
                        n.apply(this, i || [t.responseText, e, t])
                    }))
                }), this
            }, h.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], (function(t, e) {
                h.fn[e] = function(t) {
                    return this.on(e, t)
                }
            })), h.expr.filters.animated = function(t) {
                return h.grep(h.timers, (function(e) {
                    return t === e.elem
                })).length
            }, h.offset = {
                setOffset: function(t, e, n) {
                    var r, o, i, a, s, u, l = h.css(t, "position"),
                        c = h(t),
                        d = {};
                    "static" === l && (t.style.position = "relative"), s = c.offset(), i = h.css(t, "top"), u = h.css(t, "left"), ("absolute" === l || "fixed" === l) && (i + u).indexOf("auto") > -1 ? (a = (r = c.position()).top, o = r.left) : (a = parseFloat(i) || 0, o = parseFloat(u) || 0), h.isFunction(e) && (e = e.call(t, n, h.extend({}, s))), null != e.top && (d.top = e.top - s.top + a), null != e.left && (d.left = e.left - s.left + o), "using" in e ? e.using.call(t, d) : c.css(d)
                }
            }, h.fn.extend({
                offset: function(t) {
                    if (arguments.length) return void 0 === t ? this : this.each((function(e) {
                        h.offset.setOffset(this, t, e)
                    }));
                    var e, n, r = this[0],
                        o = {
                            top: 0,
                            left: 0
                        },
                        i = r && r.ownerDocument;
                    return i ? (e = i.documentElement, h.contains(e, r) ? (o = r.getBoundingClientRect(), n = Re(i), {
                        top: o.top + n.pageYOffset - e.clientTop,
                        left: o.left + n.pageXOffset - e.clientLeft
                    }) : o) : void 0
                },
                position: function() {
                    if (this[0]) {
                        var t, e, n = this[0],
                            r = {
                                top: 0,
                                left: 0
                            };
                        return "fixed" === h.css(n, "position") ? e = n.getBoundingClientRect() : (t = this.offsetParent(), e = this.offset(), h.nodeName(t[0], "html") || (r = t.offset()), r.top += h.css(t[0], "borderTopWidth", !0), r.left += h.css(t[0], "borderLeftWidth", !0)), {
                            top: e.top - r.top - h.css(n, "marginTop", !0),
                            left: e.left - r.left - h.css(n, "marginLeft", !0)
                        }
                    }
                },
                offsetParent: function() {
                    return this.map((function() {
                        for (var t = this.offsetParent; t && "static" === h.css(t, "position");) t = t.offsetParent;
                        return t || qt
                    }))
                }
            }), h.each({
                scrollLeft: "pageXOffset",
                scrollTop: "pageYOffset"
            }, (function(t, e) {
                var n = "pageYOffset" === e;
                h.fn[t] = function(r) {
                    return B(this, (function(t, r, o) {
                        var i = Re(t);
                        if (void 0 === o) return i ? i[e] : t[r];
                        i ? i.scrollTo(n ? i.pageXOffset : o, n ? o : i.pageYOffset) : t[r] = o
                    }), t, r, arguments.length)
                }
            })), h.each(["top", "left"], (function(t, e) {
                h.cssHooks[e] = Lt(f.pixelPosition, (function(t, n) {
                    if (n) return n = jt(t, e), Ct.test(n) ? h(t).position()[e] + "px" : n
                }))
            })), h.each({
                Height: "height",
                Width: "width"
            }, (function(t, e) {
                h.each({
                    padding: "inner" + t,
                    content: e,
                    "": "outer" + t
                }, (function(n, r) {
                    h.fn[r] = function(r, o) {
                        var i = arguments.length && (n || "boolean" != typeof r),
                            a = n || (!0 === r || !0 === o ? "margin" : "border");
                        return B(this, (function(e, n, r) {
                            var o;
                            return h.isWindow(e) ? e.document.documentElement["client" + t] : 9 === e.nodeType ? (o = e.documentElement, Math.max(e.body["scroll" + t], o["scroll" + t], e.body["offset" + t], o["offset" + t], o["client" + t])) : void 0 === r ? h.css(e, n, a) : h.style(e, n, r, a)
                        }), e, i ? r : void 0, i, null)
                    }
                }))
            })), h.fn.extend({
                bind: function(t, e, n) {
                    return this.on(t, null, e, n)
                },
                unbind: function(t, e) {
                    return this.off(t, null, e)
                },
                delegate: function(t, e, n, r) {
                    return this.on(e, t, n, r)
                },
                undelegate: function(t, e, n) {
                    return 1 === arguments.length ? this.off(t, "**") : this.off(e, t || "**", n)
                },
                size: function() {
                    return this.length
                }
            }), h.fn.andSelf = h.fn.addBack, void 0 === (r = function() {
                return h
            }.apply(e, [])) || (t.exports = r);
            var Ie = n.jQuery,
                Be = n.$;
            return h.noConflict = function(t) {
                return n.$ === h && (n.$ = Be), t && n.jQuery === h && (n.jQuery = Ie), h
            }, o || (n.jQuery = n.$ = h), h
        }, "object" == typeof t.exports ? t.exports = o.document ? i(o, !0) : function(t) {
            if (!t.document) throw new Error("jQuery requires a window with a document");
            return i(t)
        } : i(o)
    },
    167: function(t, e, n) {
        t.exports = n(168)
    },
    168: function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1),
            jquery__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__),
            _engine__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94);
        window.jQuery = jquery__WEBPACK_IMPORTED_MODULE_0___default.a, window.$ = jquery__WEBPACK_IMPORTED_MODULE_0___default.a, window.GloboSwatch = window.GloboSwatch || {}, GloboSwatch = function(t) {
            this.page = t.page, this.domain = t.shop.domain, this.name = t.shop.name, this.product = t.product, this.curVariant = t.curVariant, this.enable_collection_page = t.settings.enable_collection_page, this.enable_product_page = t.settings.enable_product_page, this.enable_mandatory = t.settings.enable_mandatory, this.optionsApp = t.options, this.style_collection_page_swatch = t.collection_page.customize_swatch, this.style_collection_page_button = t.collection_page.customize_button, this.align_content = t.collection_page.float, this.style_product_page_swatch = t.product_page.customize_swatch, this.style_product_page_button = t.product_page.customize_button, this.align_content_detail = t.product_page.float, this.show_number_stock = t.product_page.show_number_stock, this.show_add_to_cart_button = t.settings.show_add_to_cart_button, this.add_to_cart_ajax = t.settings.add_to_cart_ajax, this.show_option_name = t.settings.show_option_name, this.out_of_stock = t.settings.out_of_stock, this.add_to_cart_text = t.settings.add_to_cart_text, this.added_to_cart_text = t.settings.added_to_cart_text, this.sold_out_text = t.settings.sold_out_text, this.text_required = t.settings.text_required, this.sort_option = t.settings.sort_option
        }, GloboSwatch.prototype.init = function() {
            var app = this,
                installed = !1;
            if (jquery__WEBPACK_IMPORTED_MODULE_0___default()("script").each((function() {
                    -1 != jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).text().indexOf("globo.swatch.init.js?") && -1 != jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).text().indexOf("asyncLoad") && -1 == jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).text().indexOf("initSchema") && (installed = !0)
                })), installed) {
                var selectors = {
                        priceCollectionSelector: ".price, .product-price, .productitem--price, .product-item-price, p.color--primary-meta.m0.font-size--sm.line-height--4.wd--font-size--m.wd--line-height--4, p.color--primary-accent.m0.font-size--sm.line-height--4.wd--font-size--m.wd--line-height--4, .money-styling, .card__price, .product-card__price, .product__prices, .grid-product__price-wrap, .product-item--price, .grid-link__meta, .prod-price, .product-grid--price, .product-item__price, .product-list-item-price, .grid-product__price, .product_image_caption span, .price_wrapper",
                        productThumbnailsImageSelector: [".product-single__thumbnails .product-single__thumbnails-item", ".thumbs .thumb", ".product-gallery .thumbnails .thumbnail", ".product-thumbnails .product-thumbnail", ".product__thumbnails .product-flickity__slides .nine-twelfths.md--up--one-whole", "#thumblist .thumb_item", "#ProductThumbs-product-template li", "#product-image-thumbnails li", ".product-gallery--navigation .product-gallery--thumbnail-trigger", "#product-thumbnails li", ".productimages .thumbs ul li", "#product-photos .thumbnails a", ".product-single__thumbnails .product-single__thumbnail-item", ".product-single__thumbnails .thumbnail-wrapper.grid__item", ".product-photo-thumbs .grid-item", "#product-thumbnails-product-template .thumbnails .thumbnail-gallery-item", ".product__slideshow--nav img", ".product__thumbs--beside .product__thumb-item", ".product-thumbnails .product-slideshow-pagination-item", ".productThumbs li", ".product_slider .flex-control-thumbs li", "#product-photos .thumb_product", ".product-images .product-thumbnails img", ".Product__SlideshowNavScroller .Product__SlideshowNavImage", "#image-block .flex-control-thumbs li", ".product-detail .gallery .thumbnails a", "ul.product__thumbnails .product__thumbnail", ".product_gallery_nav .gallery-cell", ".product-single__photo .slick-dots li", "ul#ProductThumbs li.grid__item", "html.product .secondary-images .secondary-image", "#product-area .pager .wrap.thumb"],
                        singleOptionSelector: ".single-option-selector, select[data-single-option-selector], .pretty-select select, .select-wrapper select, .selector-wrapper select, .product-form__select .form__input--select",
                        selectOptionDetail: '.product-form-option,.swatches-type-products,.form-field.form-options,.swatch,form select[name="id"],.tt-product-head__options,.variant-wrapper,.swatches-wrapper,.swatches__container,.product-form__controls-group:nth-child(1):not(.product-form__controls-group--submit),#product-options .product-swatches, form#AddToCartForm > .swatch, .product-form--alt .form-field.form-options, .materialize-select, .product-form__select, .product-single__meta .radio-wrapper.product-form__item, .product__form-wrapper .product-form__item, .variations .product-attribute, .product-details-wrapper .inline-field-wrapper, .product-single__form .variant-wrapper, .product__info .product__form .product__variants .form__control, .variant-group .variant-group-multiple, .card__section form[action="/cart/add"] .product-form__variants',
                        btnValidationAddtocart: 'form.shopify-product-form button.add-to-cart,form[action*="/cart/add"] [name="add"], form[action*="/cart/add"] button#AddToCartDesk, form[data-product-form] button[data-product-add], .product-form--atc-button[data-product-atc], .globo-validationForm, button.single_add_to_cart_button.ajax_form_cart, input#AddToCart-product-template, button[data-action="add-to-cart"], .product-details-wrapper .add-to-cart input, form.product-menu-form .product-menu-button[data-product-menu-button-atc], .product-add input#AddToCart, #product-content #add-to-cart #addToCart, .product-form-submit-wrap .add-to-cart-button, .productForm-block .productForm-submit, .btn-wrapper-c .add, .product-submit input.add-to-cart, .form-element-quantity-submit .form-element-submit-button, .quantity-submit-row__submit input, form#AddToCartForm .product-add input#addToCart, .product__form .product__add-to-cart, #product-description form .product-add .add, .product-add input.button.product-add-available, .globo__validation-default, #product-area .product-details-wrapper .options .selector-wrapper .submit'
                    },
                    Shopify = Shopify || {};
                if (Shopify.money_format = Globo.moneyFormat, Shopify.formatMoney = function(t, e) {
                        "string" == typeof t && (t = t.replace(".", ""));
                        var n = "",
                            r = /\{\{\s*(\w+)\s*\}\}/,
                            o = e || this.money_format;

                        function i(t, e) {
                            return void 0 === t ? e : t
                        }

                        function a(t, e, n, r) {
                            if (e = i(e, 2), n = i(n, ","), r = i(r, "."), isNaN(t) || null == t) return 0;
                            var o = (t = (t / 100).toFixed(e)).split(".");
                            return o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + n) + (o[1] ? r + o[1] : "")
                        }
                        switch (o.match(r)[1]) {
                            case "amount":
                                n = a(t, 2);
                                break;
                            case "amount_no_decimals":
                                n = a(t, 0);
                                break;
                            case "amount_with_comma_separator":
                                n = a(t, 2, ".", ",");
                                break;
                            case "amount_no_decimals_with_comma_separator":
                                n = a(t, 0, ".", ",")
                        }
                        return o.replace(r, n)
                    }, app.enable_collection_page && (getTemplateSwatchCollections(), getAttrParentAndHidePrice(), getAddtocartCollection(), getToggleDropdownList(), changeImageCollection(), changeSwatchOptionValueCollection()), app.enable_product_page && "product" === app.page) {
                    var optionsApps = app.optionsApp,
                        styleOptions = getListKeyStyle(optionsApps),
                        listColors = getListColors(optionsApps),
                        listColors2 = getListColors2(optionsApps),
                        listColorImage = getListColorImage(optionsApps),
                        listColorImageUrl = getListColorImageUrl(optionsApps),
                        listSelectType = getListSelectType(optionsApps),
                        listOrderOptions = getListOrderOptions(optionsApps),
                        current_variant = app.curVariant,
                        product = app.product,
                        productVariants = app.product.variants;
                    insertAfterSwatchProduct(), setTimeout((function() {
                        getTemplateSwatchProduct(), hideSelectAndPriceProduct(), getToggleDropdownListProductDetail(), sortSwatchOptionsProduct(product.id), showNumberStock(current_variant), (app.product.variants.length > 1 || 1 == app.product.variants.length && "Default Title" != app.product.variants[0].title) && productDetailVariantsProcess(productVariants)
                    }), 300)
                }
            }

            function getGSCollection() {
                var t = [];
                return jquery__WEBPACK_IMPORTED_MODULE_0___default()(".GWS-product-item").each((function() {
                    var e = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data("id"),
                        n = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data("url"),
                        r = JSON.parse(jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).html());
                    r.url = n, t[e] = r
                })), t
            }

            function getListKeyStyle(t) {
                for (var e = [], n = 0; n < t.length; n++) e[t[n].name] = t[n].display_style;
                return Object.assign({}, e)
            }

            function getListColors(t) {
                for (var e = [], n = 0; n < t.length; n++)
                    for (var r = 0; r < t[n].option_items.length; r++) void 0 !== t[n].option_items[r].custom.color_1 && (e[t[n].name + "-" + t[n].option_items[r].value] = t[n].option_items[r].custom.color_1);
                return Object.assign({}, e)
            }

            function getListColors2(t) {
                for (var e = [], n = 0; n < t.length; n++)
                    for (var r = 0; r < t[n].option_items.length; r++) void 0 !== t[n].option_items[r].custom.color_2 && (e[t[n].name + "-" + t[n].option_items[r].value] = t[n].option_items[r].custom.color_2);
                return Object.assign({}, e)
            }

            function getListColorImage(t) {
                for (var e = [], n = 0; n < t.length; n++)
                    for (var r = 0; r < t[n].option_items.length; r++) void 0 !== t[n].option_items[r].custom.upload_file.src && (e[t[n].name + "-" + t[n].option_items[r].value] = t[n].option_items[r].custom.upload_file.src);
                return Object.assign({}, e)
            }

            function getListColorImageUrl(t) {
                for (var e = [], n = 0; n < t.length; n++)
                    for (var r = 0; r < t[n].option_items.length; r++) void 0 !== t[n].option_items[r].custom.image_url.src && (e[t[n].name + "-" + t[n].option_items[r].value] = t[n].option_items[r].custom.image_url.src);
                return Object.assign({}, e)
            }

            function getListSelectType(t) {
                for (var e = [], n = 0; n < t.length; n++)
                    for (var r = 0; r < t[n].option_items.length; r++) void 0 !== t[n].option_items[r].select_type && (e[t[n].name + "-" + t[n].option_items[r].value] = t[n].option_items[r].select_type);
                return Object.assign({}, e)
            }

            function getListOrderOptions(t) {
                for (var e = [], n = 0; n < t.length; n++) e[t[n].name] = t[n].order;
                return Object.assign({}, e)
            }

            function hideArrowSelect() {
                jquery__WEBPACK_IMPORTED_MODULE_0___default()(".ul-globo-dropdown-option").each((function(t, e) {
                    1 === jquery__WEBPACK_IMPORTED_MODULE_0___default()(e).find(".select-option--dropdown").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()(e).find(".globo-arrow-select").remove()
                }))
            }

            function sortSwatchOptionsCollection(t) {
                if (app.sort_option) {
                    var e = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.swatches-globo[product-swatch-id="' + t + '"]').eq(0).children(".globo-swatch-list .swatch--gl");
                    if (e.length > 1) {
                        var n = e.sort((function(t, e) {
                            var n = parseInt(jquery__WEBPACK_IMPORTED_MODULE_0___default()(t).data("order")),
                                r = parseInt(jquery__WEBPACK_IMPORTED_MODULE_0___default()(e).data("order"));
                            return n < r ? -1 : n > r ? 1 : 0
                        }));
                        jquery__WEBPACK_IMPORTED_MODULE_0___default()('.swatches-globo[product-swatch-id="' + t + '"] .globo-swatch-list').html(n)
                    }
                }
            }

            function getTemplateSwatchCollections() {
                if (GSCollection = getGSCollection(), "undefined" != typeof GSCollection)
                    for (var t = Object.keys(GSCollection), e = app.optionsApp, n = getListKeyStyle(e), r = getListColors(e), o = getListColors2(e), i = getListColorImage(e), a = getListColorImageUrl(e), s = getListSelectType(e), u = getListOrderOptions(e), l = 0; l < t.length; l++) {
                        var c = GSCollection[t[l]],
                            d = (GSCollection[t[l]].currentVariantCollection, document.getElementById("globoSwatchCollection").innerHTML),
                            p = (document.querySelector(".swatches-globo"), app.optionsApp.filter((function(t) {
                                return t.settings && t.settings.enable_collection
                            })));
                        p = p.map((function(t) {
                            return t.name
                        }));
                        var _ = _engine__WEBPACK_IMPORTED_MODULE_1__.a.parseAndRenderSync(d, {
                            product: c,
                            configs: {
                                visibleOptions: p,
                                displayStyles: n,
                                displayColors: r,
                                displayColors2: o,
                                displayColorsImage: i,
                                displayColorsImageUrl: a,
                                displaySelectType: s,
                                style_collection_page_swatch: app.style_collection_page_swatch,
                                style_collection_page_button: app.style_collection_page_button,
                                align_content: app.align_content,
                                showAddtocart: app.show_add_to_cart_button,
                                isAjaxcart: app.add_to_cart_ajax,
                                isOptionname: app.show_option_name,
                                styleSoldout: app.out_of_stock,
                                txtAddtocart: app.add_to_cart_text,
                                txtAddedtocart: app.added_to_cart_text,
                                txtSoldout: app.sold_out_text,
                                sortOption: app.sort_option,
                                listOrderOptions: u
                            }
                        });
                        jquery__WEBPACK_IMPORTED_MODULE_0___default()('[product-swatch-id="' + c.id + '"]').html(_), sortSwatchOptionsCollection(c.id)
                    }
            }

            function getAttrParentAndHidePrice() {
                jquery__WEBPACK_IMPORTED_MODULE_0___default()(".swatches-globo").each((function() {
                    jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parent().parent().attr("product-selector", jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).attr("product-swatch-id"))
                }))
            }

            function getAddtocartCollection() {
                var txtAdded = app.added_to_cart_text,
                    updateCart = function(t) {
                        jquery__WEBPACK_IMPORTED_MODULE_0___default.a.ajax({
                            url: "/cart.js",
                            type: "get",
                            dataType: "json",
                            success: function(e) {
                                window.dispatchEvent(new CustomEvent("globoSwatchProductsUpdateCart", {
                                    detail: {
                                        cart: e,
                                        ids: t
                                    }
                                }))
                            }
                        })
                    };
                jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on("click", ".globo-ajax-form-cart", (function(e) {
                    e.preventDefault();
                    var t = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this),
                        f = t.closest(".swatches-globo"),
                        idDataForm = f.find(".globo-selector-all").val();
                    jquery__WEBPACK_IMPORTED_MODULE_0___default.a.ajax({
                        type: "POST",
                        url: "/cart/add.js",
                        data: {
                            quantity: 1,
                            id: idDataForm
                        },
                        dataType: "json",
                        success: function(t) {
                            app.add_to_cart_ajax ? updateCart(idDataForm) : window.location.href = "/cart"
                        },
                        error: function error(XMLHttpRequest, textStatus) {
                            var data = eval("(" + XMLHttpRequest.responseText + ")");
                            data.message && (alert(data.message + ": " + data.description), t.prop("disabled", !0))
                        },
                        complete: function(e) {
                            200 == e.status && t.html(txtAdded)
                        }
                    })
                }))
            }

            function getToggleDropdownList() {
                jquery__WEBPACK_IMPORTED_MODULE_0___default()(".ul-globo-dropdown-option").length && (hideArrowSelect(), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".ul-globo-dropdown-option li.swatches-options").on("click", (function(t) {
                    t.preventDefault(), t.stopPropagation();
                    jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).siblings().toggle();
                    jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parent().prepend(this), jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).find("input[type=radio]").prop("checked", !0).trigger("change")
                })), jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on("click", (function(t) {
                    jquery__WEBPACK_IMPORTED_MODULE_0___default()(t.target).is(".ul-globo-dropdown-option") || (jquery__WEBPACK_IMPORTED_MODULE_0___default()(".ul-globo-dropdown-option li.swatches-options").hide(), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".ul-globo-dropdown-option li.swatches-options:first-child").show())
                })))
            }

            function getToggleDropdownListProductDetail() {
                jquery__WEBPACK_IMPORTED_MODULE_0___default()(".ul-globo-dropdown-option").length && (hideArrowSelect(), jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on("click", ".ul-globo-dropdown-option .select-globo-init", (function(t) {
                    t.preventDefault(), t.stopPropagation(), jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).closest(".ul-globo-dropdown-option").children("li:not(.select-globo-init)").toggle()
                })), jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on("click", ".ul-globo-dropdown-option li:not(.select-globo-init)", (function(t) {
                    t.preventDefault(), t.stopPropagation(), jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).siblings().toggle(), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".select-globo-init").length ? jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parent().find(".select-globo-init").html(jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).html()) : jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parent().prepend(this), jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).find("input[type=radio]").prop("checked", !0).trigger("change")
                })))
            }

            function changeImageCollection() {
                jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on("click", ".g-variant-color li", (function() {
                    var t = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).attr("productId"),
                        e = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).attr("productImage");
                    e && (jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parents('[product-selector="' + t + '"]').find("img").first().attr("src", e), jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parents('[product-selector="' + t + '"]').find("img").first().attr("srcset", e), jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parents("article.collection-product").find("img").length && (jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parents("article.collection-product").find("img").first().attr("src", e), jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parents("article.collection-product").find("img").first().attr("srcset", e)))
                }))
            }

            function changeSwatchOptionValueCollection() {
                var t = app.add_to_cart_text,
                    e = app.sold_out_text;
                jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on("change", ".swatches-globo .swatch--gl .swatches-options :radio", (function() {
                    var n = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parents(".swatches-globo").find(".swatch--gl"),
                        r = [];
                    jquery__WEBPACK_IMPORTED_MODULE_0___default.a.each(n, (function(t, e) {
                        var n = jquery__WEBPACK_IMPORTED_MODULE_0___default()(e).attr("data-option-index");
                        r[n] = jquery__WEBPACK_IMPORTED_MODULE_0___default()(e).find('input[type="radio"]:checked').val()
                    }));
                    for (var o = "", i = 0; i < r.length; i++) void 0 !== r[i] && (o += "[data-option" + parseInt(i + 1) + '="' + r[i] + '"]');
                    var a = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parents(".swatches-globo").find("select[name='idGlobo'] option" + o).first().val(),
                        s = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parents(".swatches-globo").find("select[name='idGlobo'] option" + o).data("available");
                    jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parents(".swatches-globo").find('select[name="idGlobo"]').val(a), s ? (jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parents(".swatches-globo").find(".globo--add-to-cart").html(t), jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parents(".swatches-globo").find(".globo--add-to-cart").removeAttr("disabled")) : (jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parents(".swatches-globo").find(".globo--add-to-cart").html(e), jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parents(".swatches-globo").find(".globo--add-to-cart").attr("disabled", "disabled"));
                    var u = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parents(".swatches-globo").find('select[name="idGlobo"] option:selected').val();
                    jquery__WEBPACK_IMPORTED_MODULE_0___default()(".globo-swatch-lists-price li").each((function() {
                        if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).attr("data-value") === u) {
                            var t = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.globo-swatch-lists-price li[data-value="' + u + '"] .gw-li-price').html(),
                                e = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.globo-swatch-lists-price li[data-value="' + u + '"] .gw-li-compareprice').html();
                            jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parents(".swatches-globo").find(".globo-cs-product_price").html(t), void 0 !== e ? jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parents(".swatches-globo").find(".globo-cs-product_oldprice").html(e) : jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parents(".swatches-globo").find(".globo-cs-product_oldprice").html("")
                        }
                    }));
                    var l = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parents(".swatches-globo").attr("product-swatch-id"),
                        c = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parents(".swatches-globo"),
                        d = c.find(".globo-swatch-list .swatch--gl");
                    d.length > 1 && c.find(".swatch--gl :radio").each((function() {
                        jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parent().removeClass("globo-out-of-stock")
                    })), d.each((function(t, e) {
                        t = jquery__WEBPACK_IMPORTED_MODULE_0___default()(e).attr("data-option-index");
                        var n = jquery__WEBPACK_IMPORTED_MODULE_0___default()(e).find('input[type="radio"]:checked').val();
                        d.each((function(e, r) {
                            e = jquery__WEBPACK_IMPORTED_MODULE_0___default()(r).attr("data-option-index");
                            t !== e && jquery__WEBPACK_IMPORTED_MODULE_0___default()(r).find(":radio").each((function(r, o) {
                                for (var i = !1, a = 0, s = GSCollection[l].variants.length; a < s; a++) {
                                    var u = GSCollection[l].variants[a];
                                    !1 !== u.available && u.options[t] == n && u.options[e] == jquery__WEBPACK_IMPORTED_MODULE_0___default()(o).val() && (i = !0)
                                }!1 === i && jquery__WEBPACK_IMPORTED_MODULE_0___default()(o).parent().not(".select-option--dropdown").addClass("globo-out-of-stock")
                            }))
                        }))
                    }));
                  var h = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).closest('.product-item.grid__item').find('select[name="idGlobo"] option:selected').data("href");
                  jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).closest('.product-item.grid__item').find('.product-item__link').attr("href",h)
                }))
            }

            function insertAfterSwatchProduct() {
                0 == jquery__WEBPACK_IMPORTED_MODULE_0___default()(".globo-swatch-product-detail").length && (jquery__WEBPACK_IMPORTED_MODULE_0___default()('form[action*="/cart/add"]').length > 1 ? jquery__WEBPACK_IMPORTED_MODULE_0___default()('<div class="globo-swatch-product-detail"></div>').insertAfter('form[action*="/cart/add"]:visible:first [name="id"]') : jquery__WEBPACK_IMPORTED_MODULE_0___default()('form[action*="/cart/add"] [name="id"]').parent("label").length ? jquery__WEBPACK_IMPORTED_MODULE_0___default()('<div class="globo-swatch-product-detail"></div>').insertAfter('form[action*="/cart/add"] label[for="product-select-simple"]') : jquery__WEBPACK_IMPORTED_MODULE_0___default()('<div class="globo-swatch-product-detail"></div>').insertAfter('form[action*="/cart/add"] [name="id"]'), jquery__WEBPACK_IMPORTED_MODULE_0___default()('form.product-menu-form[action*="/cart/add"]').length && jquery__WEBPACK_IMPORTED_MODULE_0___default()('<div class="globo-swatch-product-detail"></div>').insertAfter('form.product-menu-form[action*="/cart/add"] [name="id"]'))
            }

            function getTemplateSwatchProduct() {
                var t = document.getElementById("globoSwatchProductDetail").innerHTML,
                    e = _engine__WEBPACK_IMPORTED_MODULE_1__.a.parseAndRenderSync(t, {
                        product: product,
                        configs: {
                            displayStyles: styleOptions,
                            displayColors: listColors,
                            displayColors2: listColors2,
                            displayColorsImage: listColorImage,
                            displayColorsImageUrl: listColorImageUrl,
                            displaySelectType: listSelectType,
                            style_product_page_swatch: app.style_product_page_swatch,
                            style_product_page_button: app.style_product_page_button,
                            align_content: app.align_content_detail,
                            showNumberStock: app.show_number_stock,
                            styleSoldout: app.out_of_stock,
                            enableMandatory: app.enable_mandatory,
                            sortOption: app.sort_option,
                            current_variant: current_variant,
                            listOrderOptions: listOrderOptions
                        }
                    });
                jquery__WEBPACK_IMPORTED_MODULE_0___default()(".globo-swatch-product-detail").html(e)
            }

            function hideSelectAndPriceProduct() {
                jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.selectOptionDetail).hide(), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".product__sticky dl.price").hide(), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".product__sticky .globo-product-swatch-price").show(), setTimeout((function() {
                    jquery__WEBPACK_IMPORTED_MODULE_0___default()(".selector-wrapper").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()(".selector-wrapper").hide()
                }), 300)
            }

            function sortSwatchOptionsProduct(t) {
                if (app.sort_option) {
                    var e = jquery__WEBPACK_IMPORTED_MODULE_0___default()(".globo-swatch-product-detail .globo-swatch-list .swatch--gl");
                    if (e.length > 1) {
                        var n = e.sort((function(t, e) {
                            var n = parseInt(jquery__WEBPACK_IMPORTED_MODULE_0___default()(t).data("order")),
                                r = parseInt(jquery__WEBPACK_IMPORTED_MODULE_0___default()(e).data("order"));
                            return n < r ? -1 : n > r ? 1 : 0
                        }));
                        jquery__WEBPACK_IMPORTED_MODULE_0___default()(".globo-swatch-product-detail .globo-swatch-list").html(n)
                    }
                }
            }

            function showNumberStock(t) {
                if (app.show_number_stock && 0 == app.enable_mandatory && null != t.inventory_management) {
                    var e = t.inventory_quantity;
                    jquery__WEBPACK_IMPORTED_MODULE_0___default()(".globo-number-stock-variant").html("Stock: only " + e + " left in stock")
                }
            }

            function changeCurrencyApp() {
                ("undefined" != typeof DoublyGlobalCurrency && jquery__WEBPACK_IMPORTED_MODULE_0___default()("select.currency-switcher").length && DoublyGlobalCurrency.convertAll(jquery__WEBPACK_IMPORTED_MODULE_0___default()("select.currency-switcher").val()), "undefined" != typeof conversionBearAutoCurrencyConverter && "function" == typeof conversionBearAutoCurrencyConverter.convertPricesOnPage && conversionBearAutoCurrencyConverter.convertPricesOnPage(), jquery__WEBPACK_IMPORTED_MODULE_0___default()('[name="currencies"]').length && "undefined" != typeof Currency && void 0 !== Currency.convertAll && Currency.convertAll(window.shopCurrency, jquery__WEBPACK_IMPORTED_MODULE_0___default()("[name=currencies]").val()), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".CurrencySelector__Select").length && "this.form.submit()" != jquery__WEBPACK_IMPORTED_MODULE_0___default()(".CurrencySelector__Select").attr("onchange")) && document.querySelectorAll(".CurrencySelector__Select").forEach((function(t) {
                    app.dispatchCustomEvent(t, "change")
                }));
                ("undefined" != typeof Currency && void 0 !== Currency.moneyFormats || "undefined" != typeof ACSCurrency && void 0 !== ACSCurrency.moneyFormats) && "undefined" != typeof mlvedaload && mlvedaload(), "undefined" != typeof BOLD && void 0 !== BOLD.common && void 0 !== BOLD.common.eventEmitter && BOLD.common.eventEmitter.emit("BOLD_CURRENCY_double_check")
            }

            function automatedVariantImageSwatch() {
                jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on("change", ".globo-swatch-product-detail .g-variant-color-detail :radio", (function() {
                    for (var t = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).val(), e = 0; e < selectors.productThumbnailsImageSelector.length; e++) {
                        var n = jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.productThumbnailsImageSelector[e]);
                        jquery__WEBPACK_IMPORTED_MODULE_0___default.a.each(n, (function(e, n) {
                            var r = jquery__WEBPACK_IMPORTED_MODULE_0___default()(n).attr("data-color");
                            t == r ? jquery__WEBPACK_IMPORTED_MODULE_0___default()(n).removeClass("hide") : jquery__WEBPACK_IMPORTED_MODULE_0___default()(n).addClass("hide"), "AllColors" == jquery__WEBPACK_IMPORTED_MODULE_0___default()(n).data("color") && jquery__WEBPACK_IMPORTED_MODULE_0___default()(n).removeClass("hide")
                        }))
                    }
                    jquery__WEBPACK_IMPORTED_MODULE_0___default()(".product-single__thumbnails.slick-initialized").length && window.dispatchEvent(new CustomEvent("colorChange", {
                        detail: {
                            color: t
                        }
                    })), jquery__WEBPACK_IMPORTED_MODULE_0___default()("#product-thumbnails-product-template .thumbnails.slick-initialized").length && window.dispatchEvent(new CustomEvent("colorChangeFaster", {
                        detail: {
                            color: t
                        }
                    }))
                }))
            }

            function productDetailVariantsProcess(t) {
                if (t.length > 0) {
                    if (jquery__WEBPACK_IMPORTED_MODULE_0___default()('select[name="id"]').closest('form[action="/cart/add"]').length) var e = jquery__WEBPACK_IMPORTED_MODULE_0___default()('select[name="id"]').closest('form[action="/cart/add"]');
                    else if (jquery__WEBPACK_IMPORTED_MODULE_0___default()("form.shopify-product-form").length) e = jquery__WEBPACK_IMPORTED_MODULE_0___default()("form.shopify-product-form");
                    else e = jquery__WEBPACK_IMPORTED_MODULE_0___default()('form[action="/cart/add"]');
                    ! function() {
                        if (0 == app.enable_mandatory || product.variants.length <= 1)
                            for (var t = 0, n = app.curVariant.options.length; t < n; t++) {
                                var r = e.find(".swatch--gl[data-option-index='" + t + "'] :radio[value='" + app.curVariant.options[t] + "']");
                                r.length && (r.get(0).checked = !0)
                            }
                    }(), setTimeout((function() {
                            window.innerWidth >= 750 && function() {
                                if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(".g-variant-color-detail").length) {
                                    for (var t = app.curVariant.option1, e = 0; e < selectors.productThumbnailsImageSelector.length; e++) jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.productThumbnailsImageSelector[e]).addClass("hide");
                                    for (var n = [], r = [], o = (e = 0, product.variants.length); e < o; e++) {
                                        var i = product.variants[e]; - 1 == n.indexOf(i.option1) && (n.push(i.option1), i.featured_media && (r[i.featured_media.position] = i.option1))
                                    }
                                    if (jquery__WEBPACK_IMPORTED_MODULE_0___default.a.each(r, (function(t, e) {
                                            if (void 0 !== e)
                                                for (var n = t - 1, r = product.media.length; n < r; n++)
                                                    for (var o = 0; o < selectors.productThumbnailsImageSelector.length; o++) jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.productThumbnailsImageSelector[o]).eq(n).attr("data-color", e)
                                        })), -1 !== jquery__WEBPACK_IMPORTED_MODULE_0___default.a.inArray(t, n))
                                        for (e = 0; e < selectors.productThumbnailsImageSelector.length; e++) jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.productThumbnailsImageSelector[e] + "[data-color='" + t + "']").removeClass("hide");
                                    for (e = 0; e < selectors.productThumbnailsImageSelector.length; e++) jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.productThumbnailsImageSelector[e]).each((function(t, e) {
                                        void 0 === jquery__WEBPACK_IMPORTED_MODULE_0___default()(e).data("color") && (jquery__WEBPACK_IMPORTED_MODULE_0___default()(e).removeClass("hide"), jquery__WEBPACK_IMPORTED_MODULE_0___default()(e).attr("data-color", "AllColors"))
                                    }))
                                }
                            }()
                        }), 300),
                        function() {
                            if (jquery__WEBPACK_IMPORTED_MODULE_0___default()('form[action*="/cart/add"]').length > 1)
                                for (var e = 0, n = t.length; e < n; e++) t[e].compare_at_price > t[e].price ? jquery__WEBPACK_IMPORTED_MODULE_0___default()('form[action*="/cart/add"]:visible:first select[name="id"] option:eq(' + e + ")").attr({
                                    "data-option1": t[e].option1,
                                    "data-option2": t[e].option2,
                                    "data-option3": t[e].option3,
                                    "data-available": t[e].available,
                                    "data-price": Shopify.formatMoney(t[e].price, Shopify.money_format),
                                    "data-compare-price": Shopify.formatMoney(t[e].compare_at_price, Shopify.money_format),
                                    "data-globoquantity": t[e].inventory_quantity,
                                    "data-inventory-management": t[e].inventory_management
                                }) : jquery__WEBPACK_IMPORTED_MODULE_0___default()('form[action*="/cart/add"]:visible:first select[name="id"] option:eq(' + e + ")").attr({
                                    "data-option1": t[e].option1,
                                    "data-option2": t[e].option2,
                                    "data-option3": t[e].option3,
                                    "data-available": t[e].available,
                                    "data-price": Shopify.formatMoney(t[e].price, Shopify.money_format),
                                    "data-globoquantity": t[e].inventory_quantity,
                                    "data-inventory-management": t[e].inventory_management
                                });
                            else
                                for (e = 0, n = t.length; e < n; e++) t[e].compare_at_price > t[e].price ? jquery__WEBPACK_IMPORTED_MODULE_0___default()('form[action*="/cart/add"] select[name="id"] option:eq(' + e + ")").attr({
                                    "data-option1": t[e].option1,
                                    "data-option2": t[e].option2,
                                    "data-option3": t[e].option3,
                                    "data-available": t[e].available,
                                    "data-price": Shopify.formatMoney(t[e].price, Shopify.money_format),
                                    "data-compare-price": Shopify.formatMoney(t[e].compare_at_price, Shopify.money_format),
                                    "data-globoquantity": t[e].inventory_quantity,
                                    "data-inventory-management": t[e].inventory_management
                                }) : jquery__WEBPACK_IMPORTED_MODULE_0___default()('form[action*="/cart/add"] select[name="id"] option:eq(' + e + ")").attr({
                                    "data-option1": t[e].option1,
                                    "data-option2": t[e].option2,
                                    "data-option3": t[e].option3,
                                    "data-available": t[e].available,
                                    "data-price": Shopify.formatMoney(t[e].price, Shopify.money_format),
                                    "data-globoquantity": t[e].inventory_quantity,
                                    "data-inventory-management": t[e].inventory_management
                                });
                            if (jquery__WEBPACK_IMPORTED_MODULE_0___default()('form.product-menu-form[action*="/cart/add"]').length)
                                for (e = 0, n = t.length; e < n; e++) t[e].compare_at_price > t[e].price ? jquery__WEBPACK_IMPORTED_MODULE_0___default()('form.product-menu-form[action*="/cart/add"] select[name="id"] option:eq(' + e + ")").attr({
                                    "data-option1": t[e].option1,
                                    "data-option2": t[e].option2,
                                    "data-option3": t[e].option3,
                                    "data-available": t[e].available,
                                    "data-price": Shopify.formatMoney(t[e].price, Shopify.money_format),
                                    "data-compare-price": Shopify.formatMoney(t[e].compare_at_price, Shopify.money_format),
                                    "data-globoquantity": t[e].inventory_quantity,
                                    "data-inventory-management": t[e].inventory_management
                                }) : jquery__WEBPACK_IMPORTED_MODULE_0___default()('form.product-menu-form[action*="/cart/add"] select[name="id"] option:eq(' + e + ")").attr({
                                    "data-option1": t[e].option1,
                                    "data-option2": t[e].option2,
                                    "data-option3": t[e].option3,
                                    "data-available": t[e].available,
                                    "data-price": Shopify.formatMoney(t[e].price, Shopify.money_format),
                                    "data-globoquantity": t[e].inventory_quantity,
                                    "data-inventory-management": t[e].inventory_management
                                })
                        }(), jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on("change", ".globo-swatch-product-detail .swatch--gl .select-option :radio", (function() {
                            var n = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).closest(".globo-swatch-product-detail .swatch--gl").attr("data-option-index"),
                                r = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).val(),
                                o = parseInt(n) + 1;
                            jQuery(this).closest('form[action="/cart/add"]').find(selectors.singleOptionSelector).eq(n).val(r).trigger("change"), jquery__WEBPACK_IMPORTED_MODULE_0___default()("#SingleOptionSelector-0").length && document.getElementById("SingleOptionSelector-0").dispatchEvent(new CustomEvent("change")), jquery__WEBPACK_IMPORTED_MODULE_0___default()("#SingleOptionSelector-1").length && document.getElementById("SingleOptionSelector-1").dispatchEvent(new CustomEvent("change")), jquery__WEBPACK_IMPORTED_MODULE_0___default()("#SingleOptionSelector-2").length && document.getElementById("SingleOptionSelector-2").dispatchEvent(new CustomEvent("change")), jquery__WEBPACK_IMPORTED_MODULE_0___default()("#SingleOptionSelector-0").length && document.getElementById("SingleOptionSelector-0").dispatchEvent(new Event("change", {
                                bubbles: !0
                            })), jquery__WEBPACK_IMPORTED_MODULE_0___default()("#SingleOptionSelector-1").length && document.getElementById("SingleOptionSelector-1").dispatchEvent(new Event("change", {
                                bubbles: !0
                            })), jquery__WEBPACK_IMPORTED_MODULE_0___default()("#SingleOptionSelector-2").length && document.getElementById("SingleOptionSelector-2").dispatchEvent(new Event("change", {
                                bubbles: !0
                            })), jquery__WEBPACK_IMPORTED_MODULE_0___default()("#Option-product-" + n).length && (jquery__WEBPACK_IMPORTED_MODULE_0___default()("#Option-product-" + n).val(r).trigger("change"), document.getElementById("Option-product-" + n).dispatchEvent(new CustomEvent("change"))), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".product-single__meta .radio-wrapper").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()('.single-option-selector__radio[data-index="option' + o + '"]').val(r).trigger("change"), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".pf-variant-select").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()(".pf-variant-select").val(r).trigger("change"), jquery__WEBPACK_IMPORTED_MODULE_0___default()('input[data-single-option-selector][value="' + r + '"]').length && jquery__WEBPACK_IMPORTED_MODULE_0___default()('input[data-single-option-selector][value="' + r + '"]').trigger("click"), jquery__WEBPACK_IMPORTED_MODULE_0___default()('input[name="option-' + o + '"][value="' + r + '"]').length && jquery__WEBPACK_IMPORTED_MODULE_0___default()('input[name="option-' + o + '"][value="' + r + '"]').trigger("click"), jquery__WEBPACK_IMPORTED_MODULE_0___default()('input[name="option-' + n + '"][value="' + r + '"]').length && jquery__WEBPACK_IMPORTED_MODULE_0___default()('input[name="option-' + n + '"][value="' + r + '"]').trigger("click"), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".ColorSwatch__Radio").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()('input[name="option-' + n + '"][value="' + r + '"]').trigger("click"), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".selector-wrapper fieldset.single-option-radio").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()('input[data-index="option' + o + '"][value="' + r + '"]').trigger("click"), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".single-option-selector").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()('.single-option-selector[data-index="option' + o + '"]').val(r).trigger("change"), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".grid__item.radio-wrapper").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()('.single-option-selector__radio[data-index="option' + o + '"]').val(r).trigger("change"), jquery__WEBPACK_IMPORTED_MODULE_0___default()("[data-product-swatch-input]").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()('[name="option-' + n + "\"][value='" + r + "']").val("changed").val(r).trigger("click"), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".product-single__form .product-form__item").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()("#ProductSelect-option-" + n).find("input:radio[value='" + r + "']").val("changed").val(r).trigger("click"), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".option-values .option-value-input").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()(".option-values").find('.option-value-input[data-product-option="option' + o + "\"][value='" + r + "']").val("changed").val(r).trigger("click"), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".variant-wrapper .variant-input-wrap").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()("#ProductSelect-" + app.product.id + "-option-" + n).find("input:radio[value='" + r + "']").val("changed").val(r).trigger("click"), jquery__WEBPACK_IMPORTED_MODULE_0___default()("#product-content #add-to-cart .product-variant").length && (jquery__WEBPACK_IMPORTED_MODULE_0___default()("#product-content #add-to-cart #selector-" + n).find("select").val(r).trigger("change"), document.querySelector("#product-content #add-to-cart #selector-0 select").dispatchEvent(new Event("change")), document.querySelector("#product-content #add-to-cart #selector-1 select").dispatchEvent(new Event("change")), document.querySelector("#product-content #add-to-cart #selector-2 select").dispatchEvent(new Event("change"))), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".variant-group-multiple select.product-single__variants").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()(".variant-group-multiple select.product-single__variants[data-opnum=" + n + "]").val(r).trigger("change"), jquery__WEBPACK_IMPORTED_MODULE_0___default()("form.shopify-product-form .select select").length && (jquery__WEBPACK_IMPORTED_MODULE_0___default()("form.shopify-product-form .select select#productSelect-option-" + n).val(r).trigger("change"), jquery__WEBPACK_IMPORTED_MODULE_0___default()("select#productSelect-option-0").length && document.querySelector("select#productSelect-option-0").dispatchEvent(new Event("change")), jquery__WEBPACK_IMPORTED_MODULE_0___default()("select#productSelect-option-1").length && document.querySelector("select#productSelect-option-1").dispatchEvent(new Event("change")), jquery__WEBPACK_IMPORTED_MODULE_0___default()("select#productSelect-option-2").length && document.querySelector("select#productSelect-option-2").dispatchEvent(new Event("change"))), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".form-field-select-wrapper .form-field-select").length && (jquery__WEBPACK_IMPORTED_MODULE_0___default()('.form-field-select-wrapper .form-field-select[data-product-option="' + n + '"]').val(r).trigger("change"), document.querySelector('.form-field-select-wrapper .form-field-select[data-product-option="0"]').dispatchEvent(new Event("change")), document.querySelector('.form-field-select-wrapper .form-field-select[data-product-option="0"]').dispatchEvent(new Event("change")), document.querySelector('.form-field-select-wrapper .form-field-select[data-product-option="0"]').dispatchEvent(new Event("change"))), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".product-options .select-wrapper .single-option-selector").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()(".product-options .select-wrapper .single-option-selector[data-option-index=" + n + "]").val(r).trigger("change"), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".Popover__ValueList .Popover__Value").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()(".Popover__ValueList .Popover__Value[data-option-position=" + o + "][data-value='" + r + "']").trigger("click"), app.enable_mandatory && jquery__WEBPACK_IMPORTED_MODULE_0___default()(".ProductForm .ProductForm__AddToCart").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()(".ProductForm .ProductForm__AddToCart").hide(), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".form-element-select select.form-element").length && (jquery__WEBPACK_IMPORTED_MODULE_0___default()('.form-element-select select.form-element[data-product-option="option' + o + '"]').val(r).trigger("change"), document.querySelector('select.form-element[data-product-option="option1"]').dispatchEvent(new Event("change")), document.querySelector('select.form-element[data-product-option="option2"]').dispatchEvent(new Event("change")), document.querySelector('select.form-element[data-product-option="option3"]').dispatchEvent(new Event("change"))), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".product__variants .form__control .single-option-selector").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()('.product__variants .form__control .single-option-selector[name="single-option-selector-' + n + "\"][value='" + r + "']").trigger("click"), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".product__variants .form__control select.single-option-selector").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()("select#single-option-selector-" + n).val(r).trigger("change"), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".option label.option-label .option-input").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()('.option label.option-label .option-input[name="option-' + n + "\"][value='" + r + "']").trigger("click"), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".globo--option-selector").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()('.globo--option-selector[data-option-number="' + o + '"]').val(r).trigger("change");
                            var i = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parents(".globo-swatch-product-detail").find(".swatch--gl"),
                                a = [];
                            if (jquery__WEBPACK_IMPORTED_MODULE_0___default.a.each(i, (function(t, e) {
                                    var n = jquery__WEBPACK_IMPORTED_MODULE_0___default()(e).attr("data-option-index");
                                    a[n] = jquery__WEBPACK_IMPORTED_MODULE_0___default()(e).find('input[type="radio"]:checked').val()
                                })), 3 == a.length) {
                                var s = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).closest('form[action="/cart/add"]').find("select[name='id'] option[data-option1='" + a[0] + "'][data-option2='" + a[1] + "'][data-option3='" + a[2] + "'][data-available='true']").first().val();
                                jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).closest('form[action="/cart/add"]').find('select[name="id"]').val(s)
                            } else if (2 == a.length) {
                                var u = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).closest('form[action="/cart/add"]').find("select[name='id'] option[data-option1='" + a[0] + "'][data-option2='" + a[1] + "'][data-available='true']").first().val();
                                jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).closest('form[action="/cart/add"]').find('select[name="id"]').val(u)
                            } else if (1 == a.length) {
                                var l = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).closest('form[action="/cart/add"]').find("select[name='id'] option[data-option1='" + a[0] + "'][data-available='true']").first().val();
                                jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).closest('form[action="/cart/add"]').find('select[name="id"]').val(l)
                            }! function(n) {
                                var r = e.find(".globo-swatch-product-detail .swatch--gl");
                                r.length > 1 && e.find('.globo-swatch-product-detail .swatch--gl:not([data-option-index="' + n + '"]) :radio').each((function() {
                                    jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parent().removeClass("globo-out-of-stock")
                                })), r.each((function(e, n) {
                                    e = jquery__WEBPACK_IMPORTED_MODULE_0___default()(n).attr("data-option-index");
                                    var o = jquery__WEBPACK_IMPORTED_MODULE_0___default()(n).find('input[type="radio"]:checked').val();
                                    void 0 !== o && r.each((function(n, r) {
                                        n = jquery__WEBPACK_IMPORTED_MODULE_0___default()(r).attr("data-option-index"), e !== n && jquery__WEBPACK_IMPORTED_MODULE_0___default()(r).find(":radio").each((function(r, i) {
                                            for (var a = !1, s = 0, u = t.length; s < u; s++) {
                                                var l = t[s];
                                                !1 !== l.available && l.options[e] == o && l.options[n] == jquery__WEBPACK_IMPORTED_MODULE_0___default()(i).val() && (a = !0)
                                            }!1 === a && jquery__WEBPACK_IMPORTED_MODULE_0___default()(i).parent().not(".select-option--dropdown").addClass("globo-out-of-stock")
                                        }))
                                    }))
                                }))
                            }(n);
                            var c = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parents('form[action="/cart/add"]').find('select[name="id"] option:selected').val();
                            if (globoswatch.curVariant = globoswatch.product.variants.find((function(t) {
                                    return t.id == c
                                })), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".globo-swatch-detail-lists-price li").each((function() {
                                    if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).attr("data-value") === c) {
                                        var t = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.globo-swatch-detail-lists-price li[data-value="' + c + '"] .gw-li-price').html(),
                                            e = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.globo-swatch-detail-lists-price li[data-value="' + c + '"] .gw-li-compareprice').html();
                                        jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parents('form[action="/cart/add"]').find(".globo-cs-product_price").html(t), void 0 !== e ? jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parents('form[action="/cart/add"]').find(".globo-cs-product_oldprice").html(e) : jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parents('form[action="/cart/add"]').find(".globo-cs-product_oldprice").html("")
                                    }
                                })), app.show_number_stock) {
                                var d = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parents('form[action="/cart/add"]').find('select[name="id"] option:selected').data("globoquantity");
                                "shopify" == jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parents('form[action="/cart/add"]').find('select[name="id"] option:selected').data("inventory-management") ? jquery__WEBPACK_IMPORTED_MODULE_0___default()(".globo-number-stock-variant").html("Stock: only " + d + " left in stock") : jquery__WEBPACK_IMPORTED_MODULE_0___default()(".globo-number-stock-variant").html("")
                            }
                            jquery__WEBPACK_IMPORTED_MODULE_0___default()(".pf-variant-select").length && document.querySelector(".pf-variant-select").dispatchEvent(new Event("change")), changeCurrencyApp();
                            var p = document.createEvent("Event");
                            p.initEvent("globo_change_variant_product_detail", !0, !0), document.dispatchEvent(p)
                        })), window.innerWidth >= 750 && automatedVariantImageSwatch(), app.enable_mandatory && product.variants.length > 1 && (setTimeout((function() {
                            if (jquery__WEBPACK_IMPORTED_MODULE_0___default()("select#ProductSelect-product-template").length ? jquery__WEBPACK_IMPORTED_MODULE_0___default()('form[action*="/cart/add"] select#ProductSelect-product-template').prepend('<option value="">None</option>').val("").trigger("change") : jquery__WEBPACK_IMPORTED_MODULE_0___default()('form[action*="/cart/add"]:visible:first select[name="id"]').prepend('<option value="">None</option>').val("").trigger("change"), jquery__WEBPACK_IMPORTED_MODULE_0___default()('form.product-menu-form[action*="/cart/add"]').length && jquery__WEBPACK_IMPORTED_MODULE_0___default()('form.product-menu-form[action*="/cart/add"] select[name="id"]').prepend('<option value="">None</option>').val("").trigger("change"), app.curVariant.options.length) {
                                var t = app.curVariant.id;
                                jquery__WEBPACK_IMPORTED_MODULE_0___default()(".globo-swatch-product-detail input:radio:checked").length > 0 && (jquery__WEBPACK_IMPORTED_MODULE_0___default()("select#ProductSelect-product-template").length ? jquery__WEBPACK_IMPORTED_MODULE_0___default()('form[action*="/cart/add"] select#ProductSelect-product-template').val(t) : jquery__WEBPACK_IMPORTED_MODULE_0___default()('form[action*="/cart/add"]:visible:first select[name="id"]').val(t))
                            }
                        }), 1e3), jquery__WEBPACK_IMPORTED_MODULE_0___default()("#content #product-form li#product-add").length && (jquery__WEBPACK_IMPORTED_MODULE_0___default()("li#product-add .add-to-cart").hide(), jquery__WEBPACK_IMPORTED_MODULE_0___default()("#content #product-form li#product-add").append(jquery__WEBPACK_IMPORTED_MODULE_0___default()("<button class='action-btn accent-text add-to-cart globo-validationForm' type='button'>" + app.add_to_cart_text + "</button>"))), jquery__WEBPACK_IMPORTED_MODULE_0___default()('input#addtocart-product-template[name="ajouter"]').length && (jquery__WEBPACK_IMPORTED_MODULE_0___default()('input#addtocart-product-template[name="ajouter"]').hide(), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".product .item .info form.shopify-product-form").append(jquery__WEBPACK_IMPORTED_MODULE_0___default()("<button class='add-to-cart globo-validationForm' type='button'>" + app.add_to_cart_text + "</button>"))), jquery__WEBPACK_IMPORTED_MODULE_0___default()("#product-add input#AddToCart").length && (jquery__WEBPACK_IMPORTED_MODULE_0___default()("#product-add input#AddToCart").attr("style", "display:none !important"), jquery__WEBPACK_IMPORTED_MODULE_0___default()("form#AddToCartForm #product-add").append(jquery__WEBPACK_IMPORTED_MODULE_0___default()("<button class='add globo-validationForm' type='button'>" + app.add_to_cart_text + "</button>"))), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".ProductForm .ProductForm__AddToCart").length && (jquery__WEBPACK_IMPORTED_MODULE_0___default()(".ProductForm .ProductForm__AddToCart").hide(), jquery__WEBPACK_IMPORTED_MODULE_0___default()("<button class='Button Button--full Button--secondary globo-validationForm' type='button'>" + app.add_to_cart_text + "</button>").insertAfter(".ProductForm .ProductForm__Variants")), jquery__WEBPACK_IMPORTED_MODULE_0___default()("form[data-product-form] button[data-product-add]").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()("form[data-product-form] button[data-product-add]").attr("type", "button"), jquery__WEBPACK_IMPORTED_MODULE_0___default()("input#AddToCart-product-template").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()("input#AddToCart-product-template").attr("type", "button"), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".product-details-wrapper .add-to-cart input").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()(".product-details-wrapper .add-to-cart input").attr("type", "button"), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".product-add input#AddToCart").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()(".product-add input#AddToCart").attr("type", "button"), jquery__WEBPACK_IMPORTED_MODULE_0___default()("#product-content #add-to-cart #addToCart").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()("#product-content #add-to-cart #addToCart").attr("type", "button"), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".product-form-submit-wrap .add-to-cart-button").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()(".product-form-submit-wrap .add-to-cart-button").attr("type", "button"), jquery__WEBPACK_IMPORTED_MODULE_0___default()('form[action*="/cart/add"] button#AddToCartDesk').length && jquery__WEBPACK_IMPORTED_MODULE_0___default()('form[action*="/cart/add"] button#AddToCartDesk').attr("type", "button"), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".productForm-block .productForm-submit").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()(".productForm-block .productForm-submit").attr("type", "button"), jquery__WEBPACK_IMPORTED_MODULE_0___default()("form.shopify-product-form button.add-to-cart").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()("form.shopify-product-form button.add-to-cart").attr("type", "button"), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".btn-wrapper-c .add").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()(".btn-wrapper-c .add").attr("type", "button"), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".product-submit input.add-to-cart").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()(".product-submit input.add-to-cart").attr("type", "button"), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".form-element-quantity-submit .form-element-submit-button").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()(".form-element-quantity-submit .form-element-submit-button").attr("type", "button"), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".quantity-submit-row__submit input.button").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()(".quantity-submit-row__submit input.button").prop("type", "button"), jquery__WEBPACK_IMPORTED_MODULE_0___default()("form#AddToCartForm .product-add input#addToCart").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()("form#AddToCartForm .product-add input#addToCart").attr("type", "button"), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".product__form .product__add-to-cart").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()(".product__form .product__add-to-cart").attr("type", "button"), jquery__WEBPACK_IMPORTED_MODULE_0___default()("#product-description form .product-add .add").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()("#product-description form .product-add .add").attr("type", "button"), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".product-add input.button.product-add-available").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()(".product-add input.button.product-add-available").attr("type", "button"), jquery__WEBPACK_IMPORTED_MODULE_0___default()("#product-area .product-details-wrapper .options .selector-wrapper .submit").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()("#product-area .product-details-wrapper .options .selector-wrapper .submit").attr("type", "button"), jquery__WEBPACK_IMPORTED_MODULE_0___default()(e).find('[name="add"], .product-form--atc-button[data-product-atc], button.single_add_to_cart_button.ajax_form_cart, button[data-action="add-to-cart"], .globo__validation-default').attr("type", "button"), jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.btnValidationAddtocart).on("click", (function(t) {
                            var n = !0;
                            jquery__WEBPACK_IMPORTED_MODULE_0___default()(e).find(".globo-swatch-product-detail input:radio").each((function() {
                                var t = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).attr("name");
                                0 == jquery__WEBPACK_IMPORTED_MODULE_0___default()(e).find('.globo-swatch-product-detail input:radio[name="' + t + '"]:checked').length ? n = !1 : jquery__WEBPACK_IMPORTED_MODULE_0___default()('.errorOptions[data-nameinput="' + t + '"]').remove()
                            })), jquery__WEBPACK_IMPORTED_MODULE_0___default()('form[action="/cart/add.js"]').length && jquery__WEBPACK_IMPORTED_MODULE_0___default()('form[action="/cart/add.js"]').find(".globo-swatch-product-detail input:radio").each((function() {
                                var t = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).attr("name");
                                0 == jquery__WEBPACK_IMPORTED_MODULE_0___default()('form[action="/cart/add.js"]').find(".globo-swatch-product-detail input:radio[name=" + t + "]:checked").length ? n = !1 : jquery__WEBPACK_IMPORTED_MODULE_0___default()('.errorOptions[data-nameinput="' + t + '"]').remove()
                            })), n ? (jquery__WEBPACK_IMPORTED_MODULE_0___default()(".errorOptions").remove(), jquery__WEBPACK_IMPORTED_MODULE_0___default()(e).find('[name="add"], .product-form--atc-button[data-product-atc], input#AddToCart-product-template, button[data-action="add-to-cart"], .globo__validation-default').attr("type", "submit"), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".product-details-wrapper .add-to-cart input").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()(".product-details-wrapper .add-to-cart input").attr("type", "submit"), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".product-add input#AddToCart").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()(".product-add input#AddToCart").attr("type", "submit"), jquery__WEBPACK_IMPORTED_MODULE_0___default()("#product-content #add-to-cart #addToCart").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()("#product-content #add-to-cart #addToCart").attr("type", "submit"), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".product-form-submit-wrap .add-to-cart-button").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()(".product-form-submit-wrap .add-to-cart-button").attr("type", "submit"), jquery__WEBPACK_IMPORTED_MODULE_0___default()('form[action*="/cart/add"] button#AddToCartDesk').length && jquery__WEBPACK_IMPORTED_MODULE_0___default()('form[action*="/cart/add"] button#AddToCartDesk').attr("type", "submit"), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".productForm-block .productForm-submit").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()(".productForm-block .productForm-submit").attr("type", "submit"), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".btn-wrapper-c .add").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()(".btn-wrapper-c .add").attr("type", "submit"), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".product-submit input.add-to-cart").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()(".product-submit input.add-to-cart").attr("type", "submit"), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".form-element-quantity-submit .form-element-submit-button").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()(".form-element-quantity-submit .form-element-submit-button").attr("type", "submit"), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".quantity-submit-row__submit input.button").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()(".quantity-submit-row__submit input.button").prop("type", "submit"), jquery__WEBPACK_IMPORTED_MODULE_0___default()("form#AddToCartForm .product-add input#addToCart").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()("form#AddToCartForm .product-add input#addToCart").attr("type", "submit"), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".product__form .product__add-to-cart").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()(".product__form .product__add-to-cart").attr("type", "submit"), jquery__WEBPACK_IMPORTED_MODULE_0___default()("#product-description form .product-add .add").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()("#product-description form .product-add .add").attr("type", "submit"), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".product-add input.button.product-add-available").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()(".product-add input.button.product-add-available").attr("type", "submit"), jquery__WEBPACK_IMPORTED_MODULE_0___default()("#product-area .product-details-wrapper .options .selector-wrapper .submit").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()("#product-area .product-details-wrapper .options .selector-wrapper .submit").attr("type", "submit"), jquery__WEBPACK_IMPORTED_MODULE_0___default()("#content #product-form li#product-add").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()("li#product-add .add-to-cart").trigger("click"), jquery__WEBPACK_IMPORTED_MODULE_0___default()('input#addtocart-product-template[name="ajouter"]').length && (jquery__WEBPACK_IMPORTED_MODULE_0___default()(".add-to-cart.globo-validationForm").hide(), jquery__WEBPACK_IMPORTED_MODULE_0___default()('input#addtocart-product-template[name="ajouter"]').trigger("click")), jquery__WEBPACK_IMPORTED_MODULE_0___default()("#product-add input#AddToCart").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()("#product-add input#AddToCart").trigger("click"), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".ProductForm .ProductForm__AddToCart").length && jquery__WEBPACK_IMPORTED_MODULE_0___default()(".ProductForm .ProductForm__AddToCart").trigger("click")) : (t.stopImmediatePropagation(), jquery__WEBPACK_IMPORTED_MODULE_0___default()(".errorOptions").html(app.text_required))
                        })))
                }
            }
        }, jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).ready((function() {
            if (window.globoswatch = new GloboSwatch(GloboSwatchConfig), globoswatch.init(), "product" == GloboSwatchConfig.page && jQuery(".g-variant-color-detail").length) {
                var t = GloboSwatchConfig.curVariant.option1;
                setTimeout((function() {
                    jQuery(".product-single__thumbnails.slick-initialized").length && (jQuery(".product-single__thumbnail-item").removeClass("hide"), jQuery(".product-single__thumbnails").slick("slickUnfilter"), jQuery(".product-single__thumbnails").slick("slickFilter", '.product-single__thumbnail-item[data-color="' + t + '"], .product-single__thumbnail-item[data-color="AllColors"]')), jQuery("#product-thumbnails-product-template .thumbnails.slick-initialized").length && (jQuery("#product-thumbnails-product-template .thumbnails .thumbnail-gallery-item").removeClass("hide"), jQuery("#product-thumbnails-product-template .thumbnails").slick("slickUnfilter"), jQuery("#product-thumbnails-product-template .thumbnails").slick("slickFilter", 'div[data-color="' + t + '"], div[data-color="AllColors"]'))
                }), 1e3), window.addEventListener("colorChange", (function(t) {
                    jQuery(".product-single__thumbnail-item").removeClass("hide"), jQuery(".product-single__thumbnails").slick("slickUnfilter"), jQuery(".product-single__thumbnails").slick("slickFilter", '.product-single__thumbnail-item[data-color="' + t.detail.color + '"], .product-single__thumbnail-item[data-color="AllColors"]')
                })), window.addEventListener("colorChangeFaster", (function(t) {
                    jQuery("#product-thumbnails-product-template .thumbnails .thumbnail-gallery-item").removeClass("hide"), jQuery("#product-thumbnails-product-template .thumbnails").slick("slickUnfilter"), jQuery("#product-thumbnails-product-template .thumbnails").slick("slickFilter", 'div[data-color="' + t.detail.color + '"], div[data-color="AllColors"]')
                }))
            }
        }))
    },
    30: function(t, e, n) {
        "use strict";
        n.d(e, "a", (function() {
            return Se
        }));
        class r {
            valueOf() {}
            liquidMethodMissing(t) {}
        }
        var o = function() {
            return (o = Object.assign || function(t) {
                for (var e, n = 1, r = arguments.length; n < r; n++)
                    for (var o in e = arguments[n]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                return t
            }).apply(this, arguments)
        };
        const i = Object.prototype.toString,
            a = String.prototype.toLowerCase;

        function s(t) {
            return "[object String]" === i.call(t)
        }

        function u(t) {
            return "function" == typeof t
        }

        function l(t) {
            return p(t = c(t)) ? "" : String(t)
        }

        function c(t) {
            return t instanceof r ? t.valueOf() : t
        }

        function d(t) {
            return "number" == typeof t
        }

        function p(t) {
            return null == t
        }

        function _(t) {
            return "[object Array]" === i.call(t)
        }

        function f(t, e) {
            t = t || {};
            for (const n in t)
                if (t.hasOwnProperty(n) && !1 === e(t[n], n, t)) break;
            return t
        }

        function h(t) {
            return t[t.length - 1]
        }

        function g(t) {
            const e = typeof t;
            return null !== t && ("object" === e || "function" === e)
        }

        function m(t, e, n = 1) {
            const r = [];
            for (let o = t; o < e; o += n) r.push(o);
            return r
        }

        function y(t, e, n = " ") {
            return E(t, e, n, (t, e) => e + t)
        }

        function E(t, e, n, r) {
            let o = e - (t = String(t)).length;
            for (; o-- > 0;) t = r(t, n);
            return t
        }

        function v(t) {
            return t
        }

        function b(t) {
            return t.replace(/(\w?)([A-Z])/g, (t, e, n) => (e ? e + "_" : "") + n.toLowerCase())
        }

        function O(t, e) {
            return null == t && null == e ? 0 : null == t ? 1 : null == e || (t = a.call(t)) < (e = a.call(e)) ? -1 : t > e ? 1 : 0
        }
        class D {
            constructor(t, e, n, r) {
                this.key = t, this.value = e, this.next = n, this.prev = r
            }
        }
        class P {
            constructor(t, e = 0) {
                this.limit = t, this.size = e, this.cache = {}, this.head = new D("HEAD", null, null, null), this.tail = new D("TAIL", null, null, null), this.head.next = this.tail, this.tail.prev = this.head
            }
            write(t, e) {
                if (this.cache[t]) this.cache[t].value = e;
                else {
                    const n = new D(t, e, this.head.next, this.head);
                    this.head.next.prev = n, this.head.next = n, this.cache[t] = n, this.size++, this.ensureLimit()
                }
            }
            read(t) {
                if (!this.cache[t]) return;
                const {
                    value: e
                } = this.cache[t];
                return this.remove(t), this.write(t, e), e
            }
            remove(t) {
                const e = this.cache[t];
                e.prev.next = e.next, e.next.prev = e.prev, delete this.cache[t], this.size--
            }
            clear() {
                this.head.next = this.tail, this.tail.prev = this.head, this.size = 0, this.cache = {}
            }
            ensureLimit() {
                this.size > this.limit && this.remove(this.tail.prev.key)
            }
        }
        const M = {
            root: ["."],
            cache: void 0,
            extname: "",
            dynamicPartials: !0,
            jsTruthy: !1,
            trimTagRight: !1,
            trimTagLeft: !1,
            trimOutputRight: !1,
            trimOutputLeft: !1,
            greedy: !0,
            tagDelimiterLeft: "{%",
            tagDelimiterRight: "%}",
            outputDelimiterLeft: "{{",
            outputDelimiterRight: "}}",
            strictFilters: !1,
            strictVariables: !1,
            globals: {}
        };

        function T(t) {
            if ((t = t || {}).hasOwnProperty("root") && (t.root = w(t.root)), t.hasOwnProperty("cache")) {
                let e;
                e = "number" == typeof t.cache ? t.cache > 0 ? new P(t.cache) : void 0 : "object" == typeof t.cache ? t.cache : t.cache ? new P(1024) : void 0, t.cache = e
            }
            return t
        }

        function w(t) {
            return _(t) ? t : s(t) ? [t] : []
        }
        class C {
            constructor(t = {}, e = M, n = !1) {
                this.scopes = [{}], this.registers = {}, this.sync = n, this.opts = e, this.globals = e.globals, this.environments = t
            }
            getRegister(t, e = {}) {
                return this.registers[t] = this.registers[t] || e
            }
            setRegister(t, e) {
                return this.registers[t] = e
            }
            saveRegister(...t) {
                return t.map(t => [t, this.getRegister(t)])
            }
            restoreRegister(t) {
                return t.forEach(([t, e]) => this.setRegister(t, e))
            }
            getAll() {
                return [this.globals, this.environments, ...this.scopes].reduce((t, e) => o(t, e), {})
            }
            get(t) {
                const e = this.findScope(t[0]);
                return this.getFromScope(e, t)
            }
            getFromScope(t, e) {
                return "string" == typeof e && (e = e.split(".")), e.reduce((t, e) => {
                    if (t = function(t, e) {
                            if (p(t)) return t;
                            if ((t = function t(e) {
                                    return e && u(e.toLiquid) ? t(e.toLiquid()) : e
                                }(t)) instanceof r) return u(t[e]) ? t[e]() : t.hasOwnProperty(e) ? t[e] : t.liquidMethodMissing(e);
                            return "size" === e ? function(t) {
                                return _(t) || s(t) ? t.length : t.size
                            }(t) : "first" === e ? function(t) {
                                return _(t) ? t[0] : t.first
                            }(t) : "last" === e ? function(t) {
                                return _(t) ? t[t.length - 1] : t.last
                            }(t) : t[e]
                        }(t, e), p(t) && this.opts.strictVariables) throw new TypeError("undefined variable: " + e);
                    return t
                }, t)
            }
            push(t) {
                return this.scopes.push(t)
            }
            pop() {
                return this.scopes.pop()
            }
            bottom() {
                return this.scopes[0]
            }
            findScope(t) {
                for (let e = this.scopes.length - 1; e >= 0; e--) {
                    const n = this.scopes[e];
                    if (t in n) return n
                }
                return t in this.environments ? this.environments : this.globals
            }
        }
        var x, A = Object.freeze({
            resolve: function(t, e, n) {
                return t.length && "/" !== h(t) && (t += "/"),
                    function(t, e) {
                        const n = document.createElement("base");
                        n.href = t;
                        const r = document.getElementsByTagName("head")[0];
                        r.insertBefore(n, r.firstChild);
                        const o = document.createElement("a");
                        o.href = e;
                        const i = o.href;
                        return r.removeChild(n), i
                    }(t, e).replace(/^(\w+:\/\/[^/]+)(\/[^?]+)/, (t, e, r) => {
                        const o = r.split("/").pop();
                        return /\.\w+$/.test(o) ? t : e + r + n
                    })
            },
            readFile: async function(t) {
                return new Promise((e, n) => {
                    const r = new XMLHttpRequest;
                    r.onload = () => {
                        r.status >= 200 && r.status < 300 ? e(r.responseText) : n(new Error(r.statusText))
                    }, r.onerror = () => {
                        n(new Error("An error occurred whilst receiving the response."))
                    }, r.open("GET", t), r.send()
                })
            },
            readFileSync: function(t) {
                const e = new XMLHttpRequest;
                if (e.open("GET", t, !1), e.send(), e.status < 200 || e.status >= 300) throw new Error(e.statusText);
                return e.responseText
            },
            exists: async function(t) {
                return !0
            },
            existsSync: function(t) {
                return !0
            }
        });

        function q(t) {
            return !!(N(t) & x.Delimited)
        }

        function j(t) {
            return N(t) === x.Operator
        }

        function L(t) {
            return N(t) === x.HTML
        }

        function R(t) {
            return N(t) === x.Output
        }

        function I(t) {
            return N(t) === x.Tag
        }

        function B(t) {
            return N(t) === x.Quoted
        }

        function W(t) {
            return N(t) === x.Literal
        }

        function k(t) {
            return N(t) === x.Number
        }

        function U(t) {
            return N(t) === x.PropertyAccess
        }

        function S(t) {
            return N(t) === x.Word
        }

        function K(t) {
            return N(t) === x.Range
        }

        function N(t) {
            return t ? t.kind : -1
        }! function(t) {
            t[t.Number = 1] = "Number", t[t.Literal = 2] = "Literal", t[t.Tag = 4] = "Tag", t[t.Output = 8] = "Output", t[t.HTML = 16] = "HTML", t[t.Filter = 32] = "Filter", t[t.Hash = 64] = "Hash", t[t.PropertyAccess = 128] = "PropertyAccess", t[t.Word = 256] = "Word", t[t.Range = 512] = "Range", t[t.Quoted = 1024] = "Quoted", t[t.Operator = 2048] = "Operator", t[t.Delimited = 12] = "Delimited"
        }(x || (x = {}));
        const F = [0, 0, 0, 0, 0, 0, 0, 0, 0, 20, 4, 4, 4, 20, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 20, 2, 8, 0, 0, 0, 0, 8, 0, 0, 0, 64, 0, 65, 0, 0, 33, 33, 33, 33, 33, 33, 33, 33, 33, 33, 0, 0, 2, 2, 2, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0];

        function H(t, e) {
            if (!t || !L(t)) return;
            const n = e ? 4 : 16;
            for (; F[t.input.charCodeAt(t.end - 1 - t.trimRight)] & n;) t.trimRight++
        }

        function $(t, e) {
            if (!t || !L(t)) return;
            const n = e ? 4 : 16;
            for (; F[t.input.charCodeAt(t.begin + t.trimLeft)] & n;) t.trimLeft++;
            "\n" === t.input.charAt(t.begin + t.trimLeft) && t.trimLeft++
        }
        F[160] = F[5760] = F[6158] = F[8192] = F[8193] = F[8194] = F[8195] = F[8196] = F[8197] = F[8198] = F[8199] = F[8200] = F[8201] = F[8202] = F[8232] = F[8233] = F[8239] = F[8287] = F[12288] = 4;
        class V {
            constructor(t, e, n, r, o) {
                this.kind = t, this.input = e, this.begin = n, this.end = r, this.file = o
            }
            getText() {
                return this.input.slice(this.begin, this.end)
            }
            getPosition() {
                let [t, e] = [1, 1];
                for (let n = 0; n < this.begin; n++) "\n" === this.input[n] ? (t++, e = 1) : e++;
                return [t, e]
            }
            size() {
                return this.end - this.begin
            }
        }
        class z extends V {
            constructor(t, e) {
                super(x.Number, t.input, t.begin, e ? e.end : t.end, t.file), this.whole = t, this.decimal = e
            }
        }
        class G extends V {
            constructor(t, e, n, r) {
                super(x.Word, t, e, n, r), this.input = t, this.begin = e, this.end = n, this.file = r, this.content = this.getText()
            }
            isNumber(t = !1) {
                for (let e = t && 64 & F[this.input.charCodeAt(this.begin)] ? this.begin + 1 : this.begin; e < this.end; e++)
                    if (!(32 & F[this.input.charCodeAt(e)])) return !1;
                return !0
            }
        }
        class Q extends r {
            equals(t) {
                return s(t) || _(t) ? 0 === t.length : !!g(t) && 0 === Object.keys(t).length
            }
            gt() {
                return !1
            }
            geq() {
                return !1
            }
            lt() {
                return !1
            }
            leq() {
                return !1
            }
            valueOf() {
                return ""
            }
        }
        class X extends Q {
            equals(t) {
                return !1 === t || (!!p(c(t)) || (s(t) ? /^\s*$/.test(t) : super.equals(t)))
            }
        }
        class Y extends r {
            equals(t) {
                return p(c(t)) || t instanceof X
            }
            gt() {
                return !1
            }
            geq() {
                return !1
            }
            lt() {
                return !1
            }
            leq() {
                return !1
            }
            valueOf() {
                return null
            }
        }
        const J = {
            true: !0,
            false: !1,
            nil: new Y,
            null: new Y,
            empty: new Q,
            blank: new X
        };
        class Z extends V {
            constructor(t, e, n, r) {
                super(x.Literal, t, e, n, r), this.input = t, this.begin = e, this.end = n, this.file = r, this.literal = this.getText()
            }
        }
        const tt = {
            "==": 1,
            "!=": 1,
            ">": 1,
            "<": 1,
            ">=": 1,
            "<=": 1,
            contains: 1,
            and: 0,
            or: 0
        };
        class et extends V {
            constructor(t, e, n, r) {
                super(x.Operator, t, e, n, r), this.input = t, this.begin = e, this.end = n, this.file = r, this.operator = this.getText()
            }
            getPrecedence() {
                return tt[this.getText()]
            }
        }
        const nt = /[\da-fA-F]/,
            rt = /[0-7]/,
            ot = {
                b: "\b",
                f: "\f",
                n: "\n",
                r: "\r",
                t: "\t",
                v: "\v"
            };

        function it(t) {
            const e = t.charCodeAt(0);
            return e >= 97 ? e - 87 : e >= 65 ? e - 55 : e - 48
        }

        function at(t) {
            let e = "";
            for (let n = 1; n < t.length - 1; n++)
                if ("\\" === t[n])
                    if (void 0 !== ot[t[n + 1]]) e += ot[t[++n]];
                    else if ("u" === t[n + 1]) {
                let r = 0,
                    o = n + 2;
                for (; o <= n + 5 && nt.test(t[o]);) r = 16 * r + it(t[o++]);
                n = o - 1, e += String.fromCharCode(r)
            } else if (rt.test(t[n + 1])) {
                let r = n + 1,
                    o = 0;
                for (; r <= n + 3 && rt.test(t[r]);) o = 8 * o + it(t[r++]);
                n = r - 1, e += String.fromCharCode(o)
            } else e += t[++n];
            else e += t[n];
            return e
        }
        class st extends V {
            constructor(t, e, n) {
                super(x.PropertyAccess, t.input, t.begin, n, t.file), this.variable = t, this.props = e
            }
            getVariableAsText() {
                return this.variable instanceof G ? this.variable.getText() : at(this.variable.getText())
            }
        }
        class ut extends Error {
            constructor(t, e) {
                super(t.message), this.originalError = t, this.token = e
            }
            update() {
                const t = this.originalError,
                    e = function(t) {
                        const [e] = t.getPosition(), n = t.input.split("\n"), r = Math.max(e - 2, 1), o = Math.min(e + 3, n.length);
                        return m(r, o + 1).map(t => `${t===e?">> ":"   "}${y(String(t),String(o).length)}| ${n[t-1]}`).join("\n")
                    }(this.token);
                this.message = function(t, e) {
                    e.file && (t += ", file:" + e.file);
                    const [n, r] = e.getPosition();
                    return t += `, line:${n}, col:${r}`
                }(t.message, this.token), this.stack = this.message + "\n" + e + "\n" + this.stack + "\nFrom " + t.stack
            }
        }
        class lt extends ut {
            constructor(t, e) {
                super(new Error(t), e), this.name = "TokenizationError", super.update()
            }
        }
        class ct extends ut {
            constructor(t, e) {
                super(t, e), this.name = "ParseError", this.message = t.message, super.update()
            }
        }
        class dt extends ut {
            constructor(t, e) {
                super(t, e.token), this.name = "RenderError", this.message = t.message, super.update()
            }
            static is(t) {
                return t instanceof dt
            }
        }
        class pt extends Error {
            constructor(t) {
                super(t), this.name = "AssertionError", this.message = t + ""
            }
        }

        function _t(t, e) {
            if (!t) {
                const n = e ? e() : `expect ${t} to be true`;
                throw new pt(n)
            }
        }
        class ft extends V {
            constructor(t, e, n, r, o, i) {
                super(x.Filter, n, r, o, i), this.name = t, this.args = e
            }
        }
        class ht extends V {
            constructor(t, e, n, r, o, i) {
                super(x.Hash, t, e, n, i), this.input = t, this.begin = e, this.end = n, this.name = r, this.value = o, this.file = i
            }
        }
        class gt extends V {
            constructor(t, e, n, r) {
                super(x.Quoted, t, e, n, r), this.input = t, this.begin = e, this.end = n, this.file = r
            }
        }
        class mt extends V {
            constructor(t, e, n, r) {
                super(x.HTML, t, e, n, r), this.input = t, this.begin = e, this.end = n, this.file = r, this.trimLeft = 0, this.trimRight = 0
            }
            getContent() {
                return this.input.slice(this.begin + this.trimLeft, this.end - this.trimRight)
            }
        }
        class yt extends V {
            constructor(t, e, n, r, o, i, a, s) {
                super(t, n, r, o, s), this.trimLeft = !1, this.trimRight = !1, this.content = this.getText();
                const u = "-" === e[0],
                    l = "-" === h(e);
                this.content = e.slice(u ? 1 : 0, l ? -1 : e.length).trim(), this.trimLeft = u || i, this.trimRight = l || a
            }
        }
        class Et extends yt {
            constructor(t, e, n, r, o) {
                const {
                    trimTagLeft: i,
                    trimTagRight: a,
                    tagDelimiterLeft: s,
                    tagDelimiterRight: u
                } = r, l = t.slice(e + s.length, n - u.length);
                super(x.Tag, l, t, e, n, i, a, o);
                let c = 0;
                for (; 1 & F[this.content.charCodeAt(c)];) c++;
                if (this.name = this.content.slice(0, c), !this.name) throw new lt("illegal tag syntax", this);
                let d = c;
                for (; 4 & F[this.content.charCodeAt(d)];) d++;
                this.args = this.content.slice(d)
            }
        }
        class vt extends V {
            constructor(t, e, n, r, o, i) {
                super(x.Range, t, e, n, i), this.input = t, this.begin = e, this.end = n, this.lhs = r, this.rhs = o, this.file = i
            }
        }
        class bt extends yt {
            constructor(t, e, n, r, o) {
                const {
                    trimOutputLeft: i,
                    trimOutputRight: a,
                    outputDelimiterLeft: s,
                    outputDelimiterRight: u
                } = r, l = t.slice(e + s.length, n - u.length);
                super(x.Output, l, t, e, n, i, a, o)
            }
        }
        const Ot = {
            a: {
                n: {
                    d: {
                        end: !0,
                        needBoundary: !0
                    }
                }
            },
            o: {
                r: {
                    end: !0,
                    needBoundary: !0
                }
            },
            c: {
                o: {
                    n: {
                        t: {
                            a: {
                                i: {
                                    n: {
                                        s: {
                                            end: !0,
                                            needBoundary: !0
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "=": {
                "=": {
                    end: !0
                }
            },
            "!": {
                "=": {
                    end: !0
                }
            },
            ">": {
                end: !0,
                "=": {
                    end: !0
                }
            },
            "<": {
                end: !0,
                "=": {
                    end: !0
                }
            }
        };
        class Dt {
            constructor(t, e = "") {
                this.input = t, this.file = e, this.p = 0, this.N = t.length
            }* readExpression() {
                const t = this.readValue();
                if (t)
                    for (yield t; this.p < this.N;) {
                        const t = this.readOperator();
                        if (!t) return;
                        const e = this.readValue();
                        if (!e) return;
                        yield t, yield e
                    }
            }
            readOperator() {
                this.skipBlank();
                const t = function(t, e, n = t.length) {
                    let r, o = Ot,
                        i = e;
                    for (; o[t[i]] && i < n;) o = o[t[i++]], o.end && (r = o);
                    return r ? r.needBoundary && 1 & t.charCodeAt(i) ? -1 : i : -1
                }(this.input, this.p, this.p + 8);
                if (-1 !== t) return new et(this.input, this.p, this.p = t, this.file)
            }
            readFilters() {
                const t = [];
                for (;;) {
                    const e = this.readFilter();
                    if (!e) return t;
                    t.push(e)
                }
            }
            readFilter() {
                if (this.skipBlank(), this.end()) return null;
                _t("|" === this.peek(), () => "unexpected token at " + this.snapshot()), this.p++;
                const t = this.p,
                    e = this.readWord();
                if (!e.size()) return null;
                const n = [];
                if (this.skipBlank(), ":" === this.peek())
                    do {
                        ++this.p;
                        const t = this.readFilterArg();
                        for (t && n.push(t); this.p < this.N && "," !== this.peek() && "|" !== this.peek();) ++this.p
                    } while ("," === this.peek());
                return new ft(e.getText(), n, this.input, t, this.p, this.file)
            }
            readFilterArg() {
                const t = this.readValue();
                if (!t) return;
                if (this.skipBlank(), ":" !== this.peek()) return t;
                ++this.p;
                const e = this.readValue();
                return [t.getText(), e]
            }
            readTopLevelTokens(t = M) {
                const e = [];
                for (; this.p < this.N;) {
                    const n = this.readTopLevelToken(t);
                    e.push(n)
                }
                return function(t, e) {
                    e = Object.assign({
                        greedy: !0
                    }, e);
                    let n = !1;
                    for (let r = 0; r < t.length; r++) {
                        const o = t[r];
                        q(o) && (!n && o.trimLeft && H(t[r - 1], e.greedy), I(o) && ("raw" === o.name ? n = !0 : "endraw" === o.name && (n = !1)), !n && o.trimRight && $(t[r + 1], e.greedy))
                    }
                }(e, t), e
            }
            readTopLevelToken(t) {
                const {
                    tagDelimiterLeft: e,
                    outputDelimiterLeft: n
                } = t;
                return this.matchWord(e) ? this.readTagToken(t) : this.matchWord(n) ? this.readOutputToken(t) : this.readHTMLToken(t)
            }
            readHTMLToken(t) {
                const e = this.p;
                for (; this.p < this.N;) {
                    const {
                        tagDelimiterLeft: e,
                        outputDelimiterLeft: n
                    } = t;
                    if (this.matchWord(e)) break;
                    if (this.matchWord(n)) break;
                    ++this.p
                }
                return new mt(this.input, e, this.p, this.file)
            }
            readTagToken(t) {
                const {
                    file: e,
                    input: n
                } = this, {
                    tagDelimiterRight: r
                } = t, o = this.p;
                return -1 === this.readTo(r) && this.mkError(`tag ${this.snapshot(o)} not closed`, o), new Et(n, o, this.p, t, e)
            }
            readOutputToken(t) {
                const {
                    file: e,
                    input: n
                } = this, {
                    outputDelimiterRight: r
                } = t, o = this.p;
                return -1 === this.readTo(r) && this.mkError(`output ${this.snapshot(o)} not closed`, o), new bt(n, o, this.p, t, e)
            }
            mkError(t, e) {
                throw new lt(t, new G(this.input, e, this.N, this.file))
            }
            snapshot(t = this.p) {
                return JSON.stringify((e = this.input.slice(t), n = 16, e.length > n ? e.substr(0, n - 3) + "..." : e));
                var e, n
            }
            readWord() {
                this.skipBlank();
                const t = this.p;
                for (; 1 & this.peekType();) ++this.p;
                return new G(this.input, t, this.p, this.file)
            }
            readHashes() {
                const t = [];
                for (;;) {
                    const e = this.readHash();
                    if (!e) return t;
                    t.push(e)
                }
            }
            readHash() {
                this.skipBlank(), "," === this.peek() && ++this.p;
                const t = this.p,
                    e = this.readWord();
                if (!e.size()) return;
                let n;
                return this.skipBlank(), ":" === this.peek() && (++this.p, n = this.readValue()), new ht(this.input, t, this.p, e, n, this.file)
            }
            remaining() {
                return this.input.slice(this.p)
            }
            advance(t = 1) {
                this.p += t
            }
            end() {
                return this.p >= this.N
            }
            readTo(t) {
                for (; this.p < this.N;)
                    if (++this.p, this.reverseMatchWord(t)) return this.p;
                return -1
            }
            readValue() {
                const t = this.readQuoted() || this.readRange();
                if (t) return t;
                if ("[" === this.peek()) {
                    this.p++;
                    const t = this.readQuoted();
                    if (!t) return;
                    if ("]" !== this.peek()) return;
                    return this.p++, new st(t, [], this.p)
                }
                const e = this.readWord();
                if (!e.size()) return;
                let n = e.isNumber(!0);
                const r = [];
                for (;;)
                    if ("[" === this.peek()) {
                        n = !1, this.p++;
                        const t = this.readValue() || new G(this.input, this.p, this.p, this.file);
                        this.readTo("]"), r.push(t)
                    } else {
                        if ("." !== this.peek() || "." === this.peek(1)) break; {
                            this.p++;
                            const t = this.readWord();
                            if (!t.size()) break;
                            t.isNumber() || (n = !1), r.push(t)
                        }
                    } return !r.length && J.hasOwnProperty(e.content) ? new Z(this.input, e.begin, e.end, this.file) : n ? new z(e, r[0]) : new st(e, r, this.p)
            }
            readRange() {
                this.skipBlank();
                const t = this.p;
                if ("(" !== this.peek()) return;
                ++this.p;
                const e = this.readValueOrThrow();
                this.p += 2;
                const n = this.readValueOrThrow();
                return ++this.p, new vt(this.input, t, this.p, e, n, this.file)
            }
            readValueOrThrow() {
                const t = this.readValue();
                return _t(t, () => `unexpected token ${this.snapshot()}, value expected`), t
            }
            readQuoted() {
                this.skipBlank();
                const t = this.p;
                if (!(8 & this.peekType())) return;
                ++this.p;
                let e = !1;
                for (; this.p < this.N && (++this.p, this.input[this.p - 1] !== this.input[t] || e);) e ? e = !1 : "\\" === this.input[this.p - 1] && (e = !0);
                return new gt(this.input, t, this.p, this.file)
            }
            readFileName() {
                const t = this.p;
                for (; !(4 & this.peekType()) && "," !== this.peek() && this.p < this.N;) this.p++;
                return new G(this.input, t, this.p, this.file)
            }
            matchWord(t) {
                for (let e = 0; e < t.length; e++)
                    if (t[e] !== this.input[this.p + e]) return !1;
                return !0
            }
            reverseMatchWord(t) {
                for (let e = 0; e < t.length; e++)
                    if (t[t.length - 1 - e] !== this.input[this.p - 1 - e]) return !1;
                return !0
            }
            peekType(t = 0) {
                return F[this.input.charCodeAt(this.p + t)]
            }
            peek(t = 0) {
                return this.input[this.p + t]
            }
            skipBlank() {
                for (; 4 & this.peekType();) ++this.p
            }
        }
        class Pt {
            constructor() {
                this.html = "", this.break = !1, this.continue = !1
            }
            write(t) {
                this.html += t
            }
        }
        class Mt {
            * renderTemplates(t, e, n = new Pt) {
                for (const r of t) try {
                    const t = yield r.render(e, n);
                    if (t && n.write(t), n.break || n.continue) break
                } catch (t) {
                    throw dt.is(t) ? t : new dt(t, r)
                }
                return n.html
            }
        }
        class Tt {
            constructor(t, e) {
                this.handlers = {}, this.stopRequested = !1, this.tokens = t, this.parseToken = e
            }
            on(t, e) {
                return this.handlers[t] = e, this
            }
            trigger(t, e) {
                const n = this.handlers[t];
                return !!n && (n(e), !0)
            }
            start() {
                let t;
                for (this.trigger("start"); !this.stopRequested && (t = this.tokens.shift());) {
                    if (this.trigger("token", t)) continue;
                    if (I(t) && this.trigger("tag:" + t.name, t)) continue;
                    const e = this.parseToken(t, this.tokens);
                    this.trigger("template", e)
                }
                return this.stopRequested || this.trigger("end"), this
            }
            stop() {
                return this.stopRequested = !0, this
            }
        }
        class wt {
            constructor(t) {
                this.token = t
            }
        }

        function Ct(t) {
            return t && u(t.equals)
        }

        function xt(t, e) {
            return !At(t, e)
        }

        function At(t, e) {
            return e.opts.jsTruthy ? !t : !1 === t || null == t
        }
        const qt = {
            "==": (t, e) => Ct(t) ? t.equals(e) : Ct(e) ? e.equals(t) : t === e,
            "!=": (t, e) => Ct(t) ? !t.equals(e) : Ct(e) ? !e.equals(t) : t !== e,
            ">": (t, e) => Ct(t) ? t.gt(e) : Ct(e) ? e.lt(t) : t > e,
            "<": (t, e) => Ct(t) ? t.lt(e) : Ct(e) ? e.gt(t) : t < e,
            ">=": (t, e) => Ct(t) ? t.geq(e) : Ct(e) ? e.leq(t) : t >= e,
            "<=": (t, e) => Ct(t) ? t.leq(e) : Ct(e) ? e.geq(t) : t <= e,
            contains: (t, e) => !(!t || !u(t.indexOf)) && t.indexOf(e) > -1,
            and: (t, e, n) => xt(t, n) && xt(e, n),
            or: (t, e, n) => xt(t, n) || xt(e, n)
        };
        class jt {
            constructor(t) {
                this.operands = [];
                const e = new Dt(t);
                this.postfix = function*(t) {
                    const e = [];
                    for (const n of t)
                        if (j(n)) {
                            for (; e.length && e[e.length - 1].getPrecedence() > n.getPrecedence();) yield e.pop();
                            e.push(n)
                        } else yield n;
                    for (; e.length;) yield e.pop()
                }(e.readExpression())
            }
            evaluate(t) {
                for (const e of this.postfix)
                    if (j(e)) {
                        const n = this.operands.pop(),
                            r = It(e, this.operands.pop(), n, t);
                        this.operands.push(r)
                    } else this.operands.push(Lt(e, t));
                return this.operands[0]
            }* value(t) {
                return c(this.evaluate(t))
            }
        }

        function Lt(t, e) {
            if (_t(e, () => "unable to evaluate: context not defined"), U(t)) {
                const n = t.getVariableAsText(),
                    r = t.props.map(t => Lt(t, e));
                return e.get([n, ...r])
            }
            return K(t) ? function(t, e) {
                const n = Lt(t.lhs, e),
                    r = Lt(t.rhs, e);
                return m(+n, +r + 1)
            }(t, e) : W(t) ? function(t) {
                return J[t.literal]
            }(t) : k(t) ? function(t) {
                const e = t.whole.content + "." + (t.decimal ? t.decimal.content : "");
                return Number(e)
            }(t) : S(t) ? t.getText() : B(t) ? Rt(t) : void 0
        }

        function Rt(t) {
            return at(t.getText())
        }

        function It(t, e, n, r) {
            return (0, qt[t.operator])(e, n, r)
        }
        class Bt {
            constructor(t) {
                this.hash = {};
                const e = new Dt(t);
                for (const t of e.readHashes()) this.hash[t.name.content] = t.value
            }* render(t) {
                const e = {};
                for (const n of Object.keys(this.hash)) e[n] = yield Lt(this.hash[n], t);
                return e
            }
        }

        function Wt(t) {
            const e = {
                then: e => e(t),
                catch: () => e
            };
            return e
        }

        function kt(t) {
            const e = {
                then: (n, r) => r ? r(t) : e,
                catch: e => e(t)
            };
            return e
        }

        function Ut(t) {
            return function(t) {
                return t && u(t.then)
            }(t) ? t : function(t) {
                return t && u(t.next) && u(t.throw) && u(t.return)
            }(t) ? function e(n) {
                let r;
                try {
                    r = t.next(n)
                } catch (t) {
                    return kt(t)
                }
                return r.done ? Wt(r.value) : Ut(r.value).then(e, n => {
                    let r;
                    try {
                        r = t.throw(n)
                    } catch (t) {
                        return kt(t)
                    }
                    return r.done ? Wt(r.value) : e(r.value)
                })
            }() : Wt(t)
        }

        function St(t) {
            return Promise.resolve(Ut(t))
        }

        function Kt(t) {
            let e;
            return Ut(t).then(t => (e = t, Wt(e))).catch(t => {
                throw t
            }), e
        }
        class Nt extends wt {
            constructor(t, e, n) {
                super(t), this.name = t.name;
                const r = n.tags.get(t.name);
                this.impl = Object.create(r), this.impl.liquid = n, this.impl.parse && this.impl.parse(t, e)
            }* render(t, e) {
                const n = yield new Bt(this.token.args).render(t), r = this.impl;
                if (u(r.render)) return yield r.render(t, e, n)
            }
        }
        Nt.impls = {};
        class Ft {
            constructor(t, e, n) {
                this.name = t, this.impl = e || v, this.args = n
            }* render(t, e) {
                const n = [];
                for (const t of this.args) _(t) ? n.push([t[0], yield Lt(t[1], e)]) : n.push(yield Lt(t, e));
                return yield this.impl.apply({
                    context: e
                }, [t, ...n])
            }
        }
        class Ht {
            constructor(t, e) {
                this.filterMap = e, this.filters = [];
                const n = new Dt(t);
                this.initial = n.readValue(), this.filters = n.readFilters().map(({
                    name: t,
                    args: e
                }) => new Ft(t, this.filterMap.get(t), e))
            }* value(t) {
                let e = yield Lt(this.initial, t);
                for (const n of this.filters) e = yield n.render(e, t);
                return e
            }
        }
        class $t extends wt {
            constructor(t, e) {
                super(t), this.value = new Ht(t.content, e)
            }* render(t, e) {
                const n = yield this.value.value(t);
                e.write(l(c(n)))
            }
        }
        class Vt extends wt {
            constructor(t) {
                super(t), this.str = t.getContent()
            }* render(t, e) {
                e.write(this.str)
            }
        }
        class zt {
            constructor(t) {
                this.liquid = t
            }
            parse(t) {
                let e;
                const n = [];
                for (; e = t.shift();) n.push(this.parseToken(e, t));
                return n
            }
            parseToken(t, e) {
                try {
                    return I(t) ? new Nt(t, e, this.liquid) : R(t) ? new $t(t, this.liquid.filters) : new Vt(t)
                } catch (e) {
                    throw new ct(e, t)
                }
            }
            parseStream(t) {
                return new Tt(t, (t, e) => this.parseToken(t, e))
            }
        }
        var Gt = {
            parse: function(t) {
                const e = new Dt(t.args);
                this.key = e.readWord().content, e.skipBlank(), _t("=" === e.peek(), () => "illegal token " + t.getText()), e.advance(), this.value = e.remaining()
            },
            render: function*(t) {
                t.bottom()[this.key] = yield this.liquid._evalValue(this.value, t)
            }
        };

        function Qt(t) {
            return _(t) ? t : s(t) && t.length > 0 ? [t] : g(t) ? Object.keys(t).map(e => [e, t[e]]) : []
        }

        function Xt(t) {
            return _(t) ? t : [t]
        }
        class Yt extends r {
            constructor(t) {
                super(), this.i = 0, this.length = t
            }
            next() {
                this.i++
            }
            index0() {
                return this.i
            }
            index() {
                return this.i + 1
            }
            first() {
                return 0 === this.i
            }
            last() {
                return this.i === this.length - 1
            }
            rindex() {
                return this.length - this.i
            }
            rindex0() {
                return this.length - this.i - 1
            }
            valueOf() {
                return JSON.stringify(this)
            }
        }
        var Jt = {
                type: "block",
                parse: function(t, e) {
                    const n = new Dt(t.args),
                        r = n.readWord(),
                        o = n.readWord(),
                        i = n.readValue();
                    let a;
                    _t(r.size() && "in" === o.content && i, () => "illegal tag: " + t.getText()), this.variable = r.content, this.collection = i, this.hash = new Bt(n.remaining()), this.templates = [], this.elseTemplates = [];
                    const s = this.liquid.parser.parseStream(e).on("start", () => a = this.templates).on("tag:else", () => a = this.elseTemplates).on("tag:endfor", () => s.stop()).on("template", t => a.push(t)).on("end", () => {
                        throw new Error(`tag ${t.getText()} not closed`)
                    });
                    s.start()
                },
                render: function*(t, e) {
                    const n = this.liquid.renderer;
                    let r = Qt(yield Lt(this.collection, t));
                    if (!r.length) return void(yield n.renderTemplates(this.elseTemplates, t, e));
                    const o = yield this.hash.render(t), i = o.offset || 0, a = void 0 === o.limit ? r.length : o.limit;
                    r = r.slice(i, i + a), "reversed" in o && r.reverse();
                    const s = {
                        forloop: new Yt(r.length)
                    };
                    t.push(s);
                    for (const o of r) {
                        if (s[this.variable] = o, yield n.renderTemplates(this.templates, t, e), e.break) {
                            e.break = !1;
                            break
                        }
                        e.continue = !1, s.forloop.next()
                    }
                    t.pop()
                }
            },
            Zt = {
                parse: function(t, e) {
                    const n = new Dt(t.args);
                    this.variable = function(t) {
                        const e = t.readWord().content;
                        if (e) return e;
                        const n = t.readQuoted();
                        if (n) return Rt(n)
                    }(n), _t(this.variable, () => t.args + " not valid identifier"), this.templates = [];
                    const r = this.liquid.parser.parseStream(e);
                    r.on("tag:endcapture", () => r.stop()).on("template", t => this.templates.push(t)).on("end", () => {
                        throw new Error(`tag ${t.getText()} not closed`)
                    }), r.start()
                },
                render: function*(t) {
                    const e = this.liquid.renderer,
                        n = yield e.renderTemplates(this.templates, t);
                    t.bottom()[this.variable] = n
                }
            };
        var te, ee = {
                parse: function(t, e) {
                    this.cond = t.args, this.cases = [], this.elseTemplates = [];
                    let n = [];
                    const r = this.liquid.parser.parseStream(e).on("tag:when", t => {
                        this.cases.push({
                            val: t.args,
                            templates: n = []
                        })
                    }).on("tag:else", () => n = this.elseTemplates).on("tag:endcase", () => r.stop()).on("template", t => n.push(t)).on("end", () => {
                        throw new Error(`tag ${t.getText()} not closed`)
                    });
                    r.start()
                },
                render: function*(t, e) {
                    const n = this.liquid.renderer,
                        r = yield new jt(this.cond).value(t);
                    for (let o = 0; o < this.cases.length; o++) {
                        const i = this.cases[o];
                        if ((yield new jt(i.val).value(t)) === r) return void(yield n.renderTemplates(i.templates, t, e))
                    }
                    yield n.renderTemplates(this.elseTemplates, t, e)
                }
            },
            ne = {
                parse: function(t, e) {
                    const n = this.liquid.parser.parseStream(e);
                    n.on("token", t => {
                        "endcomment" === t.name && n.stop()
                    }).on("end", () => {
                        throw new Error(`tag ${t.getText()} not closed`)
                    }), n.start()
                }
            };
        ! function(t) {
            t[t.OUTPUT = 0] = "OUTPUT", t[t.STORE = 1] = "STORE"
        }(te || (te = {}));
        var re = te,
            oe = {
                parse: function(t) {
                    const e = t.args,
                        n = new Dt(e);
                    this.file = this.liquid.options.dynamicPartials ? n.readValue() : n.readFileName(), _t(this.file, () => `illegal argument "${t.args}"`);
                    const r = n.p;
                    "with" === n.readWord().content ? (n.skipBlank(), ":" !== n.peek() ? this.withVar = n.readValue() : n.p = r) : n.p = r, this.hash = new Bt(n.remaining())
                },
                render: function*(t, e) {
                    const {
                        liquid: n,
                        hash: r,
                        withVar: o,
                        file: i
                    } = this, {
                        renderer: a
                    } = n, s = t.opts.dynamicPartials ? B(i) ? yield a.renderTemplates(n.parse(Rt(i)), t): yield Lt(i, t): i.getText();
                    _t(s, () => `illegal filename "${i.getText()}":"${s}"`);
                    const u = t.saveRegister("blocks", "blockMode");
                    t.setRegister("blocks", {}), t.setRegister("blockMode", re.OUTPUT);
                    const l = yield r.render(t);
                    o && (l[s] = Lt(o, t));
                    const c = yield n._parseFile(s, t.opts, t.sync);
                    t.push(l), yield a.renderTemplates(c, t, e), t.pop(), t.restoreRegister(u)
                }
            },
            ie = {
                parse: function(t) {
                    const e = t.args,
                        n = new Dt(e);
                    for (this.file = this.liquid.options.dynamicPartials ? n.readValue() : n.readFileName(), _t(this.file, () => `illegal argument "${t.args}"`); !n.end();) {
                        n.skipBlank();
                        const t = n.p,
                            e = n.readWord();
                        if (("with" === e.content || "for" === e.content) && (n.skipBlank(), ":" !== n.peek())) {
                            const t = n.readValue();
                            if (t) {
                                const r = n.p;
                                let o;
                                "as" === n.readWord().content ? o = n.readWord() : n.p = r, this[e.content] = {
                                    value: t,
                                    alias: o && o.content
                                }, n.skipBlank(), "," === n.peek() && n.advance();
                                continue
                            }
                        }
                        n.p = t;
                        break
                    }
                    this.hash = new Bt(n.remaining())
                },
                render: function*(t, e) {
                    const {
                        liquid: n,
                        file: r,
                        hash: o
                    } = this, {
                        renderer: i
                    } = n, a = t.opts.dynamicPartials ? B(r) ? yield i.renderTemplates(n.parse(Rt(r)), t): Lt(r, t): r.getText();
                    _t(a, () => `illegal filename "${r.getText()}":"${a}"`);
                    const s = new C({}, t.opts, t.sync),
                        u = yield o.render(t);
                    if (this.with) {
                        const {
                            value: e,
                            alias: n
                        } = this.with;
                        u[n || a] = Lt(e, t)
                    }
                    if (s.push(u), this.for) {
                        const {
                            value: r,
                            alias: o
                        } = this.for;
                        let l = Lt(r, t);
                        l = Qt(l), u.forloop = new Yt(l.length);
                        for (const t of l) {
                            u[o] = t;
                            const r = yield n._parseFile(a, s.opts, s.sync);
                            yield i.renderTemplates(r, s, e), u.forloop.next()
                        }
                    } else {
                        const t = yield n._parseFile(a, s.opts, s.sync);
                        yield i.renderTemplates(t, s, e)
                    }
                }
            },
            ae = {
                parse: function(t) {
                    const e = new Dt(t.args);
                    this.variable = e.readWord().content
                },
                render: function(t, e) {
                    const n = t.environments;
                    d(n[this.variable]) || (n[this.variable] = 0), e.write(l(--n[this.variable]))
                }
            },
            se = {
                parse: function(t) {
                    const e = new Dt(t.args),
                        n = e.readValue();
                    for (e.skipBlank(), this.candidates = [], n && (":" === e.peek() ? (this.group = n, e.advance()) : this.candidates.push(n)); !e.end();) {
                        const t = e.readValue();
                        t && this.candidates.push(t), e.readTo(",")
                    }
                    _t(this.candidates.length, () => "empty candidates: " + t.getText())
                },
                render: function(t, e) {
                    const n = `cycle:${Lt(this.group,t)}:` + this.candidates.join(","),
                        r = t.getRegister("cycle");
                    let o = r[n];
                    void 0 === o && (o = r[n] = 0);
                    const i = this.candidates[o];
                    o = (o + 1) % this.candidates.length, r[n] = o;
                    const a = Lt(i, t);
                    e.write(a)
                }
            },
            ue = {
                parse: function(t, e) {
                    let n;
                    this.branches = [], this.elseTemplates = [];
                    const r = this.liquid.parser.parseStream(e).on("start", () => this.branches.push({
                        cond: t.args,
                        templates: n = []
                    })).on("tag:elsif", t => {
                        this.branches.push({
                            cond: t.args,
                            templates: n = []
                        })
                    }).on("tag:else", () => n = this.elseTemplates).on("tag:endif", () => r.stop()).on("template", t => n.push(t)).on("end", () => {
                        throw new Error(`tag ${t.getText()} not closed`)
                    });
                    r.start()
                },
                render: function*(t, e) {
                    const n = this.liquid.renderer;
                    for (const r of this.branches) {
                        if (xt(yield new jt(r.cond).value(t), t)) return void(yield n.renderTemplates(r.templates, t, e))
                    }
                    yield n.renderTemplates(this.elseTemplates, t, e)
                }
            },
            le = {
                parse: function(t) {
                    const e = new Dt(t.args);
                    this.variable = e.readWord().content
                },
                render: function(t, e) {
                    const n = t.environments;
                    d(n[this.variable]) || (n[this.variable] = 0);
                    const r = n[this.variable];
                    n[this.variable]++, e.write(l(r))
                }
            },
            ce = {
                parse: function(t, e) {
                    const n = new Dt(t.args),
                        r = this.liquid.options.dynamicPartials ? n.readValue() : n.readFileName();
                    _t(r, () => `illegal argument "${t.args}"`), this.file = r, this.hash = new Bt(n.remaining()), this.tpls = this.liquid.parser.parse(e)
                },
                render: function*(t, e) {
                    const {
                        liquid: n,
                        hash: r,
                        file: o
                    } = this, {
                        renderer: i
                    } = n, a = t.opts.dynamicPartials ? B(o) ? yield i.renderTemplates(n.parse(Rt(o)), t): Lt(this.file, t): o.getText();
                    _t(a, () => `illegal filename "${o.getText()}":"${a}"`), t.setRegister("blockMode", re.STORE);
                    const s = t.getRegister("blocks"),
                        u = yield i.renderTemplates(this.tpls, t);
                    void 0 === s[""] && (s[""] = u);
                    const l = yield n._parseFile(a, t.opts, t.sync);
                    t.push(yield r.render(t)), t.setRegister("blockMode", re.OUTPUT);
                    const c = yield i.renderTemplates(l, t);
                    t.pop(), e.write(c)
                }
            },
            de = {
                parse: function(t, e) {
                    const n = /\w+/.exec(t.args);
                    this.block = n ? n[0] : "", this.tpls = [];
                    const r = this.liquid.parser.parseStream(e).on("tag:endblock", () => r.stop()).on("template", t => this.tpls.push(t)).on("end", () => {
                        throw new Error(`tag ${t.getText()} not closed`)
                    });
                    r.start()
                },
                render: function*(t, e) {
                    const n = t.getRegister("blocks"),
                        r = n[this.block],
                        o = this.liquid.renderer,
                        i = void 0 !== r ? r : yield o.renderTemplates(this.tpls, t);
                    t.getRegister("blockMode", re.OUTPUT) !== re.STORE ? e.write(i) : n[this.block] = i
                }
            },
            pe = {
                parse: function(t, e) {
                    this.tokens = [];
                    const n = this.liquid.parser.parseStream(e);
                    n.on("token", t => {
                        "endraw" === t.name ? n.stop() : this.tokens.push(t)
                    }).on("end", () => {
                        throw new Error(`tag ${t.getText()} not closed`)
                    }), n.start()
                },
                render: function() {
                    return this.tokens.map(t => t.getText()).join("")
                }
            };
        class _e extends Yt {
            constructor(t, e) {
                super(t), this.length = t, this.cols = e
            }
            row() {
                return Math.floor(this.i / this.cols) + 1
            }
            col0() {
                return this.i % this.cols
            }
            col() {
                return this.col0() + 1
            }
            col_first() {
                return 0 === this.col0()
            }
            col_last() {
                return this.col() === this.cols
            }
        }
        const fe = {
                assign: Gt,
                for: Jt,
                capture: Zt,
                case: ee,
                comment: ne,
                include: oe,
                render: ie,
                decrement: ae,
                increment: le,
                cycle: se,
                if: ue,
                layout: ce,
                block: de,
                raw: pe,
                tablerow: {
                    parse: function(t, e) {
                        const n = new Dt(t.args);
                        this.variable = n.readWord(), n.skipBlank();
                        const r = n.readWord();
                        let o;
                        _t(r && "in" === r.content, () => "illegal tag: " + t.getText()), this.collection = n.readValue(), this.hash = new Bt(n.remaining()), this.templates = [];
                        const i = this.liquid.parser.parseStream(e).on("start", () => o = this.templates).on("tag:endtablerow", () => i.stop()).on("template", t => o.push(t)).on("end", () => {
                            throw new Error(`tag ${t.getText()} not closed`)
                        });
                        i.start()
                    },
                    render: function*(t, e) {
                        let n = Qt(yield Lt(this.collection, t));
                        const r = yield this.hash.render(t), o = r.offset || 0, i = void 0 === r.limit ? n.length : r.limit;
                        n = n.slice(o, o + i);
                        const a = r.cols || n.length,
                            s = this.liquid.renderer,
                            u = new _e(n.length, a),
                            l = {
                                tablerowloop: u
                            };
                        t.push(l);
                        for (let r = 0; r < n.length; r++, u.next()) l[this.variable.content] = n[r], 0 === u.col0() && (1 !== u.row() && e.write("</tr>"), e.write(`<tr class="row${u.row()}">`)), e.write(`<td class="col${u.col()}">`), yield s.renderTemplates(this.templates, t, e), e.write("</td>");
                        n.length && e.write("</tr>"), t.pop()
                    }
                },
                unless: {
                    parse: function(t, e) {
                        let n;
                        this.templates = [], this.elseTemplates = [];
                        const r = this.liquid.parser.parseStream(e).on("start", () => {
                            n = this.templates, this.cond = t.args
                        }).on("tag:else", () => n = this.elseTemplates).on("tag:endunless", () => r.stop()).on("template", t => n.push(t)).on("end", () => {
                            throw new Error(`tag ${t.getText()} not closed`)
                        });
                        r.start()
                    },
                    render: function*(t, e) {
                        const n = this.liquid.renderer,
                            r = yield new jt(this.cond).value(t);
                        yield At(r, t) ? n.renderTemplates(this.templates, t, e) : n.renderTemplates(this.elseTemplates, t, e)
                    }
                },
                break: {
                    render: function(t, e) {
                        e.break = !0
                    }
                },
                continue: {
                    render: function(t, e) {
                        e.continue = !0
                    }
                }
            },
            he = {
                "&": "&amp;",
                "<": "&lt;",
                ">": "&gt;",
                '"': "&#34;",
                "'": "&#39;"
            },
            ge = {
                "&amp;": "&",
                "&lt;": "<",
                "&gt;": ">",
                "&#34;": '"',
                "&#39;": "'"
            };

        function me(t) {
            return l(t).replace(/&|<|>|"|'/g, t => he[t])
        }
        const ye = Math.abs,
            Ee = Math.max,
            ve = Math.min,
            be = Math.ceil,
            Oe = Math.floor;
        const De = /%([-_0^#:]+)?(\d+)?([EO])?(.)/,
            Pe = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            Me = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            Te = Pe.map(xe),
            we = Me.map(xe),
            Ce = {
                1: "st",
                2: "nd",
                3: "rd",
                default: "th"
            };

        function xe(t) {
            return t.slice(0, 3)
        }

        function Ae(t) {
            return [31, function(t) {
                const e = t.getFullYear();
                return !(0 != (3 & e) || !(e % 100 || e % 400 == 0 && e))
            }(t) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
        }

        function qe(t) {
            let e = 0;
            for (let n = 0; n < t.getMonth(); ++n) e += Ae(t)[n];
            return e + t.getDate()
        }

        function je(t, e) {
            const n = qe(t) + (e - t.getDay()),
                r = 7 - new Date(t.getFullYear(), 0, 1).getDay() + e;
            return String(Math.floor((n - r) / 7) + 1)
        }
        const Le = {
                d: 2,
                e: 2,
                H: 2,
                I: 2,
                j: 3,
                k: 2,
                l: 2,
                L: 3,
                m: 2,
                M: 2,
                S: 2,
                U: 2,
                W: 2
            },
            Re = {
                a: " ",
                A: " ",
                b: " ",
                B: " ",
                c: " ",
                e: " ",
                k: " ",
                l: " ",
                p: " ",
                P: " "
            },
            Ie = {
                a: t => we[t.getDay()],
                A: t => Me[t.getDay()],
                b: t => Te[t.getMonth()],
                B: t => Pe[t.getMonth()],
                c: t => t.toLocaleString(),
                C: t => function(t) {
                    return parseInt(t.getFullYear().toString().substring(0, 2), 10)
                }(t),
                d: t => t.getDate(),
                e: t => t.getDate(),
                H: t => t.getHours(),
                I: t => String(t.getHours() % 12 || 12),
                j: t => qe(t),
                k: t => t.getHours(),
                l: t => String(t.getHours() % 12 || 12),
                L: t => t.getMilliseconds(),
                m: t => t.getMonth() + 1,
                M: t => t.getMinutes(),
                N: (t, e) => {
                    const n = Number(e.width) || 9;
                    return function(t, e, n = " ") {
                        return E(t, e, n, (t, e) => t + e)
                    }(String(t.getMilliseconds()).substr(0, n), n, "0")
                },
                p: t => t.getHours() < 12 ? "AM" : "PM",
                P: t => t.getHours() < 12 ? "am" : "pm",
                q: t => function(t) {
                    const e = t.getDate().toString(),
                        n = parseInt(e.slice(-1));
                    return Ce[n] || Ce.default
                }(t),
                s: t => Math.round(t.valueOf() / 1e3),
                S: t => t.getSeconds(),
                u: t => t.getDay() || 7,
                U: t => je(t, 0),
                w: t => t.getDay(),
                W: t => je(t, 1),
                x: t => t.toLocaleDateString(),
                X: t => t.toLocaleTimeString(),
                y: t => t.getFullYear().toString().substring(2, 4),
                Y: t => t.getFullYear(),
                z: (t, e) => {
                    const n = t.getTimezoneOffset(),
                        r = Math.abs(n),
                        o = r % 60;
                    return (n > 0 ? "-" : "+") + y(Math.floor(r / 60), 2, "0") + (e.flags[":"] ? ":" : "") + y(o, 2, "0")
                },
                t: () => "\t",
                n: () => "\n",
                "%": () => "%"
            };

        function Be(t, e) {
            const [n, r = "", o, i, a] = e, s = Ie[a];
            if (!s) return n;
            const u = {};
            for (const t of r) u[t] = !0;
            let l = String(s(t, {
                    flags: u,
                    width: o,
                    modifier: i
                })),
                c = Re[a] || "0",
                d = o || Le[a] || 0;
            var p;
            return u["^"] ? l = l.toUpperCase() : u["#"] && (p = l, l = [...p].some(t => t >= "a" && t <= "z") ? p.toUpperCase() : p.toLowerCase()), u._ ? c = " " : u[0] && (c = "0"), u["-"] && (d = 0), y(l, d, c)
        }
        Ie.h = Ie.b;
        var We = Object.freeze({
            escape: me,
            escapeOnce: function(t) {
                return me(function(t) {
                    return String(t).replace(/&(amp|lt|gt|#34|#39);/g, t => ge[t])
                }(t))
            },
            newlineToBr: function(t) {
                return t.replace(/\n/g, "<br/>")
            },
            stripHtml: function(t) {
                return t.replace(/<script.*?<\/script>|<!--.*?-->|<style.*?<\/style>|<.*?>/g, "")
            },
            abs: ye,
            atLeast: Ee,
            atMost: ve,
            ceil: be,
            dividedBy: (t, e) => t / e,
            floor: Oe,
            minus: (t, e) => t - e,
            modulo: (t, e) => t % e,
            times: (t, e) => t * e,
            round: function(t, e = 0) {
                const n = Math.pow(10, e);
                return Math.round(t * n) / n
            },
            plus: function(t, e) {
                return Number(t) + Number(e)
            },
            sortNatural: function(t, e) {
                return t && t.sort ? void 0 !== e ? [...t].sort((t, n) => O(t[e], n[e])) : [...t].sort(O) : []
            },
            urlDecode: t => t.split("+").map(decodeURIComponent).join(" "),
            urlEncode: t => t.split(" ").map(encodeURIComponent).join("+"),
            join: (t, e) => t.join(void 0 === e ? " " : e),
            last: t => _(t) ? h(t) : "",
            first: t => _(t) ? t[0] : "",
            reverse: t => [...t].reverse(),
            sort: function(t, e) {
                const n = t => e ? this.context.getFromScope(t, e.split(".")) : t;
                return Xt(t).sort((t, e) => (t = n(t)) < (e = n(e)) ? -1 : t > e ? 1 : 0)
            },
            size: t => t && t.length || 0,
            map: function(t, e) {
                return Xt(t).map(t => this.context.getFromScope(t, e.split(".")))
            },
            concat: function(t, e) {
                return Xt(t).concat(e)
            },
            slice: function(t, e, n = 1) {
                return e = e < 0 ? t.length + e : e, t.slice(e, e + n)
            },
            where: function(t, e, n) {
                return Xt(t).filter(t => {
                    const r = this.context.getFromScope(t, String(e).split("."));
                    return void 0 === n ? xt(r, this.context) : r === n
                })
            },
            uniq: function(t) {
                const e = {};
                return (t || []).filter(t => !e.hasOwnProperty(String(t)) && (e[String(t)] = !0, !0))
            },
            date: function(t, e) {
                let n = t;
                return "now" === t || "today" === t ? n = new Date : d(t) ? n = new Date(1e3 * t) : s(t) && (n = /^\d+$/.test(t) ? new Date(1e3 * +t) : new Date(t)),
                    function(t) {
                        return t instanceof Date && !isNaN(t.getTime())
                    }(n) ? function(t, e) {
                        let n, r = "",
                            o = e;
                        for (; n = De.exec(o);) r += o.slice(0, n.index), o = o.slice(n.index + n[0].length), r += Be(t, n);
                        return r + o
                    }(n, e) : t
            },
            Default: function(t, e) {
                return _(t) || s(t) ? t.length ? t : e : At(c(t), this.context) ? e : t
            },
            json: function(t) {
                return JSON.stringify(t)
            },
            append: function(t, e) {
                return _t(void 0 !== e, () => "append expect 2 arguments"), l(t) + l(e)
            },
            prepend: function(t, e) {
                return _t(void 0 !== e, () => "prepend expect 2 arguments"), l(e) + l(t)
            },
            lstrip: function(t) {
                return l(t).replace(/^\s+/, "")
            },
            downcase: function(t) {
                return l(t).toLowerCase()
            },
            upcase: function(t) {
                return l(t).toUpperCase()
            },
            remove: function(t, e) {
                return l(t).split(e).join("")
            },
            removeFirst: function(t, e) {
                return l(t).replace(e, "")
            },
            rstrip: function(t) {
                return l(t).replace(/\s+$/, "")
            },
            split: function(t, e) {
                return l(t).split(e)
            },
            strip: function(t) {
                return l(t).trim()
            },
            stripNewlines: function(t) {
                return l(t).replace(/\n/g, "")
            },
            capitalize: function(t) {
                return (t = l(t)).charAt(0).toUpperCase() + t.slice(1)
            },
            replace: function(t, e, n) {
                return l(t).split(e).join(n)
            },
            replaceFirst: function(t, e, n) {
                return l(t).replace(e, n)
            },
            truncate: function(t, e = 50, n = "...") {
                return (t = l(t)).length <= e ? t : t.substr(0, e - n.length) + n
            },
            truncatewords: function(t, e = 15, n = "...") {
                const r = t.split(/\s+/);
                let o = r.slice(0, e).join(" ");
                return r.length >= e && (o += n), o
            }
        });
        class ke {
            constructor() {
                this.impls = {}
            }
            get(t) {
                const e = this.impls[t];
                return _t(e, () => `tag "${t}" not found`), e
            }
            set(t, e) {
                this.impls[t] = e
            }
        }
        class Ue {
            constructor(t) {
                this.strictFilters = t, this.impls = {}
            }
            get(t) {
                const e = this.impls[t];
                return _t(e || !this.strictFilters, () => "undefined filter: " + t), e
            }
            set(t, e) {
                this.impls[t] = e
            }
            create(t, e) {
                return new Ft(t, this.get(t), e)
            }
        }
        class Se {
            constructor(t = {}) {
                var e;
                this.options = (e = T(t), Object.assign({}, M, e)), this.parser = new zt(this), this.renderer = new Mt, this.fs = t.fs || A, this.filters = new Ue(this.options.strictFilters), this.tags = new ke, f(fe, (t, e) => this.registerTag(b(e), t)), f(We, (t, e) => this.registerFilter(b(e), t))
            }
            parse(t, e) {
                const n = new Dt(t, e).readTopLevelTokens(this.options);
                return this.parser.parse(n)
            }
            _render(t, e, n, r) {
                const o = Object.assign({}, this.options, T(n)),
                    i = new C(e, o, r);
                return this.renderer.renderTemplates(t, i)
            }
            async render(t, e, n) {
                return St(this._render(t, e, n, !1))
            }
            renderSync(t, e, n) {
                return Kt(this._render(t, e, n, !0))
            }
            _parseAndRender(t, e, n, r) {
                const o = this.parse(t);
                return this._render(o, e, n, r)
            }
            async parseAndRender(t, e, n) {
                return St(this._parseAndRender(t, e, n, !1))
            }
            parseAndRenderSync(t, e, n) {
                return Kt(this._parseAndRender(t, e, n, !0))
            }* _parseFile(t, e, n) {
                const r = Object.assign({}, this.options, T(e)),
                    o = r.root.map(e => this.fs.resolve(e, t, r.extname));
                if (void 0 !== this.fs.fallback) {
                    const e = this.fs.fallback(t);
                    void 0 !== e && o.push(e)
                }
                for (const t of o) {
                    const {
                        cache: e
                    } = r;
                    if (e) {
                        const n = yield e.read(t);
                        if (n) return n
                    }
                    if (!(n ? this.fs.existsSync(t) : yield this.fs.exists(t))) continue;
                    const o = this.parse(n ? this.fs.readFileSync(t) : yield this.fs.readFile(t), t);
                    return e && e.write(t, o), o
                }
                throw this.lookupError(t, r.root)
            }
            async parseFile(t, e) {
                return St(this._parseFile(t, e, !1))
            }
            parseFileSync(t, e) {
                return Kt(this._parseFile(t, e, !0))
            }
            async renderFile(t, e, n) {
                const r = await this.parseFile(t, n);
                return this.render(r, e, n)
            }
            renderFileSync(t, e, n) {
                const r = T(n),
                    o = this.parseFileSync(t, r);
                return this.renderSync(o, e, n)
            }
            _evalValue(t, e) {
                return new Ht(t, this.filters).value(e)
            }
            async evalValue(t, e) {
                return St(this._evalValue(t, e))
            }
            evalValueSync(t, e) {
                return Kt(this._evalValue(t, e))
            }
            registerFilter(t, e) {
                this.filters.set(t, e)
            }
            registerTag(t, e) {
                this.tags.set(t, e)
            }
            plugin(t) {
                return t.call(this, Se)
            }
            express() {
                const t = this;
                return function(e, n, r) {
                    const o = {
                        root: [...w(this.root), ...t.options.root]
                    };
                    t.renderFile(e, n, o).then(t => r(null, t), r)
                }
            }
            lookupError(t, e) {
                const n = new Error("ENOENT");
                return n.message = `ENOENT: Failed to lookup "${t}" in "${e}"`, n.code = "ENOENT", n
            }
            async getTemplate(t, e) {
                return this.parseFile(t, e)
            }
            getTemplateSync(t, e) {
                return this.parseFileSync(t, e)
            }
        }
    },
    94: function(t, e, n) {
        "use strict";
        var r = new(n(30).a),
            o = function(t, e, n, r) {
                function o(t, e) {
                    return void 0 === t ? e : t
                }

                function i(t, e, n, r, i) {
                    if (e = o(e, 2), n = o(n, ","), r = o(r, "."), isNaN(t) || null == t) return 0;
                    var a = (t = (t / 100).toFixed(e)).split(".");
                    return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + n) + (a[1] && (i || parseInt(a[1]) > 0) ? r + a[1] : "")
                }
                "string" == typeof t && (t = t.replace(".", ""));
                var a = "",
                    s = /\{\{\s*(\w+)\s*\}\}/,
                    u = e;
                switch (u.match(s)[1]) {
                    case "amount":
                        a = i(t, 2, ",", ".", r);
                        break;
                    case "amount_no_decimals":
                        a = i(t, 0, ",", ".", r);
                        break;
                    case "amount_with_comma_separator":
                        a = i(t, 2, ".", ",", r);
                        break;
                    case "amount_with_space_separator":
                        a = i(t, 2, " ", ",", r);
                        break;
                    case "amount_with_period_and_space_separator":
                        a = i(t, 2, " ", ".", r);
                        break;
                    case "amount_no_decimals_with_comma_separator":
                        a = i(t, 0, ".", ",", r);
                        break;
                    case "amount_no_decimals_with_space_separator":
                        a = i(t, 0, " ", "", r);
                        break;
                    case "amount_with_space_separator":
                        a = i(t, 2, " ", ",", r);
                        break;
                    case "amount_with_apostrophe_separator":
                        a = i(t, 2, "'", ".", r)
                }
                return n ? u.replace(s, a) : a
            };
        r.registerFilter("money", (function(t) {
            return o(t, window.Globo.moneyFormat, !0, !0)
        })), r.registerFilter("money_without_trailing_zeros", (function(t) {
            return o(t, window.Globo.moneyFormat, !0, !1)
        })), r.registerFilter("money_without_currency", (function(t) {
            return o(t, window.Globo.moneyFormat, !1, !1)
        })), r.registerFilter("asset_url", (function(t) {
            return window.Globo.assetsUrl + t
        })), r.registerFilter("files_url", (function(t) {
            return window.Globo.filesUrl + t
        })), r.registerFilter("img_url", (function(t, e, n) {
            n = n || !1;
            var r = t.split(".").pop(),
                o = t.lastIndexOf(r) - 1;
            return t.slice(0, o) + "_" + e + t.slice(o)
        })), e.a = r
    }
});